import React, { useContext, useEffect, useState, useRef } from "react";
import PatientDetails from "../../../Components/PatientInformation";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import ErrorField from "../../../Components/ErrorField";
import SideBarMenu from "../../../Components/SideBarMenu";
import {
  HTTPResponse,
  PageDesignConstants,
  SideMenuItems,
  ToastMessageType,
  ToastMessages,
} from "../../../Helpers/Enums";
import { CarTCharMsgs, CommonError_Msgs } from "../../../Helpers/HelperText";
import DateControl from "../../../Components/DateControl";
import {
  DateInRange,
  GetLocalStorageData,
  GetLoggedInUserID,
  IsAdmin,
  GetOrdinal,
  isStringEmpty,
  getEarliestCartDate,
  getCohortTreatmentDisplayName,
} from "../../../Helpers/Utilities";
import { AppContext } from "../../../Contexts/AppContextProvider";
import { AdditionalTreatmentService } from "../../../WebApiServices/AdditionalTreatment.service";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import dayjs from "dayjs";

const CarTCharacteristics = () => {
  const pid = GetLocalStorageData("patientId") ?? 0;
  const storedData = GetLocalStorageData("CohortTreatment");

  let cohortTreatmentModelListt = [];
  if (storedData) {
    cohortTreatmentModelListt = JSON.parse(storedData);
  }
  const TTIsPresent = cohortTreatmentModelListt.some(
    (treatment) =>
      (treatment.cohortTreatmentID === 9 ||
        treatment.cohortTreatmentID === 10) &&
      treatment.isEligible === true,
  );
  const ELPresent = cohortTreatmentModelListt.some(
    (treatment) =>
      (treatment.cohortTreatmentID === 11 ||
        treatment.cohortTreatmentID === 12) &&
      treatment.isEligible === true,
  );

  const NDMMIsPresent = cohortTreatmentModelListt.some(
    (treatment) => treatment.ndmm === true && treatment.isEligible === true,
  );

  const navigatePaths = {
    prevPage: ELPresent
      ? "/ELCharacteristics"
      : TTIsPresent
        ? "/TTCharacteristics"
        : NDMMIsPresent
          ? "/NDMMSCTCharacteristics"
          : "/NonCohortDefiningTreatment",
    currPage: "/CarTCharacteristics",
    nextPage: "/IMWGReporting",
  };

  const filteredList = cohortTreatmentModelListt
    .filter(
      (item) =>
        !item.ndmm &&
        item.isEligible &&
        (item.cohortTreatmentID === 13 || item.cohortTreatmentID === 14),
    )
    .sort((a, b) => {
      if (a.cohortTreatmentID === 13) return -1;
      if (b.cohortTreatmentID === 14) return 1;
      return 0;
    });
  const inputRef = useRef(null);
  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);

  const [showClickToAddMore_13, setShowClickToAddMore_13] = useState(false);
  const [showClickToAddMore_14, setShowClickToAddMore_14] = useState(false);

  const [receivedTreatments, setReceivedTreatments] = useState([]);
  const [receivedTmtOtherID, setReceivedTmtOtherID] = useState(null);

  const [reasonCorticosteroidUsage, setreasonCorticosteroidUsage] = useState(
    [],
  );
  const [reasonCorticosteroidOtherID, setreasonCorticosteroidOtherID] =
    useState(null);

  const [
    showTocilizumabClickToAddMore_13,
    setShowTocilizumabClickToAddMore_13,
  ] = useState(false);
  const [
    showTocilizumabClickToAddMore_14,
    setShowTocilizumabClickToAddMore_14,
  ] = useState(false);

  const [showLymphocyteClickToAddMore_13, setShowLymphocyteClickToAddMore_13] =
    useState(false);
  const [showLymphocyteClickToAddMore_14, setShowLymphocyteClickToAddMore_14] =
    useState(false);

  const [showMitigationClickToAddMore_13, setShowMitigationClickToAddMore_13] =
    useState(false);
  const [showMitigationClickToAddMore_14, setShowMitigationClickToAddMore_14] =
    useState(false);

  const [
    showCorticosteroidClickToAddMore_13,
    setShowCorticosteroidClickToAddMore_13,
  ] = useState(false);
  const [
    showCorticosteroidClickToAddMore_14,
    setShowCorticosteroidClickToAddMore_14,
  ] = useState(false);

  const [bispecificDate, setBispecificDate] = useState("");

  const [filteredCiltacabtageneCarTChar, setFilteredCiltacabtageneCarTChar] =
    useState([]);
  const [filteredIdecabtageneCarTChar, setFilteredIdecabtageneCarTChar] =
    useState([]);

  const [filteredBridgingCitacel, setFilteredBridgingCitacel] = useState([]);
  const [filteredBridgingAbecma, setFilteredBridgingAbecma] = useState([]);

  const [
    filteredCiltacabtageneCarTTocilizumabChar,
    setFilteredCiltacabtageneCarTTocilizumabChar,
  ] = useState([]);
  const [
    filteredIdecabtageneCarTTocilizumabChar,
    setFilteredIdecabtageneCarTTocilizumabChar,
  ] = useState([]);

  const [
    filteredCiltacabtageneCarTMitigationChar,
    setFilteredCiltacabtageneCarTMitigationChar,
  ] = useState([]);
  const [
    filteredIdecabtageneCarTMitigationChar,
    setFilteredIdecabtageneCarTTMitigationChar,
  ] = useState([]);

  const [
    filteredCiltacabtageneCarTLymphocyteChar,
    setFilteredCiltacabtageneCarTLymphocyteChar,
  ] = useState([]);
  const [
    filteredIdecabtageneCarTLymphocyteChar,
    setFilteredIdecabtageneCarTLymphocyteChar,
  ] = useState([]);

  const [
    filteredCiltacabtageneCarTCorticosteroidChar,
    setFilteredCiltacabtageneCarTCorticosteroidChar,
  ] = useState([]);
  const [
    filteredIdecabtageneCarTCorticosteroidChar,
    setFilteredIdecabtageneCarTCorticosteroidChar,
  ] = useState([]);

  const [carTCharData, setCarTCharData] = useState({
    CartcharacteristicsId: 0,
    CohortTreatmentId: null,
    q41_Apheresis_Date: "",
    endOfFollowupDate: "",
    carvyktiFollowupDate: "",
    abecmaFollowupDate: "",
    carvyktiNextLotDate: "",
    abecmaNextLotDate: "",
    carvyktiIndexAddThirtyDate: "",
    abecmaIndexAddThirtyDate: "",
    carvyktiIndexMinusThirtyDate: "",
    abecmaIndexMinusThirtyDate: "",
  });

  const [carTCharRepeater, setCarTCharRepeater] = useState({
    //41
    q41_Apheresis_Date: "",
    q41_Apheresis_Date_Empty: false,
    q41_Apheresis_Date_NotValid: false,
    q41_Apheresis_InvalidDate: false,
    q41_Apheresis_DateRd: null,

    //41.1.A
    q411A_Dose: null,
    q411A_Utilization: null,
    q411A_Administration: null,
    q411A_Utilization_Empty: false,
    q411A_Administration_Empty: false,

    // 42
    carTCharacteristicsTypeList: {
      q42_Therapy_Receive: null,
      q42_Therpy_Initiation_Date: "",
      q42_Therpy_Initiation_Radio: null,
      // q42_CohortTreatment_Unk: null,
      q42_Therapy_Initiation_DateInvalid: false,

      q42_Therapy_Receive_Empty: false,

      q42_Therpy_Initiation_Date_Empty: false,
      q42_Therpy_Initiation_Radio_Empty: false,
      carTtherapyName: "",
      carTTherapyId: 0,

      q42_R2_Date_Not_Valid: false,
      q42_CohortTreatment_Unk: null,
      q42_Therapy_Initiation_NotValid: false,
      therapyReceivedEmpty: false,
    },

    //checkbox
    carTCharacteristicsReceivedList: {
      carTTherapyReceivedId: 0,
      carTtherapyReceivedName: "",
      carTtherapyId: 0,
      isChecked: false,
      carTOtherTxt: "",

      isCheckedEmpty: false,
      carTOtherTxtEmpty: false,
    },

    // Q42.1.A
    carTBridgingTherapyList: [
      {
        carTBridgingTherapyId: null,
        treatmentId: 0,
        treatmentName: "",
        q421A_Start_Bridging_Therapy: null,
        q421A_Start_Bridging_Therapy_Date: "",
        q421A_Start_Bridging_Therapy_Empty: false,
        q421A_Start_Bridging_TherapyDate_Empty: false,
        q421A_Start_Bridging_TherapyDate_Invalid: false,
        q421A_End_Bridging_Therapy: null,
        q421A_End_Bridging_Therapy_Date: "",
        q421A_End_Bridging_Therapy_Empty: false,
        q421A_End_Bridging_TherapyDate_Empty: false,
        q421A_End_Bridging_TherapyDate_Invalid: false,
        q421A_BestResponse_Status: null,
        q421A_BestResponse_Status_Empty: false,
        q421A_BestResponse_Assessment: null,
        q421A_BestResponse_Assessment_Date: "",
        q421A_BestResponse_Assessment_Empty: false,
        q421A_BestResponse_AssessmentDate_Empty: false,
        q421A_BestResponse_AssessmentDate_Invalid: false,
        q421A_Method_Assessment: null,
        q421A_Method_Assessment_Empty: false,
        q421A_selectedReceivedTmtList: [],
        q421A_empty_err: false,
        q421A_txt_empty_err: false,
      },
    ],

    // Q43
    carTTreatmentList: [
      {
        carTCharacteristicsProcedureBridgeId: null,
        treatmentId: 0,
        treatmentName: "",
        q43B_No_Procedure_Rcvd: null,
        q43B_Procedure_Date: "",
        q43C_ProcedureType: null,
        q43C_ProcedureType_Txt: "",
        q43B_No_Procedure_RcvdEmpty: false,
        q43B_Procedure_DateEmpty: false,
        q43C_ProcedureTypeEmpty: false,
        q43C_ProcedureType_TxtEmpty: false,
        q43_Procedure_InvalidDate: false,
        q43_Date_Valid: false,
      },
    ],

    // Q43.1.A
    carTTreatmentTocilizumabList: [
      {
        cartcharacteristicstocilizumabid: null,
        treatmentId: 0,
        treatmentName: "",
        q43_1B_No_Tocilizumab_Rcvd: null,
        q43_1B_Tocilizumab_Date: "",
        q43_1C_cytokin: false,
        q43_1C_secondary_prophylactic_crs: false,
        q43_1C_crs: false,
        q43_1C_primary_prophylactic: false,
        q43_1C_secondary_prophylactic: false,
        q43_1C_tmt_neurologic: false,
        q43_1C_reason_other: false,
        q43_1C_reason_unknown: false,

        q43_1B_No_Tocilizumab_RcvdEmpty: false,
        q43_1B_Tocilizumab_DateEmpty: false,
        q43_1C_ReasonEmpty: false,
        q43_1_Tocilizumab_InvalidDate: false,
        q43_1_Date_Valid: false,
      },
    ],

    // Q43.2.A
    carTTreatmentCorticosteroidList: [
      {
        cartcharacteristicscorticosteroidId: null,
        treatmentId: 0,
        treatmentName: "",
        q43_2B_No_Corticosteroid_Rcvd: null,
        q43_2B_Corticosteroid_Date: "",
        q43_2C_CorticosteroidType: null,
        q43_2D_DoseStrength: null,
        q43_2D_DoseStrength_mg: null,
        q43_2D_DoseStrength_kg: null,
        q43_2D_DoseStrength_other: null,

        q43_2E_Reason_otherneurologic_Txt: "",
        q43_2E_reasonCorticosteroid: [],
        q43_2E_selectedReasonCorticosteroid: [],

        q43_2B_No_Corticosteroid_RcvdEmpty: false,
        q43_2B_Corticosteroid_DateEmpty: false,
        q43_2C_CorticosteroidType_Empty: false,
        q43_2D_DoseStrength_Empty: false,
        q43_2D_DoseStrength_TxtEmpty: false,
        q43_2D_DoseStrengthMGRange: false,
        q43_2D_DoseStrengthKGRange: false,
        q43_2_Corticosteroid_InvalidDate: false,
        q43_2_Date_Valid: false,
        q43_2E_ReasonEmpty: false,
        q43_2E_Reason_TxtEmpty: false,
        q43_2E_Reason_NeurologicEmpty: false,
        q43_2E_Reason_AEEmpty: false,
      },
    ],

    // Q43.3.A
    carTTreatmentMitigationList: [
      {
        carTCharacteristicsMitigationId: null,
        treatmentId: 0,
        treatmentName: "",
        q43_3B_NeurologicType: null,
        q43_3B_NeurologicType_Txt: "",
        q43_3C_Mitigation_Txt: "",

        q43_3B_NeurologicTypeEmpty: false,
        q43_3B_NeurologicType_TxtEmpty: false,
        q43_3C_Mitigation_TxtEmpty: false,
      },
    ],
    // Q43.4.A
    carTTreatmentLymphocyteList: [
      {
        carTCharacteristicsLymphocyteId: null,
        treatmentId: 0,
        treatmentName: "",
        q43_4B_No_Assessment_Rcvd: null,
        q43_4B_Assessment_Date: "",
        q43_4C_MeasurementValue: null,
        q43_4C_Measurement_ul: null,
        q43_4C_Measurement_mm: null,
        q43_4C_Measurement_xl: null,
        q43_4B_No_Assessment_RcvdEmpty: false,
        q43_4B_Assessment_DateEmpty: false,
        q43_4C_MeasurementEmpty: false,
        q43_4C_Measurement_TxtEmpty: false,
        q43_4C_Measurement_ulRange: false,
        q43_4C_Measurement_mmRange: false,
        q43_4C_Measurement_xlRange: false,
        q43_4_Assessment_InvalidDate: false,
        q43_4_Date_Valid: false,
      },
    ],
  });

  useEffect(() => {
    const list = Array.isArray(carTCharRepeater) ? carTCharRepeater : [];

    const treatment13 = list.find((item) => item.cohortTreatmentId === 13);
    const treatment14 = list.find((item) => item.cohortTreatmentId === 14);

    const t13List = treatment13?.carTTreatmentList ?? [];
    const t14List = treatment14?.carTTreatmentList ?? [];

    const t13BridgingList = treatment13?.carTBridgingTherapyList ?? [];
    const t14BridgingList = treatment14?.carTBridgingTherapyList ?? [];

    const t13TocilizumabList = treatment13?.carTTreatmentTocilizumabList ?? [];
    const t14TocilizumabList = treatment14?.carTTreatmentTocilizumabList ?? [];

    const t13MitigationList = treatment13?.carTTreatmentMitigationList ?? [];
    const t14MitigationList = treatment14?.carTTreatmentMitigationList ?? [];

    const t13LymphocyteList = treatment13?.carTTreatmentLymphocyteList ?? [];
    const t14LymphocyteList = treatment14?.carTTreatmentLymphocyteList ?? [];

    const t13CorticosteroidList =
      treatment13?.carTTreatmentCorticosteroidList ?? [];
    const t14CorticosteroidList =
      treatment14?.carTTreatmentCorticosteroidList ?? [];
    // Enforce truncation rule for each parent row
    const truncatedList = list.map((row) => {
      const stopIndex = row.carTTreatmentList.findIndex(
        (child) => child.q43B_No_Procedure_Rcvd === 1,
      );

      if (stopIndex !== -1) {
        return {
          ...row,
          carTTreatmentList: row.carTTreatmentList.slice(0, stopIndex + 1),
        };
      }
      return row;
    });

    // Enforce truncation rule for each parent row
    const truncatedTocilizumabList = list.map((row) => {
      const stopIndex = row.carTTreatmentTocilizumabList.findIndex(
        (child) => child.q43_1B_No_Tocilizumab_Rcvd === 1,
      );

      if (stopIndex !== -1) {
        return {
          ...row,
          carTTreatmentTocilizumabList: row.carTTreatmentTocilizumabList.slice(
            0,
            stopIndex + 1,
          ),
        };
      }
      return row;
    });

    // Enforce truncation rule for each parent row
    const truncatedLymphocyteList = list.map((row) => {
      const stopIndex = row.carTTreatmentLymphocyteList.findIndex(
        (child, index, arr) =>
          child.q43_4B_No_Assessment_Rcvd === 2 && index === arr.length - 1,
      );

      if (stopIndex !== -1) {
        return {
          ...row,
          carTTreatmentLymphocyteList: row.carTTreatmentLymphocyteList.slice(
            0,
            stopIndex + 1,
          ),
        };
      }
      return row;
    });

    const truncatedCorticosteroidList = list.map((row) => {
      const stopIndex = row.carTTreatmentCorticosteroidList.findIndex(
        (child) => child.q43_2B_No_Corticosteroid_Rcvd === 1,
      );

      if (stopIndex !== -1) {
        return {
          ...row,
          carTTreatmentCorticosteroidList:
            row.carTTreatmentCorticosteroidList.slice(0, stopIndex + 1),
        };
      }
      return row;
    });
    const test = list.find((item) => item.cohortTreatmentId === 13);

    setFilteredBridgingCitacel(t13BridgingList);
    setFilteredBridgingAbecma(t14BridgingList);

    setFilteredCiltacabtageneCarTChar(t13List);
    setFilteredIdecabtageneCarTChar(t14List);
    setFilteredCiltacabtageneCarTTocilizumabChar(t13TocilizumabList);
    setFilteredIdecabtageneCarTTocilizumabChar(t14TocilizumabList);
    setFilteredCiltacabtageneCarTMitigationChar(t13MitigationList);
    setFilteredIdecabtageneCarTTMitigationChar(t14MitigationList);
    setFilteredCiltacabtageneCarTLymphocyteChar(t13LymphocyteList);
    setFilteredIdecabtageneCarTLymphocyteChar(t14LymphocyteList);
    setFilteredCiltacabtageneCarTCorticosteroidChar(t13CorticosteroidList);
    setFilteredIdecabtageneCarTCorticosteroidChar(t14CorticosteroidList);
    //  Check if any row of treatmentId=13 has q43B_No_Procedure_Rcvd === 1
    const hasNoProcedureRow13 = t13List.some(
      (row) => row.q43B_No_Procedure_Rcvd === 1,
    );
    setShowClickToAddMore_13(!hasNoProcedureRow13);

    //  Check if any row of treatmentId=14 has q43B_No_Procedure_Rcvd === 1
    const hasNoProcedureRow14 = t14List.some(
      (row) => row.q43B_No_Procedure_Rcvd === 1,
    );
    setShowClickToAddMore_14(!hasNoProcedureRow14);

    //  Check if any row of treatmentId=13 has q43_1_B_No_Tocilizumab_Rcvd === 1
    const hasNoTocilizumabRow13 = t13TocilizumabList.some(
      (row) => row.q43_1B_No_Tocilizumab_Rcvd === 1,
    );
    setShowTocilizumabClickToAddMore_13(!hasNoTocilizumabRow13);

    //  Check if any row of treatmentId=14 has q43_1_B_No_Tocilizumab_Rcvd === 1
    const hasNoTocilizumabRow14 = t14TocilizumabList.some(
      (row) => row.q43_1B_No_Tocilizumab_Rcvd === 1,
    );
    setShowTocilizumabClickToAddMore_14(!hasNoTocilizumabRow14);

    setShowMitigationClickToAddMore_13(true);
    setShowMitigationClickToAddMore_14(true);

    //  Check if any row of treatmentId=13 has q43_4B_No_Assessment_Rcvd === 1
    const hasNoLymphocyteRow13 = t13LymphocyteList.some(
      (row) => row.q43_4B_No_Assessment_Rcvd === 2,
    );
    setShowLymphocyteClickToAddMore_13(!hasNoLymphocyteRow13);

    //  Check if any row of treatmentId=14 has q43_4B_No_Assessment_Rcvd === 1
    const hasNoLymphocyteRow14 = t14LymphocyteList.some(
      (row) => row.q43_4B_No_Assessment_Rcvd === 2,
    );
    setShowLymphocyteClickToAddMore_14(!hasNoLymphocyteRow14);

    // Check if any row of treatmentId=13 has q43_2B_No_Corticosteroid_Rcvd === 1
    const hasNoCorticosteroidRow13 = t13CorticosteroidList.some(
      (row) => row.q43_2B_No_Corticosteroid_Rcvd === 1,
    );
    setShowCorticosteroidClickToAddMore_13(!hasNoCorticosteroidRow13);

    //  Check if any row of treatmentId=14 has q43_2B_No_Corticosteroid_Rcvd === 1
    const hasNoCorticosteroidRow14 = t14CorticosteroidList.some(
      (row) => row.q43_2B_No_Corticosteroid_Rcvd === 1,
    );
    setShowCorticosteroidClickToAddMore_14(!hasNoCorticosteroidRow14);

    // If truncation actually changed something, update the main state
    const listsToCheck = [
      truncatedList,
      truncatedTocilizumabList,
      truncatedLymphocyteList,
      truncatedCorticosteroidList,
    ];

    const selectedList = listsToCheck.find(
      (l) => JSON.stringify(l) !== JSON.stringify(list),
    );

    if (selectedList) {
      setCarTCharRepeater(selectedList);
    }
  }, [carTCharRepeater]);

  const HandleRepeaterFieldChange = (e) => {
    const { name, id, value, checked } = e.target;
    const value_int = Number(value);

    // Extract loopIndex and innerLoopIndex from the id
    const parts = id.split("_");
    const loopIndex = Number(parts[0]);
    const innerLoopIndex = Number(parts[1]);
    const carTTherapyId = Number(parts[2]);

    // Create a copy of the current state
    let updatedArray = [...carTCharRepeater];

    switch (name) {
      //q41_Apheresis_DateRd

      case "q41_Apheresis_DateRd" + id: {
        let updatedArray = [...carTCharRepeater];
        updatedArray[id].q41_Apheresis_DateRd = Number(value);
        updatedArray[id].q41_Apheresis_Date =
          Number(value) == 99 ? "" : updatedArray[id].q41_Apheresis_Date;
        updatedArray[id].q41_Apheresis_Date_Empty = false;
        setCarTCharRepeater(updatedArray);
        break;
      }

      case "q411A_Utilization" + id: {
        let updatedArray = [...carTCharRepeater];
        updatedArray[id].q411A_Utilization = Number(value);
        updatedArray[id].q411A_Utilization_Empty = false;
        setCarTCharRepeater(updatedArray);
        break;
      }

      case "q411A_Administration" + id: {
        let updatedArray = [...carTCharRepeater];
        updatedArray[id].q411A_Administration = Number(value);
        updatedArray[id].q411A_Administration_Empty = false;
        setCarTCharRepeater(updatedArray);
        break;
      }

      case `q42_Therapy_Receive${loopIndex}${innerLoopIndex}`: {
        // Create a deep copy of the inner object to avoid direct mutation
        const updatedTypeList = [
          ...updatedArray[loopIndex].carTCharacteristicsTypeList,
        ];

        // Update only the specific item in the list
        updatedTypeList[innerLoopIndex] = {
          ...updatedTypeList[innerLoopIndex],
          q42_Therapy_Receive: value_int,
          q42_Therpy_Initiation_Date: "",
          q42_Therpy_Initiation_Radio: null,
          q42_Therapy_Initiation_DateInvalid: false,
          q42_Therapy_Initiation_NotValid: false,
          q42_R2_Date_Not_Valid: false,
          q42_Therpy_Initiation_Date_Empty: false,
          q42_Therpy_Initiation_Radio_Empty: false,
          q42_Therapy_Receive_Empty: false,
          therapyReceivedEmpty: false,
        };

        // Only uncheck checkboxes for the current treatment
        const updatedReceivedList = updatedArray[
          loopIndex
        ].carTCharacteristicsReceivedList.map((item) =>
          item.carTtherapyId === innerLoopIndex + 1
            ? {
                ...item,
                isChecked: false,
                isCheckedEmpty: false,
                carTOtherTxtEmpty: false,
                carTOtherTxt: "",
              }
            : item,
        );

        updatedArray[loopIndex] = {
          ...updatedArray[loopIndex],
          carTCharacteristicsTypeList: updatedTypeList,
          carTCharacteristicsReceivedList: updatedReceivedList,
        };

        setCarTCharRepeater(updatedArray);
        break;
      }

      case `q42_Therpy_Initiation_Radio${loopIndex}${innerLoopIndex}`: {
        // Create a deep copy of the inner object to avoid direct mutation
        const updatedTypeList = [
          ...updatedArray[loopIndex].carTCharacteristicsTypeList,
        ];
        updatedTypeList[innerLoopIndex] = {
          ...updatedTypeList[innerLoopIndex],
          q42_Therpy_Initiation_Date: "",
          q42_Therpy_Initiation_Radio: value_int,
          q42_Therpy_Initiation_Radio_Empty: false,
          q42_Therapy_Initiation_DateInvalid: false,

          q42_R2_Date_Not_Valid: false,
          q42_Therpy_Initiation_Date_Empty: false,

          q42_Therapy_Initiation_NotValid: false,
          // carTOtherTxtEmpty: false,
          //therapyReceivedEmpty: false,
        };
        updatedArray[loopIndex] = {
          ...updatedArray[loopIndex],
          carTCharacteristicsTypeList: updatedTypeList,
        };
        setCarTCharRepeater(updatedArray);
        break;
      }

      case `q42_CohortTreatment_Unk${loopIndex}${innerLoopIndex}`: {
        // Create a deep copy of the inner object to avoid direct mutation
        const updatedTypeList = [
          ...updatedArray[loopIndex].carTCharacteristicsTypeList,
        ];
        updatedTypeList[innerLoopIndex] = {
          ...updatedTypeList[innerLoopIndex],
          q42_CohortTreatment_Unk: value_int,
          therapyReceivedEmpty: false,
        };

        // Uncheck all checkboxes and clear text inputs
        const updatedReceivedList =
          updatedArray[loopIndex].carTCharacteristicsReceivedList;

        const updatedList = updatedReceivedList.map((item) => {
          if (
            item.carTtherapyId === updatedTypeList[innerLoopIndex].carTTherapyId
          ) {
            return {
              ...item,
              isChecked: false,
              carTOtherTxt: "",
              carTOtherTxtEmpty: false,
            };
          }
          return item;
        });

        updatedArray[loopIndex] = {
          ...updatedArray[loopIndex],
          carTCharacteristicsTypeList: updatedTypeList,
          carTCharacteristicsReceivedList: updatedList,
        };

        setCarTCharRepeater(updatedArray);
        break;
      }

      case `q43B_No_Procedure_Rcvd_13_${loopIndex}`: {
        if (value_int === 1) setShowClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43B_No_Procedure_Rcvd: value_int,
                        q43B_No_Procedure_RcvdEmpty: false,
                        q43_Date_Valid: false,
                        q43B_Procedure_DateEmpty: false,
                        q43B_Procedure_Date: "",
                        q43C_ProcedureType:
                          value_int === 1 ? null : child.q43C_ProcedureType,
                        q43C_ProcedureType_Empty:
                          value_int === 1
                            ? false
                            : child.q43C_ProcedureType_Empty,
                        q43C_ProcedureType_Txt:
                          value_int === 1 ? "" : child.q43C_ProcedureType_Txt,
                        q43C_ProcedureType_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43C_ProcedureType_TxtEmpty,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43C_ProcedureType_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43C_ProcedureType: value_int,
                        q43C_ProcedureTypeEmpty: false,
                        q43C_ProcedureType_Txt: "",
                        q43C_ProcedureType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43C_ProcedureType_Txt_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43C_ProcedureType_Txt: value,
                        q43C_ProcedureType: 7, // since text implies "Other"
                        q43C_ProcedureTypeEmpty: false,
                        q43C_ProcedureType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43B_No_Procedure_Rcvd_14_${loopIndex}`: {
        if (value_int === 1) setShowClickToAddMore_14(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43B_No_Procedure_Rcvd: value_int,
                        q43B_No_Procedure_RcvdEmpty: false,
                        q43_Date_Valid: false,
                        q43B_Procedure_DateEmpty: false,
                        q43B_Procedure_Date: "",
                        q43C_ProcedureType:
                          value_int === 1 ? null : child.q43C_ProcedureType,
                        q43C_ProcedureType_Empty:
                          value_int === 1
                            ? false
                            : child.q43C_ProcedureType_Empty,
                        q43C_ProcedureType_Txt:
                          value_int === 1 ? "" : child.q43C_ProcedureType_Txt,
                        q43C_ProcedureType_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43C_ProcedureType_TxtEmpty,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43C_ProcedureType_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43C_ProcedureType: value_int,
                        q43C_ProcedureTypeEmpty: false,
                        q43C_ProcedureType_Txt: "",
                        q43C_ProcedureType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43C_ProcedureType_Txt_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43C_ProcedureType_Txt: value,
                        q43C_ProcedureType: 7, // since text implies "Other"
                        q43C_ProcedureTypeEmpty: false,
                        q43C_ProcedureType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_1B_No_Tocilizumab_Rcvd_13_${loopIndex}`: {
        if (value_int === 1) setShowTocilizumabClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1B_No_Tocilizumab_Rcvd: value_int,
                        q43_1B_No_Tocilizumab_RcvdEmpty: false,
                        q43_1_Date_Valid: false,
                        q43_1B_Tocilizumab_DateEmpty: false,
                        q43_1B_Tocilizumab_Date: "",
                        q43_1C_cytokin:
                          value_int === 1 ? null : child.q43_1C_cytokin,
                        q43_1C_secondary_prophylactic_crs:
                          value_int === 1
                            ? null
                            : child.q43_1C_secondary_prophylactic_crs,
                        q43_1C_crs: value_int === 1 ? null : child.q43_1C_crs,
                        q43_1C_primary_prophylactic:
                          value_int === 1
                            ? null
                            : child.q43_1C_primary_prophylactic,
                        q43_1C_secondary_prophylactic:
                          value_int === 1
                            ? null
                            : child.q43_1C_secondary_prophylactic,
                        q43_1C_tmt_neurologic:
                          value_int === 1 ? null : child.q43_1C_tmt_neurologic,
                        q43_1C_reason_other:
                          value_int === 1 ? null : child.q43_1C_reason_other,
                        q43_1C_reason_unknown:
                          value_int === 1 ? null : child.q43_1C_reason_unknown,
                        q43_1C_ReasonEmpty:
                          value_int === 1 ? false : child.q43_1C_ReasonEmpty,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43_1C_cytokin_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_cytokin: !child.q43_1C_cytokin,
                        q43_1C_reason_unknown: false,
                        q43_1C_ReasonEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_secondary_prophylactic_crs_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_secondary_prophylactic_crs:
                          !child.q43_1C_secondary_prophylactic_crs,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_crs_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_crs: !child.q43_1C_crs,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_primary_prophylactic_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_primary_prophylactic:
                          !child.q43_1C_primary_prophylactic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_secondary_prophylactic_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_secondary_prophylactic:
                          !child.q43_1C_secondary_prophylactic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_tmt_neurologic_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_tmt_neurologic: !child.q43_1C_tmt_neurologic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_reason_other_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_reason_other: !child.q43_1C_reason_other,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_reason_unknown_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_reason_unknown: !child.q43_1C_reason_unknown,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_other: false,
                        q43_1C_cytokin: false,
                        q43_1C_secondary_prophylactic_crs: false,
                        q43_1C_crs: false,
                        q43_1C_primary_prophylactic: false,
                        q43_1C_secondary_prophylactic: false,
                        q43_1C_tmt_neurologic: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_1B_No_Tocilizumab_Rcvd_14_${loopIndex}`: {
        if (value_int === 1) setShowTocilizumabClickToAddMore_14(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1B_No_Tocilizumab_Rcvd: value_int,
                        q43_1B_No_Tocilizumab_RcvdEmpty: false,
                        q43_1_Date_Valid: false,
                        q43_1B_Tocilizumab_DateEmpty: false,
                        q43_1B_Tocilizumab_Date: "",
                        q43_1C_cytokin:
                          value_int === 1 ? null : child.q43_1C_cytokin,
                        q43_1C_secondary_prophylactic_crs:
                          value_int === 1
                            ? null
                            : child.q43_1C_secondary_prophylactic_crs,
                        q43_1C_crs: value_int === 1 ? null : child.q43_1C_crs,
                        q43_1C_primary_prophylactic:
                          value_int === 1
                            ? null
                            : child.q43_1C_primary_prophylactic,
                        q43_1C_secondary_prophylactic:
                          value_int === 1
                            ? null
                            : child.q43_1C_secondary_prophylactic,
                        q43_1C_tmt_neurologic:
                          value_int === 1 ? null : child.q43_1C_tmt_neurologic,
                        q43_1C_reason_other:
                          value_int === 1 ? null : child.q43_1C_reason_other,
                        q43_1C_reason_unknown:
                          value_int === 1 ? null : child.q43_1C_reason_unknown,
                        q43_1C_ReasonEmpty:
                          value_int === 1 ? false : child.q43_1C_ReasonEmpty,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43_1C_cytokin_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_cytokin: !child.q43_1C_cytokin,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_secondary_prophylactic_crs_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_secondary_prophylactic_crs:
                          !child.q43_1C_secondary_prophylactic_crs,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_crs_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_crs: !child.q43_1C_crs,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_primary_prophylactic_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_primary_prophylactic:
                          !child.q43_1C_primary_prophylactic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_secondary_prophylactic_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_secondary_prophylactic:
                          !child.q43_1C_secondary_prophylactic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_tmt_neurologic_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_tmt_neurologic: !child.q43_1C_tmt_neurologic,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_reason_other_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_reason_other: !child.q43_1C_reason_other,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_unknown: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_1C_reason_unknown_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_1C_reason_unknown: !child.q43_1C_reason_unknown,
                        q43_1C_ReasonEmpty: false,
                        q43_1C_reason_other: false,
                        q43_1C_cytokin: false,
                        q43_1C_secondary_prophylactic_crs: false,
                        q43_1C_crs: false,
                        q43_1C_primary_prophylactic: false,
                        q43_1C_secondary_prophylactic: false,
                        q43_1C_tmt_neurologic: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3B_NeurologicType_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3B_NeurologicType: value_int,
                        q43_3B_NeurologicTypeEmpty: false,
                        q43_3B_NeurologicType_Txt: "",
                        q43_3B_NeurologicType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3B_NeurologicType_Txt_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3B_NeurologicType_Txt: value,
                        q43_3B_NeurologicType: 8, // since text implies "Other"
                        q43_3B_NeurologicTypeEmpty: false,
                        q43_3B_NeurologicType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3C_Mitigation_Txt_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3C_Mitigation_Txt: value,
                        q43_3C_Mitigation_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3B_NeurologicType_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3B_NeurologicType: value_int,
                        q43_3B_NeurologicTypeEmpty: false,
                        q43_3B_NeurologicType_Txt: "",
                        q43_3B_NeurologicType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3B_NeurologicType_Txt_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3B_NeurologicType_Txt: value,
                        q43_3B_NeurologicType: 8, // since text implies "Other"
                        q43_3B_NeurologicTypeEmpty: false,
                        q43_3B_NeurologicType_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_3C_Mitigation_Txt_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentMitigationList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_3C_Mitigation_Txt: value,
                        q43_3C_Mitigation_TxtEmpty: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentMitigationList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_4B_No_Assessment_Rcvd_13_${loopIndex}`: {
        if (value_int === 2) setShowLymphocyteClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4B_No_Assessment_Rcvd: value_int,
                        q43_4B_No_Assessment_RcvdEmpty: false,
                        q43_4_Date_Valid: false,
                        q43_4B_Assessment_DateEmpty: false,
                        q43_4B_Assessment_Date: "",
                        q43_4C_MeasurementValue:
                          value_int === 2
                            ? null
                            : child.q43_4C_MeasurementValue,
                        q43_4C_MeasurementEmpty:
                          value_int === 2
                            ? false
                            : child.q43_4C_MeasurementEmpty,
                        q43_4C_Measurement_TxtEmpty:
                          value_int === 2
                            ? false
                            : child.q43_4C_Measurement_TxtEmpty,
                        q43_4C_Measurement_ulRange:
                          value_int == 2
                            ? false
                            : child.q43_4C_Measurement_ulRange,
                        q43_4C_Measurement_mmRange:
                          value_int == 2
                            ? false
                            : child.q43_4C_Measurement_mmRange,
                        q43_4C_Measurement_xlRange:
                          value_int == 2
                            ? false
                            : child.q43_4C_Measurement_xlRange,
                        q43_4C_Measurement_ul:
                          value_int === 2 ? null : child.q43_4C_Measurement_ul,
                        q43_4C_Measurement_mm:
                          value_int === 2 ? null : child.q43_4C_Measurement_mm,
                        q43_4C_Measurement_xl:
                          value_int === 2 ? null : child.q43_4C_Measurement_xl,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43_4C_MeasurementValue_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_MeasurementValue: value_int,
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_ul:
                          value_int == 99 || value_int == 2 || value_int == 3
                            ? ""
                            : child.q43_4C_Measurement_ul,
                        q43_4C_Measurement_mm:
                          value_int == 99 || value_int == 1 || value_int == 3
                            ? ""
                            : child.q43_4C_Measurement_mm,
                        q43_4C_Measurement_xl:
                          value_int == 99 || value_int == 2 || value_int == 1
                            ? ""
                            : child.q43_4C_Measurement_xl,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_4C_Measurement_ul_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_ul: value,
                        q43_4C_MeasurementValue: 1, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mm: "",
                        q43_4C_Measurement_xl: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_4C_Measurement_mm_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_mm: value,
                        q43_4C_MeasurementValue: 2, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_ul: "",
                        q43_4C_Measurement_xl: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_4C_Measurement_xl_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_xl: value,
                        q43_4C_MeasurementValue: 3, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mm: "",
                        q43_4C_Measurement_ul: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_4B_No_Assessment_Rcvd_14_${loopIndex}`: {
        if (value_int === 2) setShowLymphocyteClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4B_No_Assessment_Rcvd: value_int,
                        q43_4B_No_Assessment_RcvdEmpty: false,
                        q43_4_Date_Valid: false,
                        q43_4B_Assessment_DateEmpty: false,
                        q43_4B_Assessment_Date: "",
                        q43_4C_MeasurementValue:
                          value_int === 2
                            ? null
                            : child.q43_4C_MeasurementValue,
                        q43_4C_MeasurementEmpty:
                          value_int === 2
                            ? false
                            : child.q43_4C_MeasurementEmpty,

                        q43_4C_Measurement_TxtEmpty:
                          value_int === 2
                            ? false
                            : child.q43_4C_Measurement_TxtEmpty,
                        q43_4C_Measurement_mmRange:
                          value_int === 2
                            ? false
                            : child.q43_4C_Measurement_mmRange,
                        q43_4C_Measurement_xlRange:
                          value_int === 2
                            ? false
                            : child.q43_4C_Measurement_xlRange,
                        q43_4C_Measurement_ulRange:
                          value_int === 2
                            ? false
                            : child.q43_4C_Measurement_ulRange,
                        q43_4C_Measurement_ul:
                          value_int === 2 ? null : child.q43_4C_Measurement_ul,
                        q43_4C_Measurement_mm:
                          value_int === 2 ? null : child.q43_4C_Measurement_mm,
                        q43_4C_Measurement_xl:
                          value_int === 2 ? null : child.q43_4C_Measurement_xl,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q43_4C_MeasurementValue_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_MeasurementValue: value_int,
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ul:
                          value_int == 99 || value_int == 2 || value_int == 3
                            ? ""
                            : child.q43_4C_Measurement_ul,
                        q43_4C_Measurement_mm:
                          value_int == 99 || value_int == 1 || value_int == 3
                            ? ""
                            : child.q43_4C_Measurement_mm,
                        q43_4C_Measurement_xl:
                          value_int == 99 || value_int == 2 || value_int == 2
                            ? ""
                            : child.q43_4C_Measurement_xl,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_4C_Measurement_ul_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_ul: value,
                        q43_4C_MeasurementValue: 1, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_mm: "",
                        q43_4C_Measurement_xl: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_4C_Measurement_mm_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_mm: value,
                        q43_4C_MeasurementValue: 2, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_ul: "",
                        q43_4C_Measurement_xl: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_4C_Measurement_xl_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_4C_Measurement_xl: value,
                        q43_4C_MeasurementValue: 3, // since text implies "Other"
                        q43_4C_MeasurementEmpty: false,
                        q43_4C_Measurement_TxtEmpty: false,
                        q43_4C_Measurement_ulRange: false,
                        q43_4C_Measurement_mmRange: false,
                        q43_4C_Measurement_xlRange: false,
                        q43_4C_Measurement_mm: "",
                        q43_4C_Measurement_ul: "",
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_2B_No_Corticosteroid_Rcvd_13_${loopIndex}`: {
        if (value_int === 1) setShowCorticosteroidClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2B_No_Corticosteroid_Rcvd: value_int,
                        q43_2B_No_Corticosteroid_RcvdEmpty: false,
                        q43_2_Date_Valid: false,
                        q43_2B_Corticosteroid_DateEmpty: false,
                        q43_2B_Corticosteroid_Date: "",
                        q43_2C_CorticosteroidType:
                          value_int === 1
                            ? null
                            : child.q43_2C_CorticosteroidType,
                        q43_2C_CorticosteroidType_Empty:
                          value_int === 1
                            ? false
                            : child.q43_2C_CorticosteroidType_Empty,

                        q43_2D_DoseStrength:
                          value_int === 1 ? null : child.q43_2D_DoseStrength,
                        q43_2D_DoseStrength_Empty:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrength_Empty,
                        q43_2D_DoseStrengthMGRange:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrengthMGRange,
                        q43_2D_DoseStrengthKGRange:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrengthKGRange,
                        q43_2D_DoseStrength_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrength_TxtEmpty,
                        q43_2D_DoseStrength_kg:
                          value_int === 1 ? null : child.q43_2D_DoseStrength_kg,
                        q43_2D_DoseStrength_mg:
                          value_int === 1 ? null : child.q43_2D_DoseStrength_mg,
                        q43_2D_DoseStrength_other:
                          value_int === 1
                            ? null
                            : child.q43_2D_DoseStrength_other,

                        q43_2E_selectedReasonCorticosteroid:
                          value_int === 1
                            ? []
                            : child.q43_2E_selectedReasonCorticosteroid,
                        q43_2E_reasonCorticosteroid:
                          value_int === 1
                            ? []
                            : child.q43_2E_reasonCorticosteroid,
                        q43_2E_ReasonEmpty:
                          value_int === 1 ? false : child.q43_2E_ReasonEmpty,
                        q43_2E_Reason_AEEmpty:
                          value_int === 1 ? false : child.q43_2E_Reason_AEEmpty,
                        q43_2E_Reason_NeurologicEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2E_Reason_NeurologicEmpty,
                        q43_2E_Reason_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2E_Reason_TxtEmpty,
                        q43_2E_Reason_otherneurologic_Txt:
                          value_int === 1
                            ? ""
                            : child.q43_2E_Reason_otherneurologic_Txt,
                        q43_2E_reasonCorticosteroid:
                          value_int == 1
                            ? reasonCorticosteroidUsage.filter(
                                (i) => i.corticosteroid === true,
                              )
                            : child.q43_2E_reasonCorticosteroid,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row; // keep other rows unchanged
          }),
        );

        break;
      }
      case `q43_2C_CorticosteroidType_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2C_CorticosteroidType: value_int,
                        q43_2C_CorticosteroidType_Empty: false,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_2D_DoseStrength_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength: value_int,
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_mg:
                          value_int == 99 || value_int == 2 || value_int == 3
                            ? ""
                            : child.q43_2D_DoseStrength_mg,
                        q43_2D_DoseStrength_kg:
                          value_int == 99 || value_int == 1 || value_int == 3
                            ? ""
                            : child.q43_2D_DoseStrength_kg,
                        q43_2D_DoseStrength_other:
                          value_int == 99 || value_int == 2 || value_int == 1
                            ? ""
                            : child.q43_2D_DoseStrength_other,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_2D_DoseStrength_mg_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength_mg: value,
                        q43_2D_DoseStrength: 1, // since text implies "Other"
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_kg: "",
                        q43_2D_DoseStrength_other: "",
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_2D_DoseStrength_kg_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength_kg: value,
                        q43_2D_DoseStrength: 2, // since text implies "Other"
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrength_mg: "",
                        q43_2D_DoseStrength_other: "",
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_2D_DoseStrength_other_13_${loopIndex}`:
        {
          setCarTCharRepeater((prev) =>
            prev.map((row) => {
              if (row.cohortTreatmentId === 13) {
                const updatedChildList =
                  row.carTTreatmentCorticosteroidList.map((child, idx) =>
                    idx === loopIndex
                      ? {
                          ...child,
                          q43_2D_DoseStrength_other: value,
                          q43_2D_DoseStrength: 3, // since text implies "Other"
                          q43_2D_DoseStrength_Empty: false,
                          q43_2D_DoseStrength_TxtEmpty: false,
                          q43_2D_DoseStrengthMGRange: false,
                          q43_2D_DoseStrengthKGRange: false,
                          q43_2D_DoseStrength_kg: "",
                          q43_2D_DoseStrength_mg: "",
                        }
                      : child,
                  );

                return {
                  ...row,
                  carTTreatmentCorticosteroidList: updatedChildList,
                };
              }
              return row;
            }),
          );
          break;
        }

        break;
      case `q43_2E_reasonCorticosteroid_13_${loopIndex}_${innerLoopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId !== 13) return row;

            const index = loopIndex;
            const reasonID = Number(innerLoopIndex);

            const existingList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_selectedReasonCorticosteroid || [];

            const existingreasonList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_reasonCorticosteroid || [];

            const exists = existingList.some(
              (i) => i.cartcharacteristicscorticosteroidreasonid === reasonID,
            );

            /* ===============================
         BUILD UPDATED REASON LIST
      =============================== */

            /* ===============================
         BUILD UPDATED REASON LIST
      =============================== */
            const updatedList = (() => {
              // RULE 0️⃣: Uncheck 3 → remove 3 & 4–20
              if (reasonID === 3 && exists) {
                return existingList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid < 3 ||
                    i.cartcharacteristicscorticosteroidreasonid > 20,
                );
              }

              // RULE: Uncheck 6 → remove 6 & 7–13
              if (reasonID === 6 && exists) {
                return existingList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid !== 6 &&
                    (i.cartcharacteristicscorticosteroidreasonid < 7 ||
                      i.cartcharacteristicscorticosteroidreasonid > 13),
                );
              }

              // RULE 1️⃣: 22 only
              if (reasonID === 22) {
                return [{ cartcharacteristicscorticosteroidreasonid: 22 }];
              }

              // RULE 2️⃣: 20 → ensure 3
              if (reasonID === 20) {
                return [
                  { cartcharacteristicscorticosteroidreasonid: 20 },
                  { cartcharacteristicscorticosteroidreasonid: 3 },
                ];
              }

              // CLEANUP
              const cleanedList = existingList.filter(
                (i) =>
                  i.cartcharacteristicscorticosteroidreasonid !== 20 &&
                  i.cartcharacteristicscorticosteroidreasonid !== 22,
              );

              // RULE 4️⃣: 7–13 → ensure 3 & 6
              if (reasonID >= 7 && reasonID <= 13) {
                const baseList = exists
                  ? cleanedList.filter(
                      (i) =>
                        i.cartcharacteristicscorticosteroidreasonid !==
                        reasonID,
                    )
                  : [
                      ...cleanedList,
                      { cartcharacteristicscorticosteroidreasonid: reasonID },
                    ];

                const has3 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 3,
                );
                const has6 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 6,
                );

                return [
                  ...baseList,
                  ...(has3
                    ? []
                    : [{ cartcharacteristicscorticosteroidreasonid: 3 }]),
                  ...(has6
                    ? []
                    : [{ cartcharacteristicscorticosteroidreasonid: 6 }]),
                ];
              }

              // RULE 3️⃣: 4–19 → ensure 3
              if (reasonID >= 4 && reasonID <= 19) {
                const baseList = exists
                  ? cleanedList.filter(
                      (i) =>
                        i.cartcharacteristicscorticosteroidreasonid !==
                        reasonID,
                    )
                  : [
                      ...cleanedList,
                      { cartcharacteristicscorticosteroidreasonid: reasonID },
                    ];

                const has3 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 3,
                );

                return has3
                  ? baseList
                  : [
                      ...baseList,
                      { cartcharacteristicscorticosteroidreasonid: 3 },
                    ];
              }

              // NORMAL TOGGLE
              if (exists) {
                return cleanedList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid !== reasonID,
                );
              }

              return [
                ...cleanedList,
                { cartcharacteristicscorticosteroidreasonid: reasonID },
              ];
            })();

            /* ===============================
         DISPLAY FILTER LOGIC
      =============================== */
            const selectedIds = updatedList.map(
              (i) => i.cartcharacteristicscorticosteroidreasonid,
            );

            const hasAE = selectedIds.includes(3);
            const hasNeuro = selectedIds.includes(6);

            let reasonCorticosteroid;

            if (hasAE && hasNeuro) {
              reasonCorticosteroid = reasonCorticosteroidUsage;
            } else if (hasAE) {
              reasonCorticosteroid = reasonCorticosteroidUsage.filter(
                (i) => i.neurologicevent !== true,
              );
            } else {
              reasonCorticosteroid = reasonCorticosteroidUsage.filter(
                (i) => i.corticosteroid === true,
              );
            }
            /* ===============================
         UPDATE CHILD LIST
      =============================== */
            const updatedChildList = row.carTTreatmentCorticosteroidList.map(
              (child, idx) =>
                idx === index
                  ? {
                      ...child,
                      q43_2E_selectedReasonCorticosteroid: updatedList,
                      q43_2E_ReasonEmpty: false,
                      q43_2E_Reason_TxtEmpty: false,
                      q43_2E_Reason_AEEmpty: false,
                      q43_2E_Reason_NeurologicEmpty: false,

                      q43_2E_Reason_otherneurologic_Txt: [3, 6, 13].every(
                        (id) => selectedIds.includes(id),
                      )
                        ? child.q43_2E_Reason_otherneurologic_Txt
                        : "",

                      q43_2E_reasonCorticosteroid: reasonCorticosteroid,
                    }
                  : child,
            );

            return {
              ...row,
              carTTreatmentCorticosteroidList: updatedChildList,
            };
          }),
        );
        break;
      }

      case `q43_2E_Reason_otherneurologic_Txt_13_${loopIndex}_${innerLoopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId !== 13) return row;

            const index = loopIndex;
            const reasonID = Number(innerLoopIndex);

            const existingList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_selectedReasonCorticosteroid || [];

            const exists = existingList.some(
              (item) =>
                item.cartcharacteristicscorticosteroidreasonid === reasonID,
            );

            // Required reason IDs when text is entered
            const REQUIRED_REASON_IDS = [6, 13, 3];

            // Add missing required reasons
            const updatedReasonList = [
              ...existingList.filter(
                (item) =>
                  !REQUIRED_REASON_IDS.includes(
                    item.cartcharacteristicscorticosteroidreasonid,
                  ),
              ),
              ...REQUIRED_REASON_IDS.map((id) => ({
                cartcharacteristicscorticosteroidreasonid: id,
              })),
            ];

            const updatedChildList = row.carTTreatmentCorticosteroidList.map(
              (child, idx) =>
                idx === index
                  ? {
                      ...child,
                      q43_2E_selectedReasonCorticosteroid: updatedReasonList,
                      q43_2E_Reason_otherneurologic_Txt: value,
                      q43_2E_ReasonEmpty: false,
                      q43_2E_Reason_TxtEmpty: false,
                      q43_2E_Reason_AEEmpty: false,
                      q43_2E_Reason_NeurologicEmpty: false,
                    }
                  : child,
            );

            return {
              ...row,
              carTTreatmentCorticosteroidList: updatedChildList,
            };
          }),
        );
        break;
      }
      case `q43_2B_No_Corticosteroid_Rcvd_14_${loopIndex}`: {
        if (value_int === 1) setShowCorticosteroidClickToAddMore_13(false);

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2B_No_Corticosteroid_Rcvd: value_int,
                        q43_2B_No_Corticosteroid_RcvdEmpty: false,
                        q43_2_Date_Valid: false,
                        q43_2B_Corticosteroid_DateEmpty: false,
                        q43_2B_Corticosteroid_Date: "",
                        q43_2C_CorticosteroidType:
                          value_int === 1
                            ? null
                            : child.q43_2C_CorticosteroidType,
                        q43_2C_CorticosteroidType_Empty:
                          value_int === 1
                            ? false
                            : child.q43_2C_CorticosteroidType_Empty,

                        q43_2D_DoseStrength:
                          value_int === 1 ? null : child.q43_2D_DoseStrength,
                        q43_2D_DoseStrength_Empty:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrength_Empty,
                        q43_2D_DoseStrength_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrength_TxtEmpty,
                        q43_2D_DoseStrengthMGRange:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrengthMGRange,
                        q43_2D_DoseStrengthKGRange:
                          value_int === 1
                            ? false
                            : child.q43_2D_DoseStrengthKGRange,
                        q43_2D_DoseStrength_kg:
                          value_int === 1 ? null : child.q43_2D_DoseStrength_kg,
                        q43_2D_DoseStrength_mg:
                          value_int === 1 ? null : child.q43_2D_DoseStrength_mg,
                        q43_2D_DoseStrength_other:
                          value_int === 1
                            ? null
                            : child.q43_2D_DoseStrength_other,

                        q43_2E_selectedReasonCorticosteroid:
                          value_int === 1
                            ? []
                            : child.q43_2E_selectedReasonCorticosteroid,
                        q43_2E_reasonCorticosteroid:
                          value_int === 1
                            ? []
                            : child.q43_2E_reasonCorticosteroid,
                        q43_2E_ReasonEmpty:
                          value_int === 1 ? false : child.q43_2E_ReasonEmpty,
                        q43_2E_Reason_AEEmpty:
                          value_int === 1 ? false : child.q43_2E_Reason_AEEmpty,
                        q43_2E_Reason_NeurologicEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2E_Reason_NeurologicEmpty,
                        q43_2E_Reason_TxtEmpty:
                          value_int === 1
                            ? false
                            : child.q43_2E_Reason_TxtEmpty,
                        q43_2E_Reason_otherneurologic_Txt:
                          value_int === 1
                            ? ""
                            : child.q43_2E_Reason_otherneurologic_Txt,
                        q43_2E_reasonCorticosteroid:
                          value_int == 1
                            ? reasonCorticosteroidUsage.filter(
                                (i) => i.corticosteroid === true,
                              )
                            : child.q43_2E_reasonCorticosteroid,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row; // keep other rows unchanged
          }),
        );

        break;
      }
      case `q43_2C_CorticosteroidType_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2C_CorticosteroidType: value_int,
                        q43_2C_CorticosteroidType_Empty: false,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_2D_DoseStrength_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength: value_int,
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_mg:
                          value_int == 99 || value_int == 2 || value_int == 3
                            ? ""
                            : child.q43_2D_DoseStrength_mg,
                        q43_2D_DoseStrength_kg:
                          value_int == 99 || value_int == 1 || value_int == 3
                            ? ""
                            : child.q43_2D_DoseStrength_kg,
                        q43_2D_DoseStrength_other:
                          value_int == 99 || value_int == 2 || value_int == 1
                            ? ""
                            : child.q43_2D_DoseStrength_other,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }

      case `q43_2D_DoseStrength_mg_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength_mg: value,
                        q43_2D_DoseStrength: 1, // since text implies "Other"
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_kg: "",
                        q43_2D_DoseStrength_other: "",
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_2D_DoseStrength_kg_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q43_2D_DoseStrength_kg: value,
                        q43_2D_DoseStrength: 2, // since text implies "Other"
                        q43_2D_DoseStrength_Empty: false,
                        q43_2D_DoseStrength_TxtEmpty: false,
                        q43_2D_DoseStrengthMGRange: false,
                        q43_2D_DoseStrengthKGRange: false,
                        q43_2D_DoseStrength_mg: "",
                        q43_2D_DoseStrength_other: "",
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      }
      case `q43_2D_DoseStrength_other_14_${loopIndex}`:
        {
          setCarTCharRepeater((prev) =>
            prev.map((row) => {
              if (row.cohortTreatmentId === 14) {
                const updatedChildList =
                  row.carTTreatmentCorticosteroidList.map((child, idx) =>
                    idx === loopIndex
                      ? {
                          ...child,
                          q43_2D_DoseStrength_other: value,
                          q43_2D_DoseStrength: 3, // since text implies "Other"
                          q43_2D_DoseStrength_Empty: false,
                          q43_2D_DoseStrength_TxtEmpty: false,
                          q43_2D_DoseStrengthMGRange: false,
                          q43_2D_DoseStrengthKGRange: false,
                          q43_2D_DoseStrength_kg: "",
                          q43_2D_DoseStrength_mg: "",
                        }
                      : child,
                  );

                return {
                  ...row,
                  carTTreatmentCorticosteroidList: updatedChildList,
                };
              }
              return row;
            }),
          );
          break;
        }

        break;
      case `q43_2E_reasonCorticosteroid_14_${loopIndex}_${innerLoopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId !== 14) return row;

            const index = loopIndex;
            const reasonID = Number(innerLoopIndex);

            const existingList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_selectedReasonCorticosteroid || [];

            const existingreasonList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_reasonCorticosteroid || [];

            const exists = existingList.some(
              (i) => i.cartcharacteristicscorticosteroidreasonid === reasonID,
            );

            /* ===============================
         BUILD UPDATED REASON LIST
      =============================== */
            const updatedList = (() => {
              // RULE 0️⃣: Uncheck 3 → remove 3 & 4–20
              if (reasonID === 3 && exists) {
                return existingList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid < 3 ||
                    i.cartcharacteristicscorticosteroidreasonid > 20,
                );
              }

              // RULE: Uncheck 6 → remove 6 & 7–13
              if (reasonID === 6 && exists) {
                return existingList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid !== 6 &&
                    (i.cartcharacteristicscorticosteroidreasonid < 7 ||
                      i.cartcharacteristicscorticosteroidreasonid > 13),
                );
              }

              // RULE 1️⃣: 22 only
              if (reasonID === 22) {
                return [{ cartcharacteristicscorticosteroidreasonid: 22 }];
              }

              // RULE 2️⃣: 20 → ensure 3
              if (reasonID === 20) {
                return [
                  { cartcharacteristicscorticosteroidreasonid: 20 },
                  { cartcharacteristicscorticosteroidreasonid: 3 },
                ];
              }

              // CLEANUP
              const cleanedList = existingList.filter(
                (i) =>
                  i.cartcharacteristicscorticosteroidreasonid !== 20 &&
                  i.cartcharacteristicscorticosteroidreasonid !== 22,
              );

              // RULE 4️⃣: 7–13 → ensure 3 & 6
              if (reasonID >= 7 && reasonID <= 13) {
                const baseList = exists
                  ? cleanedList.filter(
                      (i) =>
                        i.cartcharacteristicscorticosteroidreasonid !==
                        reasonID,
                    )
                  : [
                      ...cleanedList,
                      { cartcharacteristicscorticosteroidreasonid: reasonID },
                    ];

                const has3 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 3,
                );
                const has6 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 6,
                );

                return [
                  ...baseList,
                  ...(has3
                    ? []
                    : [{ cartcharacteristicscorticosteroidreasonid: 3 }]),
                  ...(has6
                    ? []
                    : [{ cartcharacteristicscorticosteroidreasonid: 6 }]),
                ];
              }

              // RULE 3️⃣: 4–19 → ensure 3
              if (reasonID >= 4 && reasonID <= 19) {
                const baseList = exists
                  ? cleanedList.filter(
                      (i) =>
                        i.cartcharacteristicscorticosteroidreasonid !==
                        reasonID,
                    )
                  : [
                      ...cleanedList,
                      { cartcharacteristicscorticosteroidreasonid: reasonID },
                    ];

                const has3 = baseList.some(
                  (i) => i.cartcharacteristicscorticosteroidreasonid === 3,
                );

                return has3
                  ? baseList
                  : [
                      ...baseList,
                      { cartcharacteristicscorticosteroidreasonid: 3 },
                    ];
              }

              // NORMAL TOGGLE
              if (exists) {
                return cleanedList.filter(
                  (i) =>
                    i.cartcharacteristicscorticosteroidreasonid !== reasonID,
                );
              }

              return [
                ...cleanedList,
                { cartcharacteristicscorticosteroidreasonid: reasonID },
              ];
            })();

            /* ===============================
         DISPLAY FILTER LOGIC
      =============================== */
            const selectedIds = updatedList.map(
              (i) => i.cartcharacteristicscorticosteroidreasonid,
            );

            const hasAE = selectedIds.includes(3);
            const hasNeuro = selectedIds.includes(6);

            let reasonCorticosteroid;

            if (hasAE && hasNeuro) {
              reasonCorticosteroid = reasonCorticosteroidUsage;
            } else if (hasAE) {
              reasonCorticosteroid = reasonCorticosteroidUsage.filter(
                (i) => i.neurologicevent !== true,
              );
            } else {
              reasonCorticosteroid = reasonCorticosteroidUsage.filter(
                (i) => i.corticosteroid === true,
              );
            }

            /* ===============================
         UPDATE CHILD LIST
      =============================== */
            const updatedChildList = row.carTTreatmentCorticosteroidList.map(
              (child, idx) =>
                idx === index
                  ? {
                      ...child,
                      q43_2E_selectedReasonCorticosteroid: updatedList,
                      q43_2E_ReasonEmpty: false,
                      q43_2E_Reason_TxtEmpty: false,
                      q43_2E_Reason_AEEmpty: false,
                      q43_2E_Reason_NeurologicEmpty: false,

                      q43_2E_Reason_otherneurologic_Txt: [3, 6, 13].every(
                        (id) => selectedIds.includes(id),
                      )
                        ? child.q43_2E_Reason_otherneurologic_Txt
                        : "",

                      q43_2E_reasonCorticosteroid: reasonCorticosteroid,
                    }
                  : child,
            );

            return {
              ...row,
              carTTreatmentCorticosteroidList: updatedChildList,
            };
          }),
        );
        break;
      }

      case `q43_2E_Reason_otherneurologic_Txt_14_${loopIndex}_${innerLoopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId !== 14) return row;

            const index = loopIndex;
            const reasonID = Number(innerLoopIndex);

            const existingList =
              row.carTTreatmentCorticosteroidList[index]
                .q43_2E_selectedReasonCorticosteroid || [];

            const exists = existingList.some(
              (item) =>
                item.cartcharacteristicscorticosteroidreasonid === reasonID,
            );

            // Required reason IDs when text is entered
            const REQUIRED_REASON_IDS = [6, 13, 3];

            // Add missing required reasons
            const updatedReasonList = [
              ...existingList.filter(
                (item) =>
                  !REQUIRED_REASON_IDS.includes(
                    item.cartcharacteristicscorticosteroidreasonid,
                  ),
              ),
              ...REQUIRED_REASON_IDS.map((id) => ({
                cartcharacteristicscorticosteroidreasonid: id,
              })),
            ];

            const updatedChildList = row.carTTreatmentCorticosteroidList.map(
              (child, idx) =>
                idx === index
                  ? {
                      ...child,
                      q43_2E_selectedReasonCorticosteroid: updatedReasonList,
                      q43_2E_Reason_otherneurologic_Txt: value,
                      q43_2E_ReasonEmpty: false,
                      q43_2E_Reason_TxtEmpty: false,
                      q43_2E_Reason_AEEmpty: false,
                      q43_2E_Reason_NeurologicEmpty: false,
                    }
                  : child,
            );

            return {
              ...row,
              carTTreatmentCorticosteroidList: updatedChildList,
            };
          }),
        );
        break;
      }

      case `q421A_Start_Bridging_Therapy_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_Start_Bridging_Therapy: value_int,
                        q421A_Start_Bridging_Therapy_Date: value_int != 2 && "",
                        q421A_Start_Bridging_Therapy_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case `q421A_Start_Bridging_Therapy_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_Start_Bridging_Therapy: value_int,
                        q421A_Start_Bridging_Therapy_Date: value_int != 2 && "",
                        q421A_Start_Bridging_Therapy_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q421A_End_Bridging_Therapy_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_End_Bridging_Therapy: value_int,
                        q421A_End_Bridging_Therapy_Date: "",
                        q421A_End_Bridging_Therapy_Empty: false,
                        q421A_End_Bridging_TherapyDate_Empty: false,
                        q421A_End_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case `q421A_End_Bridging_Therapy_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_End_Bridging_Therapy: value_int,
                        q421A_End_Bridging_Therapy_Date: "",
                        q421A_End_Bridging_Therapy_Empty: false,
                        q421A_End_Bridging_TherapyDate_Empty: false,
                        q421A_End_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q421A_BestResponse_Status_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_BestResponse_Status: value_int,
                        q421A_BestResponse_Status_Empty: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case `q421A_BestResponse_Status_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_BestResponse_Status: value_int,
                        q421A_BestResponse_Status_Empty: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q421A_BestResponse_Assessment_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_BestResponse_Assessment: value_int,
                        q421A_BestResponse_Assessment_Date: "",
                        q421A_BestResponse_Assessment_Empty: false,
                        q421A_BestResponse_AssessmentDate_Empty: false,
                        q421A_BestResponse_AssessmentDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case `q421A_BestResponse_Assessment_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_BestResponse_Assessment: value_int,
                        q421A_BestResponse_Assessment_Date: "",
                        q421A_BestResponse_Assessment_Empty: false,
                        q421A_BestResponse_AssessmentDate_Empty: false,
                        q421A_BestResponse_AssessmentDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `q421A_Method_Assessment_13_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_Method_Assessment: value_int,
                        q421A_Method_Assessment_Empty: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case `q421A_Method_Assessment_14_${loopIndex}`: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_Method_Assessment: value_int,
                        q421A_Method_Assessment_Empty: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case "q421A_rb_received_tmt_unk_13_" + id: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_rb_received_tmt_unk:
                          !child.q421A_rb_received_tmt_unk,
                        q421A_selectedReceivedTmtList: [],
                        q421A_empty_err: false,
                        q421A_txt_empty_err: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case "chk_q421A_received_tmt_13_" + id: {
        const tmtID = Number(id.split("_").pop()); // selected treatment id

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) => {
                  if (idx !== loopIndex) return child;

                  const selTmtList = child.q421A_selectedReceivedTmtList || [];
                  const tmtIndex = selTmtList.findIndex(
                    (item) => item.prescribedTreatmentId === tmtID,
                  );

                  const updatedSelTmtList =
                    tmtIndex >= 0
                      ? selTmtList.filter(
                          (item) => item.prescribedTreatmentId !== tmtID,
                        ) // unselect
                      : [...selTmtList, { prescribedTreatmentId: tmtID }]; // select

                  return {
                    ...child,
                    q421A_selectedReceivedTmtList: updatedSelTmtList,
                    q421A_rb_received_tmt_unk: false,
                    q421A_empty_err: false,
                    q421A_txt_empty_err: false,
                  };
                },
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }

            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case "q421A_txt_received_tmt_oth_13_" + id: {
        const tmtID = Number(id.split("_").pop());
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) => {
                  if (idx !== loopIndex) return child;

                  const selTmtList = child.q421A_selectedReceivedTmtList || [];
                  const existingItemIndex = selTmtList.findIndex(
                    (item) => item.prescribedTreatmentId === tmtID,
                  );

                  const updatedSelTmtList =
                    existingItemIndex >= 0
                      ? selTmtList.map((item, i) =>
                          i === existingItemIndex
                            ? {
                                ...item,
                                prescribedTreatmentOthTxt: value,
                              }
                            : item,
                        )
                      : [
                          ...selTmtList,
                          {
                            prescribedTreatmentId: tmtID,
                            prescribedTreatmentOthTxt: value,
                          },
                        ];

                  return {
                    ...child,
                    q421A_selectedReceivedTmtList: updatedSelTmtList,
                    q421A_rb_received_tmt_unk: false,
                    q421A_empty_err: false,
                    q421A_txt_empty_err: false,
                  };
                },
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }

            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case "q421A_rb_received_tmt_unk_14_" + id: {
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              // update child list immutably
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === loopIndex
                    ? {
                        ...child,
                        q421A_rb_received_tmt_unk:
                          !child.q421A_rb_received_tmt_unk,
                        q421A_selectedReceivedTmtList: [],
                        q421A_empty_err: false,
                        q421A_txt_empty_err: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case "chk_q421A_received_tmt_14_" + id: {
        const tmtID = Number(id.split("_").pop()); // selected treatment id

        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) => {
                  if (idx !== loopIndex) return child;

                  const selTmtList = child.q421A_selectedReceivedTmtList || [];
                  const tmtIndex = selTmtList.findIndex(
                    (item) => item.prescribedTreatmentId === tmtID,
                  );

                  const updatedSelTmtList =
                    tmtIndex >= 0
                      ? selTmtList.filter(
                          (item) => item.prescribedTreatmentId !== tmtID,
                        ) // unselect
                      : [...selTmtList, { prescribedTreatmentId: tmtID }]; // select

                  return {
                    ...child,
                    q421A_selectedReceivedTmtList: updatedSelTmtList,
                    q421A_rb_received_tmt_unk: false,
                    q421A_empty_err: false,
                    q421A_txt_empty_err: false,
                  };
                },
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }

            return row; // keep other rows unchanged
          }),
        );
        break;
      }
      case "q421A_txt_received_tmt_oth_14_" + id: {
        const tmtID = Number(id.split("_").pop());
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) => {
                  if (idx !== loopIndex) return child;

                  const selTmtList = child.q421A_selectedReceivedTmtList || [];
                  const existingItemIndex = selTmtList.findIndex(
                    (item) => item.prescribedTreatmentId === tmtID,
                  );

                  const updatedSelTmtList =
                    existingItemIndex >= 0
                      ? selTmtList.map((item, i) =>
                          i === existingItemIndex
                            ? {
                                ...item,
                                prescribedTreatmentOthTxt: value,
                              }
                            : item,
                        )
                      : [
                          ...selTmtList,
                          {
                            prescribedTreatmentId: tmtID,
                            prescribedTreatmentOthTxt: value,
                          },
                        ];

                  return {
                    ...child,
                    q421A_selectedReceivedTmtList: updatedSelTmtList,
                    q421A_rb_received_tmt_unk: false,
                    q421A_empty_err: false,
                    q421A_txt_empty_err: false,
                  };
                },
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }

            return row; // keep other rows unchanged
          }),
        );
        break;
      }

      case `checkbox${loopIndex}${innerLoopIndex}`: {
        const updatedTypeList = [
          ...updatedArray[loopIndex].carTCharacteristicsTypeList,
        ];
        const updatedReceivedList = [
          ...updatedArray[loopIndex].carTCharacteristicsReceivedList,
        ];

        const requiredIndex = updatedReceivedList.findIndex(
          (x) => x.carTTherapyReceivedId == innerLoopIndex,
        );

        updatedReceivedList
          .filter((x) => x.carTtherapyId == carTTherapyId)
          .forEach((item) => {
            item.carTOtherTxtEmpty = false;
          });

        if (requiredIndex > -1) {
          updatedReceivedList[requiredIndex] = {
            ...updatedReceivedList[requiredIndex],
            isChecked: checked,
            isCheckedEmpty: false,
            carTOtherTxtEmpty: false,
            carTOtherTxt:
              requiredIndex === 26 || requiredIndex === 32
                ? ""
                : updatedReceivedList[requiredIndex].carTOtherTxt,
          };
        }

        // If any checkbox is checked, unselect the "Unknown" radio button
        // if (checked) {
        //   updatedTypeList.forEach((item ) => {
        //     //map inside and then hide orelse both rows UNK unselects
        //     item.q42_CohortTreatment_Unk = null;
        //     item.therapyReceivedEmpty = false;
        //   });
        // }

        if (checked) {
          updatedTypeList
            .filter((item) => item.carTTherapyId === carTTherapyId) // Replace 1 with the desired carTTherapyId value
            .forEach((item) => {
              item.q42_CohortTreatment_Unk = null;
              item.therapyReceivedEmpty = false;
            });
        }

        updatedArray[loopIndex] = {
          ...updatedArray[loopIndex],
          carTCharacteristicsTypeList: updatedTypeList,
          carTCharacteristicsReceivedList: updatedReceivedList,
        };

        setCarTCharRepeater(updatedArray);
        break;
      }

      case `Checkboxtext${loopIndex}${innerLoopIndex}`: {
        const updatedTypeList = [
          ...updatedArray[loopIndex].carTCharacteristicsTypeList,
        ];
        const updatedReceivedList = [
          ...updatedArray[loopIndex].carTCharacteristicsReceivedList,
        ];

        const requiredIndex = updatedReceivedList.findIndex(
          (x) => x.carTTherapyReceivedId == innerLoopIndex,
        );

        if (requiredIndex > -1) {
          updatedReceivedList[requiredIndex] = {
            ...updatedReceivedList[requiredIndex],
            carTOtherTxt: value,
            isChecked: true,
            carTOtherTxtEmpty: false,
          };
        }

        // If text is entered, unselect the "Unknown" radio button
        // if (value) {
        //   updatedTypeList.forEach((item) => {
        //     item.q42_CohortTreatment_Unk = null;
        //     item.therapyReceivedEmpty = false;
        //   });
        // }

        if (value) {
          updatedTypeList
            .filter((item) => item.carTTherapyId === carTTherapyId) // Replace 1 with the desired carTTherapyId value
            .forEach((item) => {
              item.q42_CohortTreatment_Unk = null;
              item.therapyReceivedEmpty = false;
            });
        }

        updatedArray[loopIndex] = {
          ...updatedArray[loopIndex],
          carTCharacteristicsTypeList: updatedTypeList,
          carTCharacteristicsReceivedList: updatedReceivedList,
        };

        setCarTCharRepeater(updatedArray);
        break;
      }

      default:
        break;
    }
  };

  function parseDate(dateStr) {
    const [month, day, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  }

  function compareLastPatientEncounterDate(
    cohortIndexDateStr,
    apheresisDateStr,
  ) {
    const cohortIndexDate = cohortIndexDateStr
      ? parseDate(cohortIndexDateStr)
      : null;
    const lastEncounterDate = apheresisDateStr
      ? parseDate(apheresisDateStr)
      : null;

    // Ensure both dates are valid before comparison
    if (cohortIndexDate && lastEncounterDate) {
      return lastEncounterDate <= cohortIndexDate;
    }

    // If any of the dates are invalid, return false
    return false;
  }

  const checkTherapyDate = (apheresisDateStr, therapyDateStr, indexDateStr) => {
    // Helper function to parse dates from MM/DD/YYYY format
    const parseDate = (dateStr) => {
      if (!dateStr) return null; // Handle null or empty date strings
      const [month, day, year] = dateStr.split("/");
      return new Date(year, month - 1, day);
    };

    // Parse the dates
    const dateOfApheresis = parseDate(apheresisDateStr);
    const therapyDate = parseDate(therapyDateStr);
    const bispecificsCarTIndexDate = parseDate(indexDateStr);

    // Handle null dates
    if (!therapyDate || !bispecificsCarTIndexDate) {
      //!dateOfApheresis ||
      return false; // Validation fails if any date is null
    }

    // Validate the date range
    let isValid = true;
    if (!dateOfApheresis) {
      isValid = therapyDate <= bispecificsCarTIndexDate;
    } else {
      isValid =
        therapyDate >= dateOfApheresis &&
        therapyDate <= bispecificsCarTIndexDate;
    }

    return isValid;
  };

  //Q42 Date Handling
  const HandleRepeatDateChange = (name, date) => {
    const regex = /q42_Therpy_Initiation_Date(\d+)_(\d+)/;
    const match = name.match(regex);

    const loopIndex = parseInt(match[1], 10);
    const innerLoopIndex = parseInt(match[2], 10);

    let updatedArray = [...carTCharRepeater];

    // const dateIsvalid = checkTherapyDate(
    //   updatedArray[loopIndex].q41_Apheresis_Date,
    //   date,
    //   filteredList[loopIndex].cohortIndexDate
    // );

    // Create a deep copy of the inner object to avoid direct mutation
    const updatedTypeList = [
      ...updatedArray[loopIndex].carTCharacteristicsTypeList,
    ];
    updatedTypeList[innerLoopIndex] = {
      ...updatedTypeList[innerLoopIndex],
      q42_Therpy_Initiation_Date: date,
      q42_Therpy_Initiation_Radio: 1,
      q42_Therapy_Receive_Empty: false,
      q42_Therapy_Initiation_NotValid: false,
      q42_R2_Date_Not_Valid: false,
      q42_Therpy_Initiation_Date_Empty: false,
      q42_Therpy_Initiation_Radio_Empty: false,
      q42_Therapy_Initiation_DateInvalid: false,
      // q42_Therapy_Initiation_NotValid: dateIsvalid ? false : true,
    };
    updatedArray[loopIndex] = {
      ...updatedArray[loopIndex],
      carTCharacteristicsTypeList: updatedTypeList,
    };

    // Update the state
    setCarTCharRepeater(updatedArray);
  };

  function validateQ43Date(date, ndmmEndofFollowupDate, cohortIndexDate) {
    const formatDate = (dateStr) => {
      if (!dateStr) return new Date();
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const startDate = formatDate(cohortIndexDate);
    const endDate = formatDate(ndmmEndofFollowupDate);
    const dateToCompare = formatDate(date);

    if (!cohortIndexDate && !ndmmEndofFollowupDate) {
      return true;
    }

    return dateToCompare >= startDate && dateToCompare <= endDate;
  }

  function validateQ43_1_Date(
    date,
    ndmmEndofFollowupDate,
    cohortIndexDate,
    subsequentLOTStartDate,
  ) {
    const formatDate = (dateStr) => {
      if (!dateStr) return null;
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const startDate = formatDate(cohortIndexDate);
    const endDate = formatDate(ndmmEndofFollowupDate);
    const dateToCompare = formatDate(date);
    const lotStart = formatDate(subsequentLOTStartDate);

    if (!cohortIndexDate && !ndmmEndofFollowupDate && !lotStart) {
      return true;
    }

    if (!dateToCompare) return false;
    // 1️⃣ Check lower bound (index)
    if (startDate && dateToCompare < startDate) {
      return false;
    }

    // 2️⃣ Check LOT start ONLY if it exists
    if (lotStart && dateToCompare >= lotStart) {
      return false;
    }

    // 3️⃣ Always check end of follow-up if it exists
    if (endDate && dateToCompare > endDate) {
      return false;
    }

    return true;
  }

  function validateQ43_4_Date(
    date,
    ndmmEndofFollowupDate,
    apheresisDate,
    indexAddThirtyDate,
  ) {
    const formatDate = (dateStr) => {
      if (!dateStr) return null;
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const startDate = formatDate(apheresisDate);
    const endDate = formatDate(ndmmEndofFollowupDate);
    const dateToCompare = formatDate(date);
    const indexaddThirtyDates = formatDate(indexAddThirtyDate);

    if (!apheresisDate && !ndmmEndofFollowupDate && !indexaddThirtyDates) {
      return true;
    }

    if (!dateToCompare) return false;

    // 1️⃣ Check lower bound (index)
    if (startDate && dateToCompare < startDate) {
      return false;
    }

    // 2️⃣ Check LOT start ONLY if it exists
    if (indexaddThirtyDates && dateToCompare >= indexaddThirtyDates) {
      return false;
    }

    // 3️⃣ Always check end of follow-up if it exists
    if (endDate && dateToCompare > endDate) {
      return false;
    }

    return true;
  }

  function validateQ41Date(date, cohortIndexDate) {
    const formatDate = (dateStr) => {
      if (!dateStr) return new Date();
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const startDate = formatDate(cohortIndexDate);

    const dateToCompare = formatDate(date);

    if (!cohortIndexDate) {
      return true;
    }

    return dateToCompare <= startDate;
  }

  function validateQ421ADate(dateColA, dateColB, dateQ42, cohortIndexDate) {
    const parseDate = (dateStr) => {
      if (!dateStr || dateStr.trim() === "") return null;
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    // cohort index date is mandatory anchor
    if (!cohortIndexDate) return true;

    const indexDate = parseDate(cohortIndexDate);

    // collect only valid dates
    const dates = [
      parseDate(dateColA),
      parseDate(dateColB),
      parseDate(dateQ42),
    ].filter(Boolean); // removes nulls

    // add cohortIndexDate at the end for final comparison
    dates.push(indexDate);

    // validate sequence
    for (let i = 0; i < dates.length - 1; i++) {
      if (dates[i] > dates[i + 1]) {
        return false;
      }
    }

    return true;
  }

  const HandleRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = parseInt(name.slice(lastIndex + 1), 10);

    let updatedArray = [...carTCharRepeater];
    let ndmmEndoffollowupDate = "";

    if (id === 0) {
      ndmmEndoffollowupDate = carTCharData.carvyktiFollowupDate;
    } else if (id === 1) {
      ndmmEndoffollowupDate = carTCharData.abecmaFollowupDate;
    }

    if (ndmmEndoffollowupDate == "" || ndmmEndoffollowupDate == null) {
      ndmmEndoffollowupDate = carTCharData.endOfFollowupDate;
    }

    switch (true) {
      case name.startsWith("q43B_Procedure_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43B_No_Procedure_Rcvd: 2, // procedure received
                        q43B_Procedure_Date: date, // assign picked date
                        q43B_No_Procedure_RcvdEmpty: false,
                        q43B_Procedure_DateEmpty: false,
                        q43_Date_Valid: false,
                        q43_Procedure_InvalidDate: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.includes("q43B_Procedure_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43B_No_Procedure_Rcvd: 2, // procedure received
                        q43B_Procedure_Date: date, // assign picked date
                        q43B_No_Procedure_RcvdEmpty: false,
                        q43B_Procedure_DateEmpty: false,
                        q43_Date_Valid: false,
                        q43_Procedure_InvalidDate: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q43_1B_Tocilizumab_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_1B_No_Tocilizumab_Rcvd: 2, // procedure received
                        q43_1B_Tocilizumab_Date: date, // assign picked date
                        q43_1B_No_Tocilizumab_RcvdEmpty: false,
                        q43_1B_Tocilizumab_DateEmpty: false,
                        q43_1_Date_Valid: false,
                        q43_1_Tocilizumab_InvalidDate: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.includes("q43_1B_Tocilizumab_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentTocilizumabList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_1B_No_Tocilizumab_Rcvd: 2, // procedure received
                        q43_1B_Tocilizumab_Date: date, // assign picked date
                        q43_1B_No_Tocilizumab_RcvdEmpty: false,
                        q43_1B_Tocilizumab_DateEmpty: false,
                        q43_1_Date_Valid: false,
                        q43_1_Tocilizumab_InvalidDate: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentTocilizumabList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q41_Apheresis_Date"):
        updatedArray[id].q41_Apheresis_Date = date;
        updatedArray[id].q41_Apheresis_DateRd = 1;

        updatedArray[id].q41_Apheresis_Date_Empty = false;
        updatedArray[id].q41_Apheresis_Date_NotValid = false;
        updatedArray[id].q41_Apheresis_InvalidDate = false;

        //  const dateQ41IsValid =  validateQ41Date( updatedArray[id].q41_Apheresis_Date,   filteredList[id].cohortIndexDate)
        //  updatedArray[id].q41_Apheresis_Date_NotValid = !dateQ41IsValid;

        break;

      case name.startsWith("q421A_Start_Bridging_Therapy_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_Start_Bridging_Therapy: 2, // procedure received
                        q421A_Start_Bridging_Therapy_Date: date, // assign picked date
                        q421A_Start_Bridging_Therapy_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.startsWith("q421A_Start_Bridging_Therapy_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_Start_Bridging_Therapy: 2, // procedure received
                        q421A_Start_Bridging_Therapy_Date: date, // assign picked date
                        q421A_Start_Bridging_Therapy_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Empty: false,
                        q421A_Start_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q421A_End_Bridging_Therapy_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_End_Bridging_Therapy: 1, // procedure received
                        q421A_End_Bridging_Therapy_Date: date, // assign picked date
                        q421A_End_Bridging_Therapy_Empty: false,
                        q421A_End_Bridging_TherapyDate_Empty: false,
                        q421A_End_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.startsWith("q421A_End_Bridging_Therapy_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_End_Bridging_Therapy: 1, // procedure received
                        q421A_End_Bridging_Therapy_Date: date, // assign picked date
                        q421A_End_Bridging_Therapy_Empty: false,
                        q421A_End_Bridging_TherapyDate_Empty: false,
                        q421A_End_Bridging_TherapyDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q421A_BestResponse_Assessment_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_BestResponse_Assessment: 1, // procedure received
                        q421A_BestResponse_Assessment_Date: date, // assign picked date
                        q421A_BestResponse_Assessment_Empty: false,
                        q421A_BestResponse_AssessmentDate_Empty: false,
                        q421A_BestResponse_AssessmentDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.startsWith("q421A_BestResponse_Assessment_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTBridgingTherapyList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q421A_BestResponse_Assessment: 1, // procedure received
                        q421A_BestResponse_Assessment_Date: date, // assign picked date
                        q421A_BestResponse_Assessment_Empty: false,
                        q421A_BestResponse_AssessmentDate_Empty: false,
                        q421A_BestResponse_AssessmentDate_Invalid: false,
                      }
                    : child,
              );

              return { ...row, carTBridgingTherapyList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q43_4B_Assessment_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_4B_No_Assessment_Rcvd: 1, // procedure received
                        q43_4B_Assessment_Date: date, // assign picked date
                        q43_4B_No_Assessment_RcvdEmpty: false,
                        q43_4B_Assessment_DateEmpty: false,
                        q43_4_Assessment_InvalidDate: false,
                        q43_4_Date_Valid: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;
      case name.includes("q43_4B_Assessment_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentLymphocyteList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_4B_No_Assessment_Rcvd: 1, // procedure received
                        q43_4B_Assessment_Date: date, // assign picked date
                        q43_4B_No_Assessment_RcvdEmpty: false,
                        q43_4B_Assessment_DateEmpty: false,
                        q43_4_Assessment_InvalidDate: false,
                        q43_4_Date_Valid: false,
                      }
                    : child,
              );

              return { ...row, carTTreatmentLymphocyteList: updatedChildList };
            }
            return row;
          }),
        );
        break;

      case name.startsWith("q43_2B_Corticosteroid_Date_13-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 13) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_2B_No_Corticosteroid_Rcvd: 2, // procedure received
                        q43_2B_Corticosteroid_Date: date, // assign picked date
                        q43_2B_No_Corticosteroid_RcvdEmpty: false,
                        q43_2B_Corticosteroid_DateEmpty: false,
                        q43_2_Date_Valid: false,
                        q43_2_Corticosteroid_InvalidDate: false,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;
      case name.includes("q43_2B_Corticosteroid_Date_14-"):
        setCarTCharRepeater((prev) =>
          prev.map((row) => {
            if (row.cohortTreatmentId === 14) {
              const updatedChildList = row.carTTreatmentCorticosteroidList.map(
                (child, idx) =>
                  idx === id
                    ? {
                        ...child,
                        q43_2B_No_Corticosteroid_Rcvd: 2, // procedure received
                        q43_2B_Corticosteroid_Date: date, // assign picked date
                        q43_2B_No_Corticosteroid_RcvdEmpty: false,
                        q43_2B_Corticosteroid_DateEmpty: false,
                        q43_2_Date_Valid: false,
                        q43_2_Corticosteroid_InvalidDate: false,
                      }
                    : child,
              );

              return {
                ...row,
                carTTreatmentCorticosteroidList: updatedChildList,
              };
            }
            return row;
          }),
        );
        break;

      default:
        break;
    }

    // Now, validate the date after updating the state
    // const dateIsValid = validateQ43Date(
    //   updatedArray[id].q43B_Procedure_Date,
    //   ndmmEndoffollowupDate,
    //   filteredList[id].cohortIndexDate
    // );

    // Update the validation status in the state
    // updatedArray[id].q43_Date_Valid = !dateIsValid;

    // Finally, set the state again after validation
    if (name.startsWith("q41_Apheresis_Date"))
      setCarTCharRepeater(updatedArray);
  };

  const ValidateForm = () => {
    let valid = true;
    let errors = {
      q41_Apheresis_Date_Empty: false,
      q41_Apheresis_Date_NotValid: false,
      q411A_Utilization_Empty: false,
      q411A_Administration_Empty: false,
      q42_Therapy_Receive_Empty: false,
      q42_Therapy_Initiation_NotValid: false,
      q42_Therpy_Initiation_Radio_Empty: false,
      q42_Therpy_Initiation_Date_Empty: false,

      q421A_Start_Bridging_Therapy_Empty: false,
      q421A_Start_Bridging_TherapyDate_Empty: false,
      q421A_Start_Bridging_TherapyDate_Invalid: false,
      q421A_End_Bridging_Therapy_Empty: false,
      q421A_End_Bridging_TherapyDate_Empty: false,
      q421A_End_Bridging_TherapyDate_Invalid: false,
      q421A_BestResponse_Status_Empty: false,
      q421A_BestResponse_Assessment_Empty: false,
      q421A_BestResponse_AssessmentDate_Empty: false,
      q421A_BestResponse_AssessmentDate_Invalid: false,
      q421A_Method_Assessment_Empty: false,
      q421A_txt_empty_err: false,
      q421A_empty_err: false,

      q43B_No_Procedure_Rcvd_Empty: false,
      q43C_ProcedureType_Empty: false,
      q43B_Procedure_Date_Empty: false,
      q43C_ProcedureType_Txt_Empty: false,
      q43_1B_No_Tocilizumab_RcvdEmpty: false,
      q43_1C_ReasonEmpty: false,
      q43_1B_Tocilizumab_DateEmpty: false,
      q43_3B_NeurologicTypeEmpty: false,
      q43_3B_NeurologicType_TxtEmpty: false,
      q43_3C_Mitigation_TxtEmpty: false,
      q43_4B_No_Assessment_RcvdEmpty: false,
      q43_4C_MeasurementEmpty: false,
      q43_4C_Measurement_TxtEmpty: false,
      q43_4C_Measurement_ulRange: false,
      q43_4C_Measurement_mmRange: false,
      q43_4C_Measurement_xlRange: false,
      q43_4B_Assessment_DateEmpty: false,
      q43_2B_No_Corticosteroid_RcvdEmpty: false,
      q43_2C_CorticosteroidType_Empty: false,
      q43_2B_Corticosteroid_DateEmpty: false,
      q43_2D_DoseStrength_Empty: false,
      q43_2D_DoseStrength_TxtEmpty: false,
      q43_2D_DoseStrengthMGRange: false,
      q43_2D_DoseStrengthKGRange: false,
      q43_2E_Reason_TxtEmpty: false,
      q43_2E_ReasonEmpty: false,
      q43_2E_Reason_AEEmpty: false,
      q43_2E_Reason_NeurologicEmpty: false,

      isCheckedEmpty: false,
      carTOtherTxtEmpty: false,
      q43_Date_Valid: false,
      q43_1_Date_Valid: false,
      q43_4_Date_Valid: false,
      q43_2_Date_Valid: false,
      q42_R2_Date_Not_Valid: false,
      q41_Apheresis_InvalidDate: false,
      q43_Procedure_InvalidDate: false,
      q42_Therapy_Initiation_DateInvalid: false,
      q43_1_Tocilizumab_InvalidDate: false,
      q43_4_Assessment_InvalidDate: false,
      q43_2_Corticosteroid_InvalidDate: false,
    };

    // Validate carTCharRepeater fields
    if (carTCharRepeater) {
      carTCharRepeater.forEach((repeaterItem) => {
        // Validate q42 fields
        let carTCharacteristicsTypeList = isNewEcrfA
          ? repeaterItem.carTCharacteristicsTypeList.filter(
              (item) => item.carTTherapyId === 2,
            )
          : repeaterItem.carTCharacteristicsTypeList;

        carTCharacteristicsTypeList.forEach((item) => {
          const isCheckboxSectionVisible = item.q42_Therapy_Receive === 1;
          if (isCheckboxSectionVisible) {
            // Check if any checkbox is checked or if "Unknown" is selected
            const isAnyChecked =
              repeaterItem.carTCharacteristicsReceivedList.some(
                (item1) =>
                  item1.isChecked === true &&
                  item1.carTtherapyId == item.carTTherapyId,
              );
            const isUnknownSelected = item.q42_CohortTreatment_Unk === 99;

            if (!isAnyChecked && !isUnknownSelected) {
              errors.isCheckedEmpty = true;
              repeaterItem.carTCharacteristicsReceivedList
                .filter((item1) => item1.carTtherapyId == item.carTTherapyId)
                .forEach((items) => {
                  items.isCheckedEmpty = true;
                  item.therapyReceivedEmpty = true;
                });
              valid = false;
            }
          }

          repeaterItem.carTCharacteristicsReceivedList
            .filter((item1) =>
              item1.carTtherapyId == isNewEcrfA ? 2 : item.carTTherapyId,
            )
            .forEach((item) => {
              if (
                item.isChecked &&
                (item.carTTherapyReceivedId === 27 ||
                  item.carTTherapyReceivedId === 33) &&
                !item.carTOtherTxt
              ) {
                errors.carTOtherTxtEmpty = true;
                item.carTOtherTxtEmpty = true;
                valid = false;
              }
            });

          // Validate q42 Therapy Receive
          if (!item.q42_Therapy_Receive) {
            errors.q42_Therapy_Receive_Empty = true;
            item.q42_Therapy_Receive_Empty = true;
            valid = false;
          }

          if (item.q42_Therapy_Receive === 1) {
            // Validate q42 Therapy Initiation Radio
            if (!item.q42_Therpy_Initiation_Radio) {
              errors.q42_Therpy_Initiation_Radio_Empty = true;
              item.q42_Therpy_Initiation_Radio_Empty = true;
              // errors.q42_Therapy_Initiation_NotValid = true;
              // item.q42_Therpy_Initiation_Date_Empty = true;

              valid = false;
            }

            // Validate q42 Therapy Initiation Date

            if (
              (!item.q42_Therpy_Initiation_Date ||
                item.q42_Therpy_Initiation_Date == null ||
                item.q42_Therpy_Initiation_Date == "") &&
              item.q42_Therpy_Initiation_Radio === 1
            ) {
              errors.q42_Therpy_Initiation_Date_Empty = true;
              item.q42_Therpy_Initiation_Date_Empty = true;
              valid = false;
            } else if (item.q42_Therapy_Initiation_NotValid) {
              // errors.q42_Therapy_Initiation_NotValid = true;
              // item.q42_Therpy_Initiation_Date_Empty = true;
              valid = false;
            }

            if (
              item.q42_Therpy_Initiation_Date !== null &&
              item.q42_Therpy_Initiation_Date !== "" &&
              item.q42_Therpy_Initiation_Radio === 1 &&
              item.q42_Therpy_Initiation_Date != "Invalid Date" &&
              DateInRange(
                item.q42_Therpy_Initiation_Date,
                dayjs("01-01-1920"),
                dayjs(),
              )
              // && repeaterItem.q41_Apheresis_Date !== "" && repeaterItem.q41_Apheresis_Date !=  "Invalid Date"
            ) {
              const dateIsvalid = checkTherapyDate(
                repeaterItem.q41_Apheresis_Date,
                item.q42_Therpy_Initiation_Date,
                repeaterItem.cohortIndexDate,
              );
              errors.q42_Therapy_Initiation_NotValid = !dateIsvalid;
              item.q42_Therapy_Initiation_NotValid = !dateIsvalid;

              if (dateIsvalid == false) {
                valid = false;
              }
            }

            if (item.q42_Therpy_Initiation_Date === "Invalid Date") {
              errors.q42_Therapy_Initiation_DateInvalid = true;
              item.q42_Therapy_Initiation_DateInvalid = true;
              valid = false;
            } else if (
              item.q42_Therpy_Initiation_Date !== "Invalid Date" &&
              item.q42_Therpy_Initiation_Date !== "" &&
              !DateInRange(
                item.q42_Therpy_Initiation_Date,
                dayjs("01-01-1920"),
                dayjs(),
              )
            ) {
              errors.q42_Therapy_Initiation_DateInvalid = true;
              item.q42_Therapy_Initiation_DateInvalid = true;
              valid = false;
            }
          }
        });

        // Validate q41
        if (
          repeaterItem.q41_Apheresis_DateRd == null ||
          (repeaterItem.q41_Apheresis_DateRd == 1 &&
            (repeaterItem.q41_Apheresis_Date == "" ||
              repeaterItem.q41_Apheresis_Date == null))
        ) {
          errors.q41_Apheresis_Date_Empty = true;
          repeaterItem.q41_Apheresis_Date_Empty = true;
          valid = false;
        }

        if (isNewEcrfA) {
          // Validate q41.1.A Site of Administration
          if (isStringEmpty(repeaterItem.q411A_Utilization)) {
            errors.q411A_Utilization_Empty = true;
            repeaterItem.q411A_Utilization_Empty = true;
            valid = false;
          }

          // Validate q41.1.A Single bag utilization
          if (isStringEmpty(repeaterItem.q411A_Administration)) {
            errors.q411A_Administration_Empty = true;
            repeaterItem.q411A_Administration_Empty = true;
            valid = false;
          }
        }

        if (
          (repeaterItem.q41_Apheresis_Date !== "" ||
            repeaterItem.q41_Apheresis_Date !== null) &&
          repeaterItem.q41_Apheresis_Date != "Invalid Date" &&
          DateInRange(
            repeaterItem.q41_Apheresis_Date,
            dayjs("01-01-1920"),
            dayjs(),
          )
          //  && repeaterItem.q41_Apheresis_Date_NotValid == true
        ) {
          const dateIsValid = validateQ41Date(
            repeaterItem.q41_Apheresis_Date,
            repeaterItem.cohortIndexDate,
          );
          errors.q41_Apheresis_Date_NotValid = true;
          repeaterItem.q41_Apheresis_Date_NotValid = !dateIsValid;
          if (dateIsValid == false) {
            valid = false;
          }
        }

        if (repeaterItem.q41_Apheresis_Date === "Invalid Date") {
          errors.q41_Apheresis_InvalidDate = true;
          repeaterItem.q41_Apheresis_InvalidDate = true;
          valid = false;
        } else if (
          repeaterItem.q41_Apheresis_Date !== "Invalid Date" &&
          repeaterItem.q41_Apheresis_Date !== "" &&
          !DateInRange(
            repeaterItem.q41_Apheresis_Date,
            dayjs("01-01-1920"),
            dayjs(),
          )
        ) {
          errors.q41_Apheresis_InvalidDate = true;
          repeaterItem.q41_Apheresis_InvalidDate = true;
          valid = false;
        }

        carTCharRepeater.forEach((parentItem) => {
          let cohortindexDate = parentItem.cohortIndexDate;
          let apheresisdate = parentItem.q41_Apheresis_Date;
          parentItem.carTTreatmentList.forEach((repeaterItem) => {
            const errors = {};
            // 1. q43B_No_Procedure_Rcvd required
            if (!repeaterItem.q43B_No_Procedure_Rcvd) {
              errors.q43B_No_Procedure_Rcvd_Empty = true;
              repeaterItem.q43B_No_Procedure_RcvdEmpty = true;
              valid = false;
            }

            // 2. Date required if procedure received
            if (
              repeaterItem.q43B_No_Procedure_Rcvd === 2 &&
              (!repeaterItem.q43B_Procedure_Date ||
                repeaterItem.q43B_Procedure_Date.trim() === "")
            ) {
              errors.q43B_Procedure_Date_Empty = true;
              repeaterItem.q43B_Procedure_DateEmpty = true;
              valid = false;
            }

            // 3. Date validity check
            if (
              repeaterItem.q43B_No_Procedure_Rcvd === 2 &&
              repeaterItem.q43B_Procedure_Date &&
              repeaterItem.q43B_Procedure_Date !== "Invalid Date"
            ) {
              const dateIsValid = DateInRange(
                repeaterItem.q43B_Procedure_Date,
                dayjs("01-01-1920"),
                dayjs(),
              );

              if (!dateIsValid) {
                errors.q43_Date_Valid = true;
                repeaterItem.q43_Date_Valid = true;
                valid = false;
              }
            }

            // 4. Explicit invalid date
            if (repeaterItem.q43B_Procedure_Date === "Invalid Date") {
              errors.q43_Procedure_InvalidDate = true;
              repeaterItem.q43_Procedure_InvalidDate = true;
              valid = false;
            }

            // 5. Out of date range
            if (
              repeaterItem.q43B_Procedure_Date &&
              repeaterItem.q43B_Procedure_Date !== "Invalid Date" &&
              !DateInRange(
                repeaterItem.q43B_Procedure_Date,
                dayjs("01-01-1920"),
                dayjs(),
              )
            ) {
              errors.q43_Procedure_InvalidDate = true;
              repeaterItem.q43_Procedure_InvalidDate = true;
              valid = false;
            }

            // 6. Procedure type required for 2 or 99
            if (
              [2, 99].includes(repeaterItem.q43B_No_Procedure_Rcvd) &&
              !repeaterItem.q43C_ProcedureType
            ) {
              errors.q43C_ProcedureType_Empty = true;
              repeaterItem.q43C_ProcedureTypeEmpty = true;
              valid = false;
            }

            // 7. "Other" requires text
            if (
              repeaterItem.q43C_ProcedureType === 7 &&
              (!repeaterItem.q43C_ProcedureType_Txt ||
                repeaterItem.q43C_ProcedureType_Txt.trim() === "")
            ) {
              errors.q43C_ProcedureType_Txt_Empty = true;
              repeaterItem.q43C_ProcedureType_TxtEmpty = true;
              valid = false;
            }

            // 8. Compare with followup dates
            if (
              repeaterItem.q43B_Procedure_Date &&
              repeaterItem.q43B_Procedure_Date !== "Invalid Date"
            ) {
              let ndmmEndoffollowupDate = "";

              if (parentItem.cohortTreatmentId === 13) {
                ndmmEndoffollowupDate = carTCharData.carvyktiFollowupDate;
              } else if (parentItem.cohortTreatmentId === 14) {
                ndmmEndoffollowupDate = carTCharData.abecmaFollowupDate;
              }

              if (!ndmmEndoffollowupDate) {
                ndmmEndoffollowupDate = carTCharData.endOfFollowupDate;
              }

              // const dateIsValid = validateQ43Date(
              //   repeaterItem.q43B_Procedure_Date,
              //   ndmmEndoffollowupDate,
              //   repeaterItem.cohortIndexDate,
              // );
              const subsequentLotStartDate =
                repeaterItem.treatmentId == 13
                  ? carTCharData.carvyktiNextLotDate
                  : carTCharData.abecmaNextLotDate;

              const dateIsValid = validateQ43_1_Date(
                repeaterItem.q43B_Procedure_Date,
                ndmmEndoffollowupDate,
                cohortindexDate,
                subsequentLotStartDate,
              );

              if (!dateIsValid) {
                errors.q43_Date_Valid = true;
                repeaterItem.q43_Date_Valid = true;
                valid = false;
              }
            }

            repeaterItem.errors = errors; // optional, for UI
          });

          if (isNewEcrfA) {
            parentItem.carTTreatmentTocilizumabList.forEach((repeaterItem) => {
              const errors = {};
              // 1. q43B_No_Procedure_Rcvd required
              if (!repeaterItem.q43_1B_No_Tocilizumab_Rcvd) {
                errors.q43_1B_No_Tocilizumab_RcvdEmpty = true;
                repeaterItem.q43_1B_No_Tocilizumab_RcvdEmpty = true;
                valid = false;
              }

              // 2. Date required if procedure received
              if (
                repeaterItem.q43_1B_No_Tocilizumab_Rcvd === 2 &&
                (!repeaterItem.q43_1B_Tocilizumab_Date ||
                  repeaterItem.q43_1B_Tocilizumab_Date.trim() === "")
              ) {
                errors.q43_1B_Tocilizumab_DateEmpty = true;
                repeaterItem.q43_1B_Tocilizumab_DateEmpty = true;
                valid = false;
              }

              // 3. Date validity check
              if (
                repeaterItem.q43_1B_No_Tocilizumab_Rcvd === 2 &&
                repeaterItem.q43_1B_Tocilizumab_Date &&
                repeaterItem.q43_1B_Tocilizumab_Date !== "Invalid Date"
              ) {
                const dateIsValid = DateInRange(
                  repeaterItem.q43_1B_Tocilizumab_Date,
                  dayjs("01-01-1920"),
                  dayjs(),
                );

                if (!dateIsValid) {
                  errors.q43_1_Date_Valid = true;
                  repeaterItem.q43_1_Date_Valid = true;
                  valid = false;
                }
              }

              // 4. Explicit invalid date
              if (repeaterItem.q43_1B_Tocilizumab_Date === "Invalid Date") {
                errors.q43_1_Tocilizumab_InvalidDate = true;
                repeaterItem.q43_1_Tocilizumab_InvalidDate = true;
                valid = false;
              }

              // 5. Out of date range
              if (
                repeaterItem.q43_1B_Tocilizumab_Date &&
                repeaterItem.q43_1B_Tocilizumab_Date !== "Invalid Date" &&
                !DateInRange(
                  repeaterItem.q43_1B_Tocilizumab_Date,
                  dayjs("01-01-1920"),
                  dayjs(),
                )
              ) {
                errors.q43_Procedure_InvalidDate = true;
                repeaterItem.q43_Procedure_InvalidDate = true;
                valid = false;
              }

              // 6. Procedure type required for 2 or 99
              if (
                [2, 99].includes(repeaterItem.q43_1B_No_Tocilizumab_Rcvd) &&
                !repeaterItem.q43_1C_cytokin &&
                !repeaterItem.q43_1C_secondary_prophylactic_crs &&
                !repeaterItem.q43_1C_crs &&
                !repeaterItem.q43_1C_primary_prophylactic &&
                !repeaterItem.q43_1C_secondary_prophylactic &&
                !repeaterItem.q43_1C_tmt_neurologic &&
                !repeaterItem.q43_1C_reason_other &&
                !repeaterItem.q43_1C_reason_unknown
              ) {
                errors.q43_1C_ReasonEmpty = true;
                repeaterItem.q43_1C_ReasonEmpty = true;
                valid = false;
              }

              // 8. Compare with followup dates
              if (
                repeaterItem.q43_1B_Tocilizumab_Date &&
                repeaterItem.q43_1B_Tocilizumab_Date !== "Invalid Date"
              ) {
                let ndmmEndoffollowupDate = "";

                // if (parentItem.cohortTreatmentId === 13) {
                //   ndmmEndoffollowupDate = carTCharData.carvyktiFollowupDate;
                // } else if (parentItem.cohortTreatmentId === 14) {
                //   ndmmEndoffollowupDate = carTCharData.abecmaFollowupDate;
                // }

                //if (!ndmmEndoffollowupDate) {
                ndmmEndoffollowupDate = carTCharData.endOfFollowupDate;
                const subsequentLotStartDate =
                  repeaterItem.treatmentId == 13
                    ? carTCharData.carvyktiNextLotDate
                    : carTCharData.abecmaNextLotDate;
                // }

                const dateIsValid = validateQ43_1_Date(
                  repeaterItem.q43_1B_Tocilizumab_Date,
                  ndmmEndoffollowupDate,
                  cohortindexDate,
                  subsequentLotStartDate,
                );

                if (!dateIsValid) {
                  errors.q43_1_Date_Valid = true;
                  repeaterItem.q43_1_Date_Valid = true;
                  valid = false;
                }
              }

              repeaterItem.errors = errors; // optional, for UI
            });

            parentItem.carTTreatmentMitigationList.forEach((repeaterItem) => {
              const errors = {};

              // 1. Neurologic type required for 2 or 99
              if (!repeaterItem.q43_3B_NeurologicType) {
                errors.q43_3B_NeurologicTypeEmpty = true;
                repeaterItem.q43_3B_NeurologicTypeEmpty = true;
                valid = false;
              }

              // 2. "Other" requires text
              if (
                repeaterItem.q43_3B_NeurologicType === 8 &&
                (!repeaterItem.q43_3B_NeurologicType_Txt ||
                  repeaterItem.q43_3B_NeurologicType_Txt.trim() === "")
              ) {
                errors.q43_3B_NeurologicType_TxtEmpty = true;
                repeaterItem.q43_3B_NeurologicType_TxtEmpty = true;
                valid = false;
              }
              // 3.  requires text
              if (
                !repeaterItem.q43_3C_Mitigation_Txt ||
                repeaterItem.q43_3C_Mitigation_Txt.trim() === ""
              ) {
                errors.q43_3C_Mitigation_TxtEmpty = true;
                repeaterItem.q43_3C_Mitigation_TxtEmpty = true;
                valid = false;
              }

              repeaterItem.errors = errors; // optional, for UI
            });

            parentItem.carTTreatmentLymphocyteList.forEach((repeaterItem) => {
              const errors = {};
              // 1. q43_4B_No_Assessment_Rcvd required
              if (!repeaterItem.q43_4B_No_Assessment_Rcvd) {
                errors.q43_4B_No_Assessment_RcvdEmpty = true;
                repeaterItem.q43_4B_No_Assessment_RcvdEmpty = true;
                valid = false;
              }

              // 2. Date required if lymphocyte received
              if (
                repeaterItem.q43_4B_No_Assessment_Rcvd === 1 &&
                (!repeaterItem.q43_4B_Assessment_Date ||
                  repeaterItem.q43_4B_Assessment_Date.trim() === "")
              ) {
                errors.q43_4B_Assessment_DateEmpty = true;
                repeaterItem.q43_4B_Assessment_DateEmpty = true;
                valid = false;
              }

              // 3. Date validity check
              if (
                repeaterItem.q43_4B_No_Assessment_Rcvd === 1 &&
                repeaterItem.q43_4B_Assessment_Date &&
                repeaterItem.q43_4B_Assessment_Date !== "Invalid Date"
              ) {
                const dateIsValid = DateInRange(
                  repeaterItem.q43_4B_Assessment_Date,
                  dayjs("01-01-1920"),
                  dayjs(),
                );

                if (!dateIsValid) {
                  errors.q43_4_Date_Valid = true;
                  repeaterItem.q43_4_Date_Valid = true;
                  valid = false;
                }
              }

              // 4. Explicit invalid date
              if (repeaterItem.q43_4B_Assessment_Date === "Invalid Date") {
                errors.q43_4_Assessment_InvalidDate = true;
                repeaterItem.q43_4_Assessment_InvalidDate = true;
                valid = false;
              }

              // 5. Out of date range
              if (
                repeaterItem.q43_4B_Assessment_Date &&
                repeaterItem.q43_4B_Assessment_Date !== "Invalid Date" &&
                !DateInRange(
                  repeaterItem.q43_4B_Assessment_Date,
                  dayjs("01-01-1920"),
                  dayjs(),
                )
              ) {
                errors.q43_4_Assessment_InvalidDate = true;
                repeaterItem.q43_4_Assessment_InvalidDate = true;
                valid = false;
              }

              // 6. Measurement required for 2
              if (
                [1].includes(repeaterItem.q43_4B_No_Assessment_Rcvd) &&
                !repeaterItem.q43_4C_MeasurementValue
              ) {
                errors.q43_4C_MeasurementEmpty = true;
                repeaterItem.q43_4C_MeasurementEmpty = true;
                valid = false;
              }

              // 7. "Measurement" requires value
              if (
                repeaterItem.q43_4C_MeasurementValue === 1 &&
                (!repeaterItem.q43_4C_Measurement_ul ||
                  repeaterItem.q43_4C_Measurement_ul === null)
              ) {
                errors.q43_4C_Measurement_TxtEmpty = true;
                repeaterItem.q43_4C_Measurement_TxtEmpty = true;
                valid = false;
              } else {
                const regex = /^\d+(\.\d{0,2})?$/;
                if (regex.test(repeaterItem.q43_4C_Measurement_ul)) {
                  const num = Number(repeaterItem.q43_4C_Measurement_ul);

                  if (num <= 0 || num > 600000) {
                    errors.q43_4C_Measurement_ulRange = true;
                    repeaterItem.q43_4C_Measurement_ulRange = true;
                    valid = false;
                  }
                }
              }

              if (
                repeaterItem.q43_4C_MeasurementValue === 2 &&
                (!repeaterItem.q43_4C_Measurement_mm ||
                  repeaterItem.q43_4C_Measurement_mm === null)
              ) {
                errors.q43_4C_Measurement_TxtEmpty = true;
                repeaterItem.q43_4C_Measurement_TxtEmpty = true;
                valid = false;
              } else {
                const regex = /^\d+(\.\d{0,2})?$/;
                if (regex.test(repeaterItem.q43_4C_Measurement_mm)) {
                  const num = Number(repeaterItem.q43_4C_Measurement_mm);

                  if (num <= 0 || num > 600000) {
                    errors.q43_4C_Measurement_mmRange = true;
                    repeaterItem.q43_4C_Measurement_mmRange = true;
                    valid = false;
                  }
                }
              }

              if (
                repeaterItem.q43_4C_MeasurementValue === 3 &&
                (!repeaterItem.q43_4C_Measurement_xl ||
                  repeaterItem.q43_4C_Measurement_xl === null)
              ) {
                errors.q43_4C_Measurement_TxtEmpty = true;
                repeaterItem.q43_4C_Measurement_TxtEmpty = true;
                valid = false;
              } else {
                const regex = /^\d+(\.\d{0,2})?$/;
                if (regex.test(repeaterItem.q43_4C_Measurement_xl)) {
                  const num = Number(repeaterItem.q43_4C_Measurement_xl);

                  if (num <= 0 || num > 600) {
                    errors.q43_4C_Measurement_xlRange = true;
                    repeaterItem.q43_4C_Measurement_xlRange = true;
                    valid = false;
                  }
                }
              }

              // 8. Compare with followup dates
              if (
                repeaterItem.q43_4B_Assessment_Date &&
                repeaterItem.q43_4B_Assessment_Date !== "Invalid Date"
              ) {
                let ndmmEndoffollowupDate = "";

                if (parentItem.cohortTreatmentId === 13) {
                  ndmmEndoffollowupDate = carTCharData.carvyktiFollowupDate;
                } else if (parentItem.cohortTreatmentId === 14) {
                  ndmmEndoffollowupDate = carTCharData.abecmaFollowupDate;
                }

                if (!ndmmEndoffollowupDate) {
                  ndmmEndoffollowupDate = carTCharData.endOfFollowupDate;
                }

                // const dateIsValid = validateQ43Date(
                //   repeaterItem.q43B_Procedure_Date,
                //   ndmmEndoffollowupDate,
                //   repeaterItem.cohortIndexDate,
                // );

                const indexaddthirty =
                  repeaterItem.treatmentId == 13
                    ? carTCharData.carvyktiIndexAddThirtyDate
                    : carTCharData.abecmaIndexAddThirtyDate;
                const dateIsValid = validateQ43_4_Date(
                  repeaterItem.q43_4B_Assessment_Date,
                  ndmmEndoffollowupDate,
                  apheresisdate,
                  indexaddthirty,
                );

                if (!dateIsValid) {
                  errors.q43_4_Date_Valid = true;
                  repeaterItem.q43_4_Date_Valid = true;
                  valid = false;
                }
              }

              repeaterItem.errors = errors; // optional, for UI
            });

            parentItem.carTTreatmentCorticosteroidList.forEach(
              (repeaterItem) => {
                const errors = {};
                // 1. q43B_No_Procedure_Rcvd required
                if (!repeaterItem.q43_2B_No_Corticosteroid_Rcvd) {
                  errors.q43_2B_No_Corticosteroid_RcvdEmpty = true;
                  repeaterItem.q43_2B_No_Corticosteroid_RcvdEmpty = true;
                  valid = false;
                }

                // 2. Date required if procedure received
                if (
                  repeaterItem.q43_2B_No_Corticosteroid_Rcvd === 2 &&
                  (!repeaterItem.q43_2B_Corticosteroid_Date ||
                    repeaterItem.q43_2B_Corticosteroid_Date.trim() === "")
                ) {
                  errors.q43_2B_Corticosteroid_DateEmpty = true;
                  repeaterItem.q43_2B_Corticosteroid_DateEmpty = true;
                  valid = false;
                }

                // 3. Date validity check
                if (
                  repeaterItem.q43_2B_No_Corticosteroid_Rcvd === 2 &&
                  repeaterItem.q43_2B_Corticosteroid_Date &&
                  repeaterItem.q43_2B_Corticosteroid_Date !== "Invalid Date"
                ) {
                  const dateIsValid = DateInRange(
                    repeaterItem.q43_2B_Corticosteroid_Date,
                    dayjs("01-01-1920"),
                    dayjs(),
                  );

                  if (!dateIsValid) {
                    errors.q43_2_Date_Valid = true;
                    repeaterItem.q43_2_Date_Valid = true;
                    valid = false;
                  }
                }

                // 4. Explicit invalid date
                if (
                  repeaterItem.q43_2B_Corticosteroid_Date === "Invalid Date"
                ) {
                  errors.q43_2_Corticosteroid_InvalidDate = true;
                  repeaterItem.q43_2_Corticosteroid_InvalidDate = true;
                  valid = false;
                }

                // 5. Out of date range
                if (
                  repeaterItem.q43_2B_Corticosteroid_Date &&
                  repeaterItem.q43_2B_Corticosteroid_Date !== "Invalid Date" &&
                  !DateInRange(
                    repeaterItem.q43_2B_Corticosteroid_Date,
                    dayjs("01-01-1920"),
                    dayjs(),
                  )
                ) {
                  errors.q43_2_Corticosteroid_InvalidDate = true;
                  repeaterItem.q43_2_Corticosteroid_InvalidDate = true;
                  valid = false;
                }

                // 6. Corticosteroid type required for 2 or 99
                if (
                  [2, 99].includes(
                    repeaterItem.q43_2B_No_Corticosteroid_Rcvd,
                  ) &&
                  !repeaterItem.q43_2C_CorticosteroidType
                ) {
                  errors.q43_2C_CorticosteroidType_Empty = true;
                  repeaterItem.q43_2C_CorticosteroidType_Empty = true;
                  valid = false;
                }

                // 6. Dosestrength required for 2  or 99
                if (
                  [2, 99].includes(
                    repeaterItem.q43_2B_No_Corticosteroid_Rcvd,
                  ) &&
                  !repeaterItem.q43_2D_DoseStrength
                ) {
                  errors.q43_2D_DoseStrength_Empty = true;
                  repeaterItem.q43_2D_DoseStrength_Empty = true;
                  valid = false;
                }

                // 7. "DoseStrength" requires value
                if (
                  repeaterItem.q43_2D_DoseStrength === 1 &&
                  (!repeaterItem.q43_2D_DoseStrength_mg ||
                    repeaterItem.q43_2D_DoseStrength_mg === null)
                ) {
                  errors.q43_2D_DoseStrength_TxtEmpty = true;
                  repeaterItem.q43_2D_DoseStrength_TxtEmpty = true;
                  valid = false;
                } else {
                  const regex = /^\d+(\.\d{0,2})?$/;
                  if (regex.test(repeaterItem.q43_2D_DoseStrength_mg)) {
                    const num = Number(repeaterItem.q43_2D_DoseStrength_mg);

                    if (num <= 0 || num > 4000) {
                      errors.q43_2D_DoseStrengthMGRange = true;
                      repeaterItem.q43_2D_DoseStrengthMGRange = true;
                      valid = false;
                    }
                  }
                }

                if (
                  repeaterItem.q43_2D_DoseStrength === 2 &&
                  (!repeaterItem.q43_2D_DoseStrength_kg ||
                    repeaterItem.q43_2D_DoseStrength_kg === null)
                ) {
                  errors.q43_2D_DoseStrength_TxtEmpty = true;
                  repeaterItem.q43_2D_DoseStrength_TxtEmpty = true;
                  valid = false;
                } else {
                  const regex = /^\d+(\.\d{0,2})?$/;
                  if (regex.test(repeaterItem.q43_2D_DoseStrength_kg)) {
                    const num = Number(repeaterItem.q43_2D_DoseStrength_kg);

                    if (num <= 0 || num > 60) {
                      errors.q43_2D_DoseStrengthKGRange = true;
                      repeaterItem.q43_2D_DoseStrengthKGRange = true;
                      valid = false;
                    }
                  }
                }

                if (
                  repeaterItem.q43_2D_DoseStrength === 3 &&
                  (!repeaterItem.q43_2D_DoseStrength_other ||
                    repeaterItem.q43_2D_DoseStrength_other === null)
                ) {
                  errors.q43_2D_DoseStrength_TxtEmpty = true;
                  repeaterItem.q43_2D_DoseStrength_TxtEmpty = true;
                  valid = false;
                }

                if (
                  [2, 99].includes(repeaterItem.q43_2B_No_Corticosteroid_Rcvd)
                ) {
                  if (
                    repeaterItem.q43_2E_selectedReasonCorticosteroid.length > 0
                  ) {
                    if (
                      repeaterItem.q43_2E_selectedReasonCorticosteroid?.some(
                        (item) =>
                          item.cartcharacteristicscorticosteroidreasonid ===
                          reasonCorticosteroidOtherID,
                      ) &&
                      (repeaterItem.q43_2E_Reason_otherneurologic_Txt ===
                        undefined ||
                        repeaterItem.q43_2E_Reason_otherneurologic_Txt ===
                          null ||
                        repeaterItem.q43_2E_Reason_otherneurologic_Txt.trim() ===
                          "")
                    ) {
                      errors.q43_2E_Reason_TxtEmpty = true;
                      repeaterItem.q43_2E_Reason_TxtEmpty = true;
                      valid = false;
                    } else if (
                      repeaterItem.q43_2E_selectedReasonCorticosteroid?.some(
                        (item) =>
                          item.cartcharacteristicscorticosteroidreasonid === 3,
                      ) && //ae selected
                      !repeaterItem.q43_2E_selectedReasonCorticosteroid?.some(
                        (item) =>
                          item.cartcharacteristicscorticosteroidreasonid >= 4 &&
                          item.cartcharacteristicscorticosteroidreasonid <= 20,
                      )
                    ) {
                      errors.q43_2E_Reason_AEEmpty = true;
                      repeaterItem.q43_2E_Reason_AEEmpty = true;
                      valid = false;
                    } else if (
                      repeaterItem.q43_2E_selectedReasonCorticosteroid?.some(
                        (item) =>
                          item.cartcharacteristicscorticosteroidreasonid === 6,
                      ) && //ae selected
                      !repeaterItem.q43_2E_selectedReasonCorticosteroid?.some(
                        (item) =>
                          item.cartcharacteristicscorticosteroidreasonid >= 7 &&
                          item.cartcharacteristicscorticosteroidreasonid <= 13,
                      )
                    ) {
                      errors.q43_2E_Reason_NeurologicEmpty = true;
                      repeaterItem.q43_2E_Reason_NeurologicEmpty = true;
                      valid = false;
                    }
                  } else {
                    errors.q43_2E_ReasonEmpty = true;
                    repeaterItem.q43_2E_ReasonEmpty = true;
                    valid = false;
                  }
                }

                // 8. Compare with followup dates
                if (
                  repeaterItem.q43_2B_Corticosteroid_Date &&
                  repeaterItem.q43_2B_Corticosteroid_Date !== "Invalid Date"
                ) {
                  let ndmmEndoffollowupDate = "";

                  if (parentItem.cohortTreatmentId === 13) {
                    ndmmEndoffollowupDate = carTCharData.carvyktiFollowupDate;
                  } else if (parentItem.cohortTreatmentId === 14) {
                    ndmmEndoffollowupDate = carTCharData.abecmaFollowupDate;
                  }

                  if (!ndmmEndoffollowupDate) {
                    ndmmEndoffollowupDate = carTCharData.endOfFollowupDate;
                  }

                  // const dateIsValid = validateQ43Date(
                  //   repeaterItem.q43B_Procedure_Date,
                  //   ndmmEndoffollowupDate,
                  //   repeaterItem.cohortIndexDate,
                  // );
                  const subsequentLotStartDate =
                    repeaterItem.treatmentId == 13
                      ? carTCharData.carvyktiNextLotDate
                      : carTCharData.abecmaNextLotDate;

                  const dateIsValid = validateQ43_1_Date(
                    repeaterItem.q43_2B_Corticosteroid_Date,
                    ndmmEndoffollowupDate,
                    cohortindexDate,
                    subsequentLotStartDate,
                  );

                  if (!dateIsValid) {
                    errors.q43_2_Date_Valid = true;
                    repeaterItem.q43_2_Date_Valid = true;
                    valid = false;
                  }
                }

                repeaterItem.errors = errors; // optional, for UI
              },
            );
          }
        });

        //Q42 Date Validation. R2 > R1

        if (
          !repeaterItem.q42_Therapy_Initiation_NotValid &&
          repeaterItem.carTCharacteristicsTypeList[0]
            ?.q42_Therpy_Initiation_Date !== "Invalid Date" &&
          repeaterItem.carTCharacteristicsTypeList[1]
            ?.q42_Therpy_Initiation_Date !== "Invalid Date"
        ) {
          const r1Date =
            repeaterItem.carTCharacteristicsTypeList[0]
              ?.q42_Therpy_Initiation_Date;
          const r2Date =
            repeaterItem.carTCharacteristicsTypeList[1]
              ?.q42_Therpy_Initiation_Date;

          if (r1Date && r2Date) {
            const date1 = new Date(r1Date);
            const date2 = new Date(r2Date);

            // Check if both dates are valid Date objects
            if (!isNaN(date1) && !isNaN(date2)) {
              if (
                date1 > date2 &&
                repeaterItem.carTCharacteristicsTypeList[1]
                  .q42_R2_Date_Not_Valid == false
              ) {
                errors.q42_R2_Date_Not_Valid = true;
                repeaterItem.carTCharacteristicsTypeList[1].q42_R2_Date_Not_Valid = true;
                valid = false;
              } else {
                repeaterItem.carTCharacteristicsTypeList[1].q42_R2_Date_Not_Valid = false;
              }
            } else {
              // Handle cases where the date strings are not valid
            }
          }
        }

        if (isNewEcrfA) {
          //Q42.1.A
          carTCharRepeater.forEach((parentItem) => {
            parentItem.carTBridgingTherapyList.forEach((repeaterItem) => {
              const errors = {};
              // 1. q421A_Start_Bridging_Therapy required
              if (repeaterItem.q421A_Start_Bridging_Therapy === null) {
                errors.q421A_Start_Bridging_Therapy_Empty = true;
                repeaterItem.q421A_Start_Bridging_Therapy_Empty = true;
                valid = false;
              }

              if (repeaterItem.q421A_Start_Bridging_Therapy > 1) {
                if (
                  repeaterItem.q421A_Start_Bridging_Therapy === 2 &&
                  (!repeaterItem.q421A_Start_Bridging_Therapy_Date ||
                    repeaterItem.q421A_Start_Bridging_Therapy_Date.trim() ===
                      "")
                ) {
                  errors.q421A_Start_Bridging_TherapyDate_Empty = true;
                  repeaterItem.q421A_Start_Bridging_TherapyDate_Empty = true;
                  valid = false;
                }

                // 2. q421A_End_Bridging_Therapy required
                if (repeaterItem.q421A_End_Bridging_Therapy === null) {
                  errors.q421A_End_Bridging_Therapy_Empty = true;
                  repeaterItem.q421A_End_Bridging_Therapy_Empty = true;
                  valid = false;
                }

                if (
                  repeaterItem.q421A_End_Bridging_Therapy === 1 &&
                  (!repeaterItem.q421A_End_Bridging_Therapy_Date ||
                    repeaterItem.q421A_End_Bridging_Therapy_Date.trim() === "")
                ) {
                  errors.q421A_End_Bridging_TherapyDate_Empty = true;
                  repeaterItem.q421A_End_Bridging_TherapyDate_Empty = true;
                  valid = false;
                }

                // 3. q421A_BestResponse_Status required
                if (repeaterItem.q421A_BestResponse_Status === null) {
                  errors.q421A_BestResponse_Status_Empty = true;
                  repeaterItem.q421A_BestResponse_Status_Empty = true;
                  valid = false;
                }

                // 4. q421A_BestResponse_Assessment required
                if (repeaterItem.q421A_BestResponse_Assessment === null) {
                  errors.q421A_BestResponse_Assessment_Empty = true;
                  repeaterItem.q421A_BestResponse_Assessment_Empty = true;
                  valid = false;
                }

                if (repeaterItem.q421A_BestResponse_Assessment !== 8) {
                  if (
                    repeaterItem.q421A_BestResponse_Assessment === 1 &&
                    (!repeaterItem.q421A_BestResponse_Assessment_Date ||
                      repeaterItem.q421A_BestResponse_Assessment_Date.trim() ===
                        "")
                  ) {
                    errors.q421A_BestResponse_AssessmentDate_Empty = true;
                    repeaterItem.q421A_BestResponse_AssessmentDate_Empty = true;
                    valid = false;
                  }

                  // 5. q421A_Method_Assessment required
                  if (repeaterItem.q421A_Method_Assessment === null) {
                    errors.q421A_Method_Assessment_Empty = true;
                    repeaterItem.q421A_Method_Assessment_Empty = true;
                    valid = false;
                  }
                }
              }

              let cohortData = carTCharRepeater.filter(
                (item1) => item1.cohortTreatmentId == repeaterItem.treatmentId,
              );

              let lymphodepletionDate = isNewEcrfA
                ? cohortData[0].carTCharacteristicsTypeList.filter(
                    (item1) => item1.carTTherapyId == 2,
                  )
                : cohortData[0].carTCharacteristicsTypeList
                    .map((item) => item.q42_Therpy_Initiation_Date)
                    .filter(Boolean)
                    .sort((a, b) => new Date(a) - new Date(b));

              let cohortIndexDateByTreatmentId = filteredList.filter(
                (item) => item.cohortTreatmentID == repeaterItem.treatmentId,
              );

              if (
                !isStringEmpty(repeaterItem.q421A_Start_Bridging_Therapy_Date)
              ) {
                //Date validations for Q42.1.A Col A
                const dateStartIsValid = validateQ421ADate(
                  repeaterItem.q421A_Start_Bridging_Therapy_Date,
                  null,
                  lymphodepletionDate[0].q42_Therpy_Initiation_Date,
                  cohortIndexDateByTreatmentId[0].cohortIndexDate,
                );
                errors.q421A_Start_Bridging_TherapyDate_Invalid = true;
                repeaterItem.q421A_Start_Bridging_TherapyDate_Invalid =
                  !dateStartIsValid;
                if (dateStartIsValid == false) {
                  valid = false;
                }
              }

              if (repeaterItem.q421A_Start_Bridging_Therapy > 1) {
                if (
                  !isStringEmpty(repeaterItem.q421A_End_Bridging_Therapy_Date)
                ) {
                  //Date validations for Q42.1.A Col A & Col B
                  const dateIsValid = validateQ421ADate(
                    repeaterItem.q421A_Start_Bridging_Therapy_Date,
                    repeaterItem.q421A_End_Bridging_Therapy_Date,
                    lymphodepletionDate[0].q42_Therpy_Initiation_Date,
                    cohortIndexDateByTreatmentId[0].cohortIndexDate,
                  );
                  errors.q421A_End_Bridging_TherapyDate_Invalid = true;
                  repeaterItem.q421A_End_Bridging_TherapyDate_Invalid =
                    !dateIsValid;
                  if (dateIsValid == false) {
                    valid = false;
                  }
                }
              }

              if (
                repeaterItem.q421A_Start_Bridging_Therapy > 1 &&
                repeaterItem.q421A_BestResponse_Assessment !== 8
              ) {
                if (
                  !isStringEmpty(
                    repeaterItem.q421A_BestResponse_Assessment_Date,
                  )
                ) {
                  //Date validations for Q42.1.A Col A & Col E
                  const dateColEIsValid = validateQ421ADate(
                    repeaterItem.q421A_Start_Bridging_Therapy_Date,
                    repeaterItem.q421A_BestResponse_Assessment_Date,
                    lymphodepletionDate[0].q42_Therpy_Initiation_Date,
                    cohortIndexDateByTreatmentId[0].cohortIndexDate,
                  );
                  errors.q421A_BestResponse_AssessmentDate_Invalid = true;
                  repeaterItem.q421A_BestResponse_AssessmentDate_Invalid =
                    !dateColEIsValid;
                  if (dateColEIsValid == false) {
                    valid = false;
                  }
                }
              }

              if (repeaterItem.q421A_Start_Bridging_Therapy > 1) {
                const selectedList =
                  repeaterItem.q421A_selectedReceivedTmtList ?? [];

                if (
                  selectedList.length === 0 &&
                  !repeaterItem.q421A_rb_received_tmt_unk
                ) {
                  if (
                    repeaterItem.q421A_selectedReceivedTmtList?.includes(
                      receivedTmtOtherID,
                    )
                  ) {
                    errors.q421A_txt_empty_err = true;
                    repeaterItem.q421A_txt_empty_err = true;
                    valid = false;
                  } else {
                    errors.q421A_empty_err = true;
                    repeaterItem.q421A_empty_err = true;
                    valid = false;
                  }
                } else {
                  const hasOther36WithEmptyText =
                    repeaterItem.q421A_selectedReceivedTmtList?.some(
                      (item) =>
                        item.prescribedTreatmentId === 36 &&
                        (!item.prescribedTreatmentOthTxt ||
                          item.prescribedTreatmentOthTxt.trim() === ""),
                    );

                  if (hasOther36WithEmptyText) {
                    errors.q421A_txt_empty_err = true;
                    repeaterItem.q421A_txt_empty_err = true;
                    valid = false;
                  }
                }
              }

              repeaterItem.errors = errors; // optional, for UI
            });
          });
        }
      });
    }

    setCarTCharRepeater([...carTCharRepeater]);

    return valid;
  };

  useEffect(() => {
    LoadData();
  }, []);

  async function LoadData() {
    try {
      if (pid > 0) {
        ToggleLoader(true);
        const response =
          await AdditionalTreatmentService.LoadCarTCharacteristics(pid);
        ToggleLoader(false);

        const cohortTreatmentModelList = response.data.cohortTreatmentModelList;

        const bispecificDates = cohortTreatmentModelList
          .map((entry) => new Date(entry.cohortIndexDate))
          .reduce((max, date) => (date > max ? date : max), new Date(0));

        const formattedDate = `${
          bispecificDates.getMonth() + 1
        }/${bispecificDates.getDate()}/${bispecificDates.getFullYear()}`;

        setBispecificDate(formattedDate);

        if (response?.status === HTTPResponse.OK) {
          const carTCharData = response.data;

          const prescribedTreatmentList = carTCharData.prescribedTreatmentList;
          const reasonCorticosteroidList =
            carTCharData.reasonCorticosteroidList;

          if (
            prescribedTreatmentList != null &&
            prescribedTreatmentList.length > 0
          ) {
            setReceivedTreatments(prescribedTreatmentList);

            //Get the ID of "Other" checkbox
            const othTmt = prescribedTreatmentList
              .find((item) => item.category === null)
              ?.treatments.find((tmt) => tmt.name === "Other, please specify");
            if (othTmt) {
              setReceivedTmtOtherID(othTmt.prescribedTreatmentId);
            }
          }

          if (
            reasonCorticosteroidList != null &&
            reasonCorticosteroidList.length > 0
          ) {
            setreasonCorticosteroidUsage(reasonCorticosteroidList);
            //Get the ID of "Other" checkbox
            const othTmt = reasonCorticosteroidList.find(
              (tmt) => tmt.name === "Other neurologic event, please specify: ",
            );
            if (othTmt) {
              setreasonCorticosteroidOtherID(
                othTmt.cartcharacteristicscorticosteroidreasonid,
              );
            }
          }

          if (carTCharData) {
            setCarTCharData((prev) => ({
              ...prev,
              CartcharacteristicsId: carTCharData.cartcharacteristicsid,
              CohortTreatmentId: carTCharData.cohorttreatmentid,
              endOfFollowupDate: carTCharData.endOfFollowUpDate,

              carvyktiFollowupDate: carTCharData.carvyktiFollowupDate,
              abecmaFollowupDate: carTCharData.abecmaFollowupDate,
              carvyktiNextLotDate: carTCharData.carvyktiNextLOTDate,
              abecmaNextLotDate: carTCharData.abecmaNextLOTDate,
              carvyktiIndexAddThirtyDate:
                carTCharData.carvyktiIndexAddThirtyDays,
              abecmaIndexAddThirtyDate: carTCharData.abecmaIndexAddThirtyDays,
              carvyktiIndexMinusThirtyDate:
                carTCharData.carvyktiIndexMinusThirtyDate,
              abecmaIndexMinusThirtyDate:
                carTCharData.abecmaIndexMinusThirtyDate,
            }));

            setIsNewEcrfA(carTCharData.isNewEcrfA ?? false);

            if (
              carTCharData.cohortTreatmentModelList &&
              carTCharData.cohortTreatmentModelList.length !== 0
            ) {
              const repeaterData = carTCharData.cohortTreatmentModelList.map(
                (item) => {
                  const carTCharacteristicsTypeList =
                    item.carTCharacteristicsTypeList.map((typeItem) => ({
                      carTTherapyId: typeItem.carTtherapyId,
                      carTtherapyName: typeItem.carTtherapyName,
                      carTCharacteristicsProcedureBridgeId: null,
                      q42_Therapy_Receive: typeItem.therapyReceived,
                      q42_Therpy_Initiation_Date:
                        typeItem.therapyInitiationDate || "",
                      q42_Therpy_Initiation_Radio:
                        typeItem.therapyInitiationDateUnk
                          ? 99
                          : !isStringEmpty(typeItem.therapyInitiationDate)
                            ? 1
                            : null,
                      q42_CohortTreatment_Unk: typeItem.cohortTreatmentUnk
                        ? 99
                        : null,

                      q42_Therpy_Initiation_Date_Empty: false,
                      q42_Therpy_Initiation_Radio_Empty: false,
                      q42_Therapy_Receive_Empty: false,

                      q42_R2_Date_Not_Valid: false,
                      q42_Therapy_Initiation_NotValid: false,
                      therapyReceivedEmpty: false,
                      q42_Therapy_Initiation_DateInvalid: false,
                      //q43B_No_Procedure_RcvdEmpty: false,
                    }));

                  const carTCharacteristicsReceivedList =
                    item.carTCharacteristicsReceivedList.map((typeItem) => ({
                      carTtherapyId: typeItem.carTtherapyId,
                      carTtherapyReceivedName: typeItem.carTtherapyReceivedName,
                      carTTherapyReceivedId: typeItem.carTTherapyReceivedId,
                      isChecked: typeItem.isChecked,
                      carTOtherTxt: typeItem.carTOtherTxt,
                      carTOtherTxtEmpty: false,
                      isCheckedEmpty: false,
                    }));

                  //Q42.1.A
                  const carTBridgingTherapyList =
                    item.carTBridgingTherapyList?.length > 0
                      ? item.carTBridgingTherapyList.map((typeItem) => ({
                          carTBridgingTherapyId: item.carTBridgingTherapyId,
                          treatmentId: item.cohortTreatmentID,
                          treatmentName: item.cohortTreatmentName,
                          q421A_Start_Bridging_Therapy: !isStringEmpty(
                            typeItem.bridgingTherapyStartDate,
                          )
                            ? 2
                            : typeItem.bridgingTherapyStart,
                          q421A_Start_Bridging_Therapy_Date:
                            typeItem.bridgingTherapyStartDate,
                          q421A_Start_Bridging_Therapy_Empty: false,
                          q421A_Start_Bridging_TherapyDate_Empty: false,
                          q421A_Start_Bridging_TherapyDate_Invalid: false,
                          q421A_End_Bridging_Therapy: !isStringEmpty(
                            typeItem.bridgingTherapyEndDate,
                          )
                            ? 1
                            : typeItem.bridgingTherapyEnd,
                          q421A_End_Bridging_Therapy_Date:
                            typeItem.bridgingTherapyEndDate,
                          q421A_End_Bridging_Therapy_Empty: false,
                          q421A_End_Bridging_TherapyDate_Empty: false,
                          q421A_End_Bridging_TherapyDate_Invalid: false,
                          q421A_BestResponse_Status:
                            typeItem.bestResponseStatus,
                          q421A_BestResponse_Status_Empty: false,
                          q421A_BestResponse_Assessment: !isStringEmpty(
                            typeItem.bestResponseAssessmentDate,
                          )
                            ? 1
                            : typeItem.bestResponseAssessment,
                          q421A_BestResponse_Assessment_Date:
                            typeItem.bestResponseAssessmentDate,
                          q421A_BestResponse_Assessment_Empty: false,
                          q421A_BestResponse_AssessmentDate_Empty: false,
                          q421A_BestResponse_AssessmentDate_Invalid: false,
                          q421A_Method_Assessment: typeItem.methodAssessment,
                          q421A_Method_Assessment_Empty: false,

                          // RECEIVED TREATMENT FLAGS
                          q421A_rb_received_tmt_unk:
                            typeItem.therapyReceivedUnknown ?? false,
                          // SELECTED TREATMENTS LIST
                          q421A_selectedReceivedTmtList:
                            typeItem.selectedPrescribedTreatmentList ?? [],
                          q421A_empty_err: false,
                          q421A_txt_empty_err: false,
                        }))
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,
                            q421A_Start_Bridging_Therapy: null,
                            q421A_Start_Bridging_Therapy_Empty: false,
                            q421A_Start_Bridging_TherapyDate_Empty: false,
                            q421A_Start_Bridging_TherapyDate_Invalid: false,
                            q421A_End_Bridging_Therapy: null,
                            q421A_End_Bridging_Therapy_Date: "",
                            q421A_End_Bridging_Therapy_Empty: false,
                            q421A_End_Bridging_TherapyDate_Empty: false,
                            q421A_End_Bridging_TherapyDate_Invalid: false,
                            q421A_BestResponse_Status: null,
                            q421A_BestResponse_Status_Empty: false,
                            q421A_BestResponse_Assessment: null,
                            q421A_BestResponse_Assessment_Date: "",
                            q421A_BestResponse_Assessment_Empty: false,
                            q421A_BestResponse_AssessmentDate_Empty: false,
                            q421A_BestResponse_AssessmentDate_Invalid: false,
                            q421A_Method_Assessment: null,
                            q421A_Method_Assessment_Empty: false,
                            q421A_empty_err: false,
                            q421A_txt_empty_err: false,
                          },
                        ];

                  const carTTreatmentList =
                    item.carTTreatmentList?.length > 0
                      ? item.carTTreatmentList.map((typeItem) => ({
                          carTCharacteristicsProcedureBridgeId:
                            item.carTCharacteristicsProcedureBridgeId,
                          treatmentId: item.cohortTreatmentID,
                          treatmentName: item.cohortTreatmentName,
                          q43B_No_Procedure_Rcvd: typeItem.procedureNotreceived
                            ? 1
                            : !isStringEmpty(typeItem.procedureDate)
                              ? 2
                              : typeItem.procedureDateUnk
                                ? 99
                                : null,

                          q43B_No_Procedure_RcvdEmpty: false,
                          q43B_Procedure_Date: typeItem.procedureDate,
                          q43C_ProcedureType: typeItem.procedureType,
                          q43C_ProcedureType_Txt: typeItem.procedureTypeOth,

                          q43C_ProcedureTypeEmpty: false,
                          q43C_ProcedureType_TxtEmpty: false,
                          q43B_Procedure_DateEmpty: false,
                          q43_Date_Valid: false,
                          q43_Procedure_InvalidDate: false,
                        }))
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,
                            q43B_No_Procedure_Rcvd: null,

                            q43B_No_Procedure_RcvdEmpty: false,
                            q43B_Procedure_Date: "",
                            q43C_ProcedureType: null,
                            q43C_ProcedureType_Txt: "",

                            q43C_ProcedureTypeEmpty: false,
                            q43C_ProcedureType_TxtEmpty: false,
                            q43B_Procedure_DateEmpty: false,
                            q43_Date_Valid: false,
                            q43_Procedure_InvalidDate: false,
                          },
                        ];

                  const carTTreatmentTocilizumabList =
                    item.carTTreatmentTocilizumabList?.length > 0
                      ? item.carTTreatmentTocilizumabList.map((typeItem) => ({
                          cartcharacteristicstocilizumabid:
                            typeItem.carTCharacteristicstocilizumabId,
                          treatmentId: item.cohortTreatmentID,
                          treatmentName: item.cohortTreatmentName,
                          q43_1B_No_Tocilizumab_Rcvd:
                            typeItem.tocilizumabNotreceived
                              ? 1
                              : !isStringEmpty(typeItem.tocilizumabDate)
                                ? 2
                                : typeItem.tocilizumabDateUnk
                                  ? 99
                                  : null,

                          q43_1B_No_Tocilizumab_RcvdEmpty: false,
                          q43_1B_Tocilizumab_Date: typeItem.tocilizumabDate,
                          q43_1C_cytokin: typeItem.reasonCystokin,
                          q43_1C_secondary_prophylactic_crs:
                            typeItem.reasonSecondaryProphylacticCRS,
                          q43_1C_crs: typeItem.reasonCRS,
                          q43_1C_primary_prophylactic:
                            typeItem.reasonPrimaryProphlactic,
                          q43_1C_secondary_prophylactic:
                            typeItem.reasonSecondaryProphlactic,
                          q43_1C_tmt_neurologic: typeItem.reasonNeurologic,
                          q43_1C_reason_other: typeItem.reasonOther,
                          q43_1C_reason_unknown: typeItem.reasonUnknown,

                          q43_1C_ReasonEmpty: false,
                          q43_1B_Tocilizumab_DateEmpty: false,
                          q43_1_Date_Valid: false,
                          q43_1_Tocilizumab_InvalidDate: false,
                        }))
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,
                            q43_1B_No_Tocilizumab_Rcvd: null,

                            q43_1B_No_Tocilizumab_RcvdEmpty: false,
                            q43_1B_Tocilizumab_Date: "",
                            q43_1C_cytokin: false,
                            q43_1C_secondary_prophylactic_crs: false,
                            q43_1C_crs: false,
                            q43_1C_primary_prophylactic: false,
                            q43_1C_secondary_prophylactic: false,
                            q43_1C_tmt_neurologic: false,
                            q43_1C_reason_other: false,
                            q43_1C_reason_unknown: false,

                            q43_1C_ReasonEmpty: false,
                            q43_1B_Tocilizumab_DateEmpty: false,
                            q43_1_Date_Valid: false,
                            q43_1_Tocilizumab_InvalidDate: false,
                          },
                        ];

                  const carTTreatmentMitigationList =
                    item.carTTreatmentMitigationList?.length > 0
                      ? item.carTTreatmentMitigationList.map((typeItem) => ({
                          carTCharacteristicsMitigationId:
                            item.carTCharacteristicsMitigationId,
                          treatmentId: item.cohortTreatmentID,
                          treatmentName: item.cohortTreatmentName,

                          q43_3B_NeurologicType: typeItem.neurologicType,
                          q43_3B_NeurologicType_Txt: typeItem.neurologicTypeOth,
                          q43_3C_Mitigation_Txt: typeItem.mitigationTypeOth,

                          q43_3B_NeurologicTypeEmpty: false,
                          q43_3B_NeurologicType_TxtEmpty: false,
                          q43_3C_Mitigation_TxtEmpty: false,
                        }))
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,

                            q43_3B_NeurologicType: null,
                            q43_3B_NeurologicType_Txt: "",
                            q43_3C_Mitigation_Txt: "",

                            q43_3B_NeurologicTypeEmpty: false,
                            q43_3B_NeurologicType_TxtEmpty: false,
                            q43_3C_Mitigation_TxtEmpty: false,
                          },
                        ];

                  const carTTreatmentLymphocyteList =
                    item.carTTreatmentLymphocyteList?.length > 0
                      ? item.carTTreatmentLymphocyteList.map((typeItem) => ({
                          carTCharacteristicsLymphocyteId:
                            item.carTCharacteristicsLymphocyteId,
                          treatmentId: item.cohortTreatmentID,
                          treatmentName: item.cohortTreatmentName,
                          q43_4B_No_Assessment_Rcvd:
                            typeItem.lymphocyteNotreceived
                              ? 2
                              : !isStringEmpty(typeItem.lymphocyteDate)
                                ? 1
                                : null,

                          q43_4B_No_Assessment_RcvdEmpty: false,
                          q43_4B_Assessment_Date: typeItem.lymphocyteDate,
                          q43_4C_MeasurementValue: typeItem.measurement,
                          q43_4C_Measurement_ul: typeItem.measurementUL,
                          q43_4C_Measurement_mm: typeItem.measurementMM,
                          q43_4C_Measurement_xl: typeItem.measurementXL,

                          q43_4C_MeasurementEmpty: false,
                          q43_4C_Measurement_TxtEmpty: false,
                          q43_4C_Measurement_xlRange: false,
                          q43_4C_Measurement_mmRange: false,
                          q43_4C_Measurement_ulRange: false,

                          q43_4B_Assessment_DateEmpty: false,
                          q43_4_Date_Valid: false,
                          q43_4_Assessment_InvalidDate: false,
                        }))
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,
                            q43_4B_No_Assessment_Rcvd: null,

                            q43_4B_No_Assessment_RcvdEmpty: false,
                            q43_4B_Assessment_Date: "",
                            q43_4C_MeasurementValue: null,
                            q43_4C_Measurement_ul: null,
                            q43_4C_Measurement_mm: null,
                            q43_4C_Measurement_xl: null,

                            q43_4C_MeasurementEmpty: false,
                            q43_4C_Measurement_TxtEmpty: false,
                            q43_4C_Measurement_xlRange: false,
                            q43_4C_Measurement_mmRange: false,
                            q43_4C_Measurement_ulRange: false,
                            q43_4B_Assessment_DateEmpty: false,
                            q43_4_Date_Valid: false,
                            q43_4_Assessment_InvalidDate: false,
                          },
                        ];
                  const carTTreatmentCorticosteroidList =
                    item.carTTreatmentCorticosteroidList?.length > 0
                      ? item.carTTreatmentCorticosteroidList.map((typeItem) => {
                          /* ===============================
           DERIVE SELECTED IDS
        =============================== */
                          const selectedIds = (
                            typeItem.selectedReasonCorticosteroidList ?? []
                          ).map(
                            (i) => i.cartcharacteristicscorticosteroidreasonid,
                          );

                          const hasAE = selectedIds.includes(3);
                          const hasNeuro = selectedIds.includes(6);

                          /* ===============================
           DISPLAY LOGIC
        =============================== */
                          let reasonCorticosteroid;

                          if (hasAE && hasNeuro) {
                            reasonCorticosteroid =
                              typeItem.reasonCorticosteroidList;
                          } else if (hasAE) {
                            reasonCorticosteroid =
                              typeItem.reasonCorticosteroidList.filter(
                                (i) => i.neurologicevent !== true,
                              );
                          } else {
                            reasonCorticosteroid =
                              typeItem.reasonCorticosteroidList.filter(
                                (i) => i.corticosteroid === true,
                              );
                          }
                          return {
                            cartcharacteristicscorticosteroidId:
                              item.cartcharacteristicscorticosteroidId,
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,

                            q43_2B_No_Corticosteroid_Rcvd:
                              typeItem.corticosteroidNotreceived
                                ? 1
                                : !isStringEmpty(typeItem.corticosteroidDate)
                                  ? 2
                                  : typeItem.corticosteroidDateUnk
                                    ? 99
                                    : null,

                            q43_2B_No_Corticosteroid_RcvdEmpty: false,
                            q43_2B_Corticosteroid_Date:
                              typeItem.corticosteroidDate,
                            q43_2C_CorticosteroidType:
                              typeItem.corticosteroidType,
                            q43_2D_DoseStrength: typeItem.doseStrength,
                            q43_2D_DoseStrength_mg: typeItem.doseStrengthMG,
                            q43_2D_DoseStrength_kg: typeItem.doseStrengthKG,
                            q43_2D_DoseStrength_other:
                              typeItem.doseStrengthOther,

                            q43_2E_selectedReasonCorticosteroid:
                              typeItem.selectedReasonCorticosteroidList ?? [],

                            // ✅ ADDED ONLY WHEN length > 0
                            q43_2E_reasonCorticosteroid: reasonCorticosteroid,

                            q43_2E_Reason_otherneurologic_Txt: [3, 6, 13].every(
                              (id) => selectedIds.includes(id),
                            )
                              ? typeItem.reasonNeurlogicother
                              : "",

                            q43_2C_CorticosteroidType_Empty: false,
                            q43_2D_DoseStrength_Empty: false,
                            q43_2D_DoseStrength_TxtEmpty: false,
                            q43_2D_DoseStrengthMGRange: false,
                            q43_2D_DoseStrengthKGRange: false,
                            q43_2E_ReasonEmpty: false,
                            q43_2E_Reason_TxtEmpty: false,
                            q43_2E_Reason_AEEmpty: false,
                            q43_2E_Reason_NeurologicEmpty: false,
                            q43_2B_Corticosteroid_DateEmpty: false,
                            q43_2_Date_Valid: false,
                            q43_2_Corticosteroid_InvalidDate: false,
                          };
                        })
                      : [
                          {
                            treatmentId: item.cohortTreatmentID,
                            treatmentName: item.cohortTreatmentName,
                            q43B_No_Procedure_Rcvd: null,

                            q43_2B_No_Corticosteroid_RcvdEmpty: false,
                            q43_2B_Corticosteroid_Date: "",
                            q43_2C_CorticosteroidType: null,
                            q43_2D_DoseStrength: null,
                            q43_2D_DoseStrength_mg: null,
                            q43_2D_DoseStrength_kg: null,
                            q43_2D_DoseStrength_other: null,
                            q43_2E_selectedReasonCorticosteroid: [],
                            q43_2E_reasonCorticosteroid:
                              reasonCorticosteroidList.filter(
                                (i) => i.corticosteroid === true,
                              ),
                            q43_2E_Reason_otherneurologic_Txt: "",

                            q43_2C_CorticosteroidType_Empty: false,
                            q43_2D_DoseStrength_Empty: false,
                            q43_2D_DoseStrength_TxtEmpty: false,
                            q43_2D_DoseStrengthKGRange: false,
                            q43_2D_DoseStrengthMGRange: false,
                            q43_2E_ReasonEmpty: false,
                            q43_2E_Reason_TxtEmpty: false,
                            q43_2E_Reason_AEEmpty: false,
                            q43_2E_Reason_NeurologicEmpty: false,
                            q43_2B_Corticosteroid_DateEmpty: false,
                            q43_2_Date_Valid: false,
                            q43_2_Corticosteroid_InvalidDate: false,
                          },
                        ];

                  return {
                    cohortTreatmentId: item.cohortTreatmentID,
                    cohortTreatmentName: item.cohortTreatmentName,
                    cohortIndexDate: item.cohortIndexDate,
                    isEligible: item.isEligible,
                    subsequentLOTStartDate: item.subsequentLOTStartDate,
                    indexAddThirtyDate: item.indexAddThirtyDate,

                    //41
                    q41_Apheresis_Date: item.apheresisDate,
                    q41_Apheresis_Date_Empty: false,
                    q41_Apheresis_Date_NotValid: false,
                    q41_Apheresis_InvalidDate: false,

                    q41_Apheresis_DateRd:
                      item.apheresisDateUnk == true
                        ? 99
                        : item.apheresisDate
                          ? 1
                          : null,

                    //Q41.1.A
                    q411A_Dose: item.doseAdministration,
                    q411A_Administration: item.siteAdministration,
                    q411A_Utilization: item.bagUtilization,
                    q411A_Administration_Empty: false,
                    q411A_Utilization_Empty: false,

                    carTBridgingTherapyList: carTBridgingTherapyList,
                    carTTreatmentList: carTTreatmentList,
                    carTTreatmentTocilizumabList: carTTreatmentTocilizumabList,
                    carTCharacteristicsTypeList: carTCharacteristicsTypeList,
                    carTTreatmentMitigationList: carTTreatmentMitigationList,
                    carTTreatmentLymphocyteList: carTTreatmentLymphocyteList,
                    carTTreatmentCorticosteroidList:
                      carTTreatmentCorticosteroidList,
                    carTCharacteristicsReceivedList:
                      carTCharacteristicsReceivedList,
                  };
                },
              );

              setCarTCharRepeater(repeaterData);
            }
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);

      let isValid = validate ? ValidateForm() : true;
      if (isValid) {
        setShowTopErrMsg(false);
        const CarTCharacteristicsModel = {
          patientid: pid,
          userId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
          cartcharacteristicsid: carTCharData.CartcharacteristicsId,

          cohortTreatmentModelList: carTCharRepeater.map((item) => ({
            patientId: pid,
            userId: GetLoggedInUserID(),
            centerId: 0,
            cohortTreatmentID: item.cohortTreatmentId,
            cohortTreatmentName: item.cohortTreatmentName,
            ndmm: false,
            cohortIndexDate: item.cohortIndexDate,
            cohortIndexDateUnk: false,
            cohortTreatmentNameSuperscript: "",
            isEligible: item.isEligible,
            lineOfTherapy: null,
            cohorttreatmentUnk: null,
            //41
            //apheresisDate: item.q41_Apheresis_Date,

            apheresisDate:
              item.q41_Apheresis_Date != "Invalid Date" &&
              item.q41_Apheresis_Date
                ? item.q41_Apheresis_Date
                : "",

            ApheresisDateUnk: item.q41_Apheresis_DateRd === 99 ? true : false,

            //Q41.1.A
            siteAdministration: item.q411A_Administration,
            bagUtilization: item.q411A_Utilization,

            carTCharacteristicsTypeList: item.carTCharacteristicsTypeList.map(
              (type) => ({
                CarTtherapyId: type.carTTherapyId,
                CarTtherapyName: type.carTtherapyName,
                TherapyReceived: type.q42_Therapy_Receive,

                // TherapyInitiationDate:
                //   type.q42_Therpy_Initiation_Radio === 1
                //     ? type.q42_Therpy_Initiation_Date
                //     : null,

                TherapyInitiationDate:
                  type.q42_Therpy_Initiation_Radio === 1 &&
                  type.q42_Therpy_Initiation_Date != "Invalid Date" &&
                  type.q42_Therpy_Initiation_Date
                    ? type.q42_Therpy_Initiation_Date
                    : "",

                TherapyInitiationDateUnk:
                  type.q42_Therpy_Initiation_Radio === 99,

                CohortTreatmentUnk:
                  type.q42_CohortTreatment_Unk == 99 ? true : false,
              }),
            ),

            carTBridgingTherapyList: item.carTBridgingTherapyList.map(
              (type) => ({
                BridgingTherapyStart: type.q421A_Start_Bridging_Therapy,
                BridgingtherapyStartdate:
                  type.q421A_Start_Bridging_Therapy === 2 &&
                  type.q421A_Start_Bridging_Therapy_Date != "Invalid Date" &&
                  type.q421A_Start_Bridging_Therapy_Date
                    ? type.q421A_Start_Bridging_Therapy_Date
                    : "",
                BridgingTherapyEnd: type.q421A_End_Bridging_Therapy,
                BridgingtherapyEnddate:
                  type.q421A_End_Bridging_Therapy === 1 &&
                  type.q421A_End_Bridging_Therapy_Date != "Invalid Date" &&
                  type.q421A_End_Bridging_Therapy_Date
                    ? type.q421A_End_Bridging_Therapy_Date
                    : "",
                BestresponseStatus: type.q421A_BestResponse_Status,
                BestresponseAssessment: type.q421A_BestResponse_Assessment,
                BestresponseAssessmentDate:
                  type.q421A_BestResponse_Assessment === 1 &&
                  type.q421A_BestResponse_Assessment_Date != "Invalid Date" &&
                  type.q421A_BestResponse_Assessment_Date
                    ? type.q421A_BestResponse_Assessment_Date
                    : "",
                MethodAssessment: type.q421A_Method_Assessment,

                // RECEIVED TREATMENT FLAGS
                TherapyReceivedUnknown: type.q421A_rb_received_tmt_unk,

                SelectedPrescribedTreatmentList:
                  type.q421A_selectedReceivedTmtList?.map((x) => ({
                    ...x,
                    prescribedTreatmentId: x.prescribedTreatmentId,
                    prescribedTreatmentOthTxt: x.prescribedTreatmentOthTxt,
                  })),
              }),
            ),

            carTCharacteristicsReceivedList:
              item.carTCharacteristicsReceivedList.map((received) => ({
                CarTtherapyId: received.carTtherapyId,
                CarTtherapyReceivedName: received.carTtherapyReceivedName,
                IsChecked: received.isChecked,
                CarTTherapyReceivedId: received.carTTherapyReceivedId,
                CarTOtherTxt: received.carTOtherTxt,
              })),

            carTTreatmentList: item.carTTreatmentList.map((received) => ({
              CarTCharacteristicsProcedureBridgeId:
                received.carTCharacteristicsProcedureBridgeId ?? null,
              TreatmentId: received.treatmentId,
              TreatmentName: received.treatmentName,
              Roundid: null, //received.,
              Recordmodified: null, //received.,
              ProcedureNotreceived: received.q43B_No_Procedure_Rcvd === 1,
              ProcedureDate:
                received.q43B_No_Procedure_Rcvd === 2
                  ? received.q43B_Procedure_Date
                  : null,
              ProcedureDateUnk: received.q43B_No_Procedure_Rcvd === 99, //received.,
              ProcedureType: received.q43C_ProcedureType,
              ProcedureTypeOth: received.q43C_ProcedureType_Txt,
            })),

            //Q43.1.A
            carTTreatmentTocilizumabList: item.carTTreatmentTocilizumabList.map(
              (received) => ({
                CarTCharacteristicstocilizumabId:
                  received.cartcharacteristicstocilizumabid ?? null,
                TreatmentId: received.treatmentId,
                TreatmentName: received.treatmentName,
                Roundid: null, //received.,
                Recordmodified: null, //received.,
                TocilizumabNotreceived:
                  received.q43_1B_No_Tocilizumab_Rcvd === 1,
                TocilizumabDate:
                  received.q43_1B_No_Tocilizumab_Rcvd === 2
                    ? received.q43_1B_Tocilizumab_Date
                    : null,
                TocilizumabDateUnk: received.q43_1B_No_Tocilizumab_Rcvd === 99, //received.,
                ReasonCystokin: received.q43_1C_cytokin,
                ReasonSecondaryProphylacticCRS:
                  received.q43_1C_secondary_prophylactic_crs,
                ReasonCRS: received.q43_1C_crs,
                ReasonPrimaryProphlactic: received.q43_1C_primary_prophylactic,
                ReasonSecondaryProphlactic:
                  received.q43_1C_secondary_prophylactic,
                ReasonNeurologic: received.q43_1C_tmt_neurologic,
                ReasonOther: received.q43_1C_reason_other,
                ReasonUnknown: received.q43_1C_reason_unknown,
              }),
            ),

            carTTreatmentCorticosteroidList:
              item.carTTreatmentCorticosteroidList.map((received) => ({
                CartcharacteristicscorticosteroidId:
                  received.cartcharacteristicscorticosteroidId ?? null,
                TreatmentId: received.treatmentId,
                TreatmentName: received.treatmentName,
                Roundid: null, //received.,
                Recordmodified: null, //received.,
                CorticosteroidNotreceived:
                  received.q43_2B_No_Corticosteroid_Rcvd === 1,
                CorticosteroidDate:
                  received.q43_2B_No_Corticosteroid_Rcvd === 2
                    ? received.q43_2B_Corticosteroid_Date
                    : null,
                CorticosteroidDateUnk:
                  received.q43_2B_No_Corticosteroid_Rcvd === 99, //received.,
                CorticosteroidType: received.q43_2C_CorticosteroidType,
                DoseStrength: received.q43_2D_DoseStrength,
                DoseStrengthMG: received.q43_2D_DoseStrength_mg,
                DoseStrengthKG: received.q43_2D_DoseStrength_kg,
                DoseStrengthOther: received.q43_2D_DoseStrength_other,
                SelectedReasonCorticosteroidList:
                  received.q43_2E_selectedReasonCorticosteroid.map((x) => ({
                    ...x,
                    Cartcharacteristicscorticosteroidreasonid:
                      x.Cartcharacteristicscorticosteroidreasonid,
                  })),

                reasonNeurlogicother:
                  received.q43_2E_Reason_otherneurologic_Txt,
              })),

            //Q43.3.A
            carTTreatmentMitigationList: item.carTTreatmentMitigationList.map(
              (received) => ({
                CarTCharacteristicsMitigationId:
                  received.carTCharacteristicsMitigationId ?? null,
                TreatmentId: received.treatmentId,
                TreatmentName: received.treatmentName,
                Roundid: null, //received.,
                Recordmodified: null, //received.,

                NeurologicType: received.q43_3B_NeurologicType,
                NeurologicTypeOth: received.q43_3B_NeurologicType_Txt,
                MitigationTypeOth: received.q43_3C_Mitigation_Txt,
              }),
            ),

            //Q43.4.A
            carTTreatmentLymphocyteList: item.carTTreatmentLymphocyteList.map(
              (received) => ({
                CarTCharacteristicsLymphocyteId:
                  received.carTCharacteristicsLymphocyteId ?? null,
                TreatmentId: received.treatmentId,
                TreatmentName: received.treatmentName,
                Roundid: null, //received.,
                Recordmodified: null, //received.,
                LymphocyteNotreceived: received.q43_4B_No_Assessment_Rcvd === 2,
                LymphocyteDate:
                  received.q43_4B_No_Assessment_Rcvd === 1
                    ? received.q43_4B_Assessment_Date
                    : null,
                Measurement: received.q43_4C_MeasurementValue,
                MeasurementUL: received.q43_4C_Measurement_ul,
                MeasurementMM: received.q43_4C_Measurement_mm,
                MeasurementXL: received.q43_4C_Measurement_xl,
              }),
            ),
          })),
        };

        if (pid > 0) {
          const response =
            await AdditionalTreatmentService.SaveCarTCharacteristics(
              CarTCharacteristicsModel,
            );

          if (response.status === HTTPResponse.OK) {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData();
          } else if (response.status === HTTPResponse.Unauthorized) {
            HandleSessionTimeout();
          } else {
            throw new Error("Failed to save data");
          }
        }

        return true;
      } else {
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
      return false;
    } finally {
      ToggleLoader(false);
    }
  };

  const displayCohortIndexDates = () => {
    const date1 = filteredList[0]?.cohortIndexDate;
    const date2 = filteredList[1]?.cohortIndexDate;

    if (date1 && date2) {
      return `${date1} and ${date2}`;
    } else if (date1) {
      return date1;
    } else if (date2) {
      return date2;
    } else {
      return ""; // Return an empty string or a default message if neither date is present
    }
  };

  const displayApheresisDate = () => {
    let carvyktiApheresisDate = "";
    let abecmaApheresisDate = "";

    if (carTCharRepeater.length > 0) {
      carvyktiApheresisDate =
        carTCharRepeater.find((item) => item.cohortTreatmentId === 13)
          ?.q41_Apheresis_Date || "";
      abecmaApheresisDate =
        carTCharRepeater.find((item) => item.cohortTreatmentId === 14)
          ?.q41_Apheresis_Date || "";
    }

    if (carvyktiApheresisDate && abecmaApheresisDate) {
      return `${carvyktiApheresisDate} and ${abecmaApheresisDate}`;
    } else if (carvyktiApheresisDate) {
      return carvyktiApheresisDate;
    } else if (abecmaApheresisDate) {
      return abecmaApheresisDate;
    } else {
      return "Date of apheresis";
    }
  };

  const displayNdmmEndOfDates = (cohortId) => {
    let date = "";
    if (cohortId === 13) {
      date =
        carTCharData.carvyktiFollowupDate ||
        carTCharData.endOfFollowupDate ||
        "Bispecifics/CAR-T end of follow up for Cilta-Cel";
    } else if (cohortId === 14) {
      date =
        carTCharData.abecmaFollowupDate ||
        carTCharData.endOfFollowupDate ||
        "Bispecifics/CAR-T end of follow up for Ide-Cel";
    }
    return date;
  };

  const display43_1_EndOfDates = (cohortId) => {
    if (cohortId === 13) {
      return (
        getEarliestCartDate([
          carTCharData.carvyktiNextLotDate,
          carTCharData.carvyktiFollowupDate,
          carTCharData.endOfFollowupDate,
        ]) || "Bispecifics/CAR-T end of follow up for Cilta-Cel"
      );
    }

    if (cohortId === 14) {
      return (
        getEarliestCartDate([
          carTCharData.abecmaNextLotDate,
          carTCharData.abecmaFollowupDate,
          carTCharData.endOfFollowupDate,
        ]) || "Bispecifics/CAR-T end of follow up for Ide-Cel"
      );
    }

    return "";
  };

  const displayCohortIndexNames = () => {
    const cohortName1 = getCohortTreatmentDisplayName(
      filteredList[0]?.cohortTreatmentID,
    );
    const cohortName2 = getCohortTreatmentDisplayName(
      filteredList[1]?.cohortTreatmentID,
    );

    if (cohortName1 && cohortName2) {
      return `${cohortName1} and ${cohortName2}`;
    } else if (cohortName1) {
      return cohortName1;
    } else if (cohortName2) {
      return cohortName2;
    } else {
      return ""; // Return an empty string or a default message if neither date is present
    }
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  const handleDeleteQ421ARow = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTBridgingTherapyList: row.carTBridgingTherapyList.filter(
              (_, index) => index !== childIdx,
            ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ421ARow = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    if (isNewEcrfA) {
      setCarTCharRepeater((prev) => {
        const updated = prev.map((row) => {
          if (row?.cohortTreatmentId === treatmentTypeId) {
            // define empty row
            const emptyRow = {
              treatmentId: treatmentTypeId,
              treatmentName,
              q421A_Start_Bridging_Therapy: null,
              q421A_Start_Bridging_Therapy_Date: "",
              q421A_Start_Bridging_Therapy_Empty: false,
              q421A_Start_Bridging_TherapyDate_Empty: false,
              q421A_Start_Bridging_TherapyDate_Invalid: false,
              q421A_End_Bridging_Therapy: null,
              q421A_End_Bridging_Therapy_Date: "",
              q421A_End_Bridging_Therapy_Empty: false,
              q421A_End_Bridging_TherapyDate_Empty: false,
              q421A_End_Bridging_TherapyDate_Invalid: false,
              q421A_BestResponse_Status: null,
              q421A_BestResponse_Status_Empty: false,
              q421A_BestResponse_Assessment: null,
              q421A_BestResponse_Assessment_Date: "",
              q421A_BestResponse_Assessment_Empty: false,
              q421A_BestResponse_AssessmentDate_Empty: false,
              q421A_BestResponse_AssessmentDate_Invalid: false,
              q421A_Method_Assessment: null,
              q421A_Method_Assessment_Empty: false,
              q421A_txt_empty_err: false,
              q421A_empty_err: false,
            };

            const updatedRow = {
              ...row,
              carTBridgingTherapyList: [
                ...row.carTBridgingTherapyList,
                emptyRow,
              ],
            };

            return updatedRow;
          }
          return row; // keep unchanged
        });

        return updated;
      });
    }
  };

  useEffect(() => {
    const handleWheel = (event) => {
      if (inputRef.current && inputRef.current.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation(); // Stop the event from bubbling up
      }
    };

    const inputElement = inputRef.current;

    // inputElement.addEventListener('wheel', handleWheel, { passive: false });
    // inputElement.addEventListener('mousewheel', handleWheel, { passive: false }); // For older browsers

    // return () => {
    //     inputElement.removeEventListener('wheel', handleWheel);
    //     inputElement.removeEventListener('mousewheel', handleWheel);
    // };
  }, []);

  const handleDeleteQ43Row = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTTreatmentList: row.carTTreatmentList.filter(
              (_, index) => index !== childIdx,
            ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ43Row = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    setCarTCharRepeater((prev) => {
      const updated = prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          // define empty row
          const emptyRow = {
            treatmentId: treatmentTypeId,
            treatmentName,
            q43B_No_Procedure_Rcvd: null,
            q43B_Procedure_Date: "",
            q43C_ProcedureType: null,
            q43C_ProcedureType_Txt: "",
            q43B_No_Procedure_RcvdEmpty: false,
            q43B_Procedure_DateEmpty: false,
            q43C_ProcedureTypeEmpty: false,
            q43C_ProcedureType_TxtEmpty: false,
            q43_Procedure_InvalidDate: false,
            q43_Date_Valid: false,
          };

          const updatedRow = {
            ...row,
            carTTreatmentList: [...row.carTTreatmentList, emptyRow],
          };

          return updatedRow;
        }
        return row; // keep unchanged
      });

      return updated;
    });
  };

  const handleDeleteQ43_1_Row = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTTreatmentTocilizumabList:
              row.carTTreatmentTocilizumabList.filter(
                (_, index) => index !== childIdx,
              ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ43_1_Row = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    setCarTCharRepeater((prev) => {
      const updated = prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          // define empty row
          const emptyRow = {
            treatmentId: treatmentTypeId,
            treatmentName,
            q43_1B_No_Tocilizumab_Rcvd: null,
            q43_1B_Tocilizumab_Date: "",
            q43_1C_cytokin: false,
            q43_1C_secondary_prophylactic_crs: false,
            q43_1C_crs: false,
            q43_1C_primary_prophylactic: false,
            q43_1C_secondary_prophylactic: false,
            q43_1C_tmt_neurologic: false,
            q43_1C_reason_other: false,
            q43_1C_reason_unknown: false,

            q43_1B_No_Tocilizumab_RcvdEmpty: false,
            q43_1B_Tocilizumab_DateEmpty: false,
            q43_1C_ReasonEmpty: false,
            q43_1_Tocilizumab_InvalidDate: false,
            q43_1_Date_Valid: false,
          };

          const updatedRow = {
            ...row,
            carTTreatmentTocilizumabList: [
              ...row.carTTreatmentTocilizumabList,
              emptyRow,
            ],
          };

          return updatedRow;
        }
        return row; // keep unchanged
      });

      return updated;
    });
  };

  const handleDeleteQ43_3_Row = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTTreatmentMitigationList: row.carTTreatmentMitigationList.filter(
              (_, index) => index !== childIdx,
            ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ43_3_Row = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    setCarTCharRepeater((prev) => {
      const updated = prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          // define empty row
          const emptyRow = {
            treatmentId: treatmentTypeId,
            treatmentName,
            q43_3B_NeurologicType: null,
            q43_3B_NeurologicType_Txt: "",
            q43_3C_Mitigation_Txt: "",

            q43_3B_NeurologicTypeEmpty: false,
            q43_3B_NeurologicType_TxtEmpty: false,
            q43_3C_Mitigation_TxtEmpty: false,
          };

          const updatedRow = {
            ...row,
            carTTreatmentMitigationList: [
              ...row.carTTreatmentMitigationList,
              emptyRow,
            ],
          };

          return updatedRow;
        }
        return row; // keep unchanged
      });

      return updated;
    });
  };

  const handleDeleteQ43_4_Row = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTTreatmentLymphocyteList: row.carTTreatmentLymphocyteList.filter(
              (_, index) => index !== childIdx,
            ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ43_4_Row = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    setCarTCharRepeater((prev) => {
      const updated = prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          // define empty row
          const emptyRow = {
            treatmentId: treatmentTypeId,
            treatmentName,
            q43_4B_No_Assessment_Rcvd: null,
            q43_4B_Assessment_Date: "",
            q43_4C_MeasurementValue: null,
            q43_4C_Measurement_ul: null,
            q43_4C_Measurement_mm: null,
            q43_4C_Measurement_xl: null,
            q43_4B_No_Assessment_RcvdEmpty: false,
            q43_4B_Assessment_DateEmpty: false,
            q43_4C_MeasurementEmpty: false,
            q43_4C_Measurement_TxtEmpty: false,
            q43_4C_Measurement_xlRange: false,
            q43_4C_Measurement_mmRange: false,
            q43_4C_Measurement_ulRange: false,
            q43_4_Assessment_InvalidDate: false,
            q43_4_Date_Valid: false,
          };

          const updatedRow = {
            ...row,
            carTTreatmentLymphocyteList: [
              ...row.carTTreatmentLymphocyteList,
              emptyRow,
            ],
          };

          return updatedRow;
        }
        return row; // keep unchanged
      });

      return updated;
    });
  };

  const handleDeleteQ43_2_Row = (treatmentTypeId, childIdx) => {
    setCarTCharRepeater((prev) =>
      prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          return {
            ...row,
            carTTreatmentCorticosteroidList:
              row.carTTreatmentCorticosteroidList.filter(
                (_, index) => index !== childIdx,
              ),
          };
        }
        return row; // unchanged
      }),
    );
  };

  const AddQ43_2_Row = (treatmentTypeId) => {
    let treatmentName =
      treatmentTypeId === 13
        ? "Ciltacabtagene autoleucel"
        : "Idecabtagene vicleucel";

    setCarTCharRepeater((prev) => {
      const updated = prev.map((row) => {
        if (row?.cohortTreatmentId === treatmentTypeId) {
          // define empty row
          const emptyRow = {
            treatmentId: treatmentTypeId,
            treatmentName,
            q43_2B_No_Corticosteroid_Rcvd: null,
            q43_2B_Corticosteroid_Date: "",
            q43_2C_CorticosteroidType: null,
            q43_2D_DoseStrength: null,
            q43_2D_DoseStrength_mg: null,
            q43_2D_DoseStrength_kg: null,
            q43_2D_DoseStrength_other: null,
            q43_2E_Reason_Primary_Prophylactic: false,
            q43_2E_Reason_Secondary_Prophylactic: false,
            q43_2E_Reason_ae_mngmnt: false,
            q43_2E_Reason_crs: false,
            q43_2E_Reason_icans: false,
            q43_2E_Reason_neurologic: false,
            q43_2E_Reason_neuropathy: false,
            q43_2E_Reason_fever: false,
            q43_2E_Reason_neurotoxicity: false,
            q43_2E_Reason_guillianbarre: false,
            q43_2E_Reason_parkinson: false,
            q43_2E_Reason_cranialnerve: false,
            q43_2E_Reason_otherneurologic: false,
            q43_2E_Reason_otherneurologic_Txt: "",
            q43_2E_Reason_Malignancy: false,
            q43_2E_Reason_neutropenia: false,
            q43_2E_Reason_cytopenia: false,
            q43_2E_Reason_enterocolitis: false,
            q43_2E_Reason_lymphopenia: false,
            q43_2E_Reason_other_ae: false,
            q43_2E_Reason_unknown_ae: false,
            q43_2E_Reason_other: false,
            q43_2E_Reason_unknown: false,
            q43_2E_selectedReasonCorticosteroid: [],
            q43_2E_reasonCorticosteroid: reasonCorticosteroidUsage.filter(
              (i) => i.corticosteroid === true,
            ),
            q43_2B_No_Corticosteroid_RcvdEmpty: false,
            q43_2B_Corticosteroid_DateEmpty: false,
            q43_2C_CorticosteroidType_Empty: false,
            q43_2D_DoseStrength_Empty: false,
            q43_2D_DoseStrength_TxtEmpty: false,
            q43_2D_DoseStrengthMGRange: false,
            q43_2D_DoseStrengthKGRange: false,
            q43_2_Corticosteroid_InvalidDate: false,
            q43_2_Date_Valid: false,
            q43_2E_ReasonEmpty: false,
            q43_2E_Reason_TxtEmpty: false,
            q43_2E_Reason_AEEmpty: false,
            q43_2E_Reason_NeurologicEmpty: false,
          };

          const updatedRow = {
            ...row,
            carTTreatmentCorticosteroidList: [
              ...row.carTTreatmentCorticosteroidList,
              emptyRow,
            ],
          };

          return updatedRow;
        }
        return row; // keep unchanged
      });

      return updated;
    });
  };

  const formatDose = (text) => {
    const regex = /x\s*10\s*6/i;

    if (!regex.test(text)) return text;

    const [before, after] = text.split(regex);

    return (
      <>
        {before}X 10<sup>6</sup>
        {after}
      </>
    );
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.CartCharacteristics} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                class="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>CAR-T Characteristics</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    {/* Question 41 */}
                    <div className="sub-question" style={{ padding: "0px" }}>
                      <div
                        className="table-page"
                        style={{ paddingTop: "15px" }}
                      >
                        <div className="question question-weight">
                          <span style={{ fontWeight: "500" }}>Q41.</span>
                          <span
                            className="quest-text-pad"
                            style={{ fontWeight: "500" }}
                          >
                            Date of apheresis
                          </span>
                        </div>
                        <table border="1">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                Treatment <br />
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                ></span>
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                Date of apheresis
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                ></span>
                              </th>
                            </tr>
                          </thead>

                          {carTCharRepeater && carTCharRepeater.length > 0
                            ? carTCharRepeater.map((data, idx) => (
                                <tbody key={idx}>
                                  <tr>
                                    <td rowSpan={2}>
                                      {data.cohortTreatmentName}
                                    </td>
                                    <td
                                      className="customNoContent"
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                      }}
                                    >
                                      <div
                                        className="option-without-input"
                                        style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q41_Apheresis_DateRd" + idx}
                                          value={1}
                                          checked={
                                            data.q41_Apheresis_DateRd === 1
                                          }
                                          onChange={HandleRepeaterFieldChange}
                                        />

                                        <span
                                          className="radio-text-padding"
                                          style={{ marginLeft: "-5px" }}
                                        >
                                          {/* <DateControl
                                            ctrlId={`q41_Apheresis_Date-${idx}`}
                                            HandleDateChange={
                                              HandleRepeaterDateChange
                                            }
                                            date={data.q41_Apheresis_Date}
                                          /> */}

                                          <DatePickerComponent
                                            ctrlId={`q41_Apheresis_Date-${idx}`}
                                            HandleDateChange={
                                              HandleRepeaterDateChange
                                            }
                                            minDate={dayjs("01-01-1920")}
                                            maxDate={dayjs()}
                                            locale="en"
                                            date={data.q41_Apheresis_Date}
                                          />
                                        </span>
                                      </div>
                                      {/* 
                                      <ErrorField
                                        show={data.q41_Apheresis_Date_Empty}
                                        message={CarTCharMsgs.q41_Date_Empty}
                                      /> */}

                                      <div className="">
                                        <label className="long-text-option">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"q41_Apheresis_DateRd" + idx}
                                            value={99}
                                            checked={
                                              data.q41_Apheresis_DateRd === 99
                                            }
                                            onChange={HandleRepeaterFieldChange}
                                          />

                                          <span
                                            className="radio-text-padding"
                                            style={{
                                              paddingLeft: "10px",
                                            }}
                                          >
                                            Date of apheresis unknown
                                          </span>
                                        </label>
                                      </div>

                                      <ErrorField
                                        show={data.q41_Apheresis_Date_Empty}
                                        message={CarTCharMsgs.q41_Date_Empty}
                                      />

                                      <ErrorField
                                        show={data.q41_Apheresis_InvalidDate}
                                        message={CommonError_Msgs.InvalidDate}
                                      />

                                      <ErrorField
                                        show={data.q41_Apheresis_Date_NotValid}
                                        message={CarTCharMsgs.q41_Date_NotValid}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              ))
                            : null}
                        </table>
                      </div>
                    </div>

                    {/* Question 41.1.A */}
                    {isNewEcrfA && (
                      <>
                        <div
                          className="sub-question"
                          style={{ padding: "0px" }}
                        >
                          <div
                            className="table-page"
                            style={{ paddingTop: "15px" }}
                          >
                            <div className="question question-weight">
                              <span style={{ fontWeight: "500" }}>Q41.1.A</span>
                              <span
                                className="quest-text-pad"
                                style={{ fontWeight: "500" }}
                              >
                                Please provide additional information on the
                                CAR-T infusion with [
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {displayCohortIndexNames()}
                                </span>
                                ]
                              </span>
                            </div>
                            <table border="1">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Treatment <br />
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    ></span>
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Dose
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    ></span>
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Site of administration
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    ></span>
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Single bag utilization
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    ></span>
                                  </th>
                                </tr>
                              </thead>

                              {carTCharRepeater && carTCharRepeater.length > 0
                                ? carTCharRepeater.map((data, idx) => (
                                    <tbody key={idx}>
                                      <tr>
                                        <td rowSpan={2}>
                                          {getCohortTreatmentDisplayName(
                                            data.cohortTreatmentId,
                                          )}
                                        </td>
                                        <td
                                          className="customNoContent"
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            <label className="long-text-option">
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                {formatDose(data.q411A_Dose)}
                                              </span>
                                            </label>
                                          </div>
                                        </td>
                                        <td
                                          className="customNoContent"
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q411A_Administration" + idx
                                                }
                                                value={1}
                                                checked={
                                                  data.q411A_Administration ===
                                                  1
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Inpatient
                                              </span>
                                            </label>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q411A_Administration" + idx
                                                }
                                                value={2}
                                                checked={
                                                  data.q411A_Administration ===
                                                  2
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Outpatient
                                              </span>
                                            </label>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q411A_Administration" + idx
                                                }
                                                value={99}
                                                checked={
                                                  data.q411A_Administration ===
                                                  99
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={
                                              data.q411A_Administration_Empty
                                            }
                                            message={
                                              CarTCharMsgs.q411A_Administration_Empty
                                            }
                                          />
                                        </td>
                                        <td
                                          className="customNoContent"
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q411A_Utilization" + idx}
                                                value={1}
                                                checked={
                                                  data.q411A_Utilization === 1
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Yes
                                              </span>
                                            </label>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q411A_Utilization" + idx}
                                                value={2}
                                                checked={
                                                  data.q411A_Utilization === 2
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                No
                                              </span>
                                            </label>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q411A_Utilization" + idx}
                                                value={99}
                                                checked={
                                                  data.q411A_Utilization === 99
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={data.q411A_Utilization_Empty}
                                            message={
                                              CarTCharMsgs.q411A_Utilization_Empty
                                            }
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))
                                : null}
                            </table>
                          </div>
                        </div>
                      </>
                    )}

                    {/* QUESTION 42 */}
                    {isNewEcrfA ? (
                      <div className="question-bot-sapce">
                        <div className="question question-weight">
                          <span style={{ fontWeight: "500" }}>Q42.</span>
                          <span
                            className="quest-text-pad"
                            style={{ fontWeight: "500" }}
                          >
                            Provide information on{" "}
                            <u>
                              any <i>lymphodepletion therapy</i>
                            </u>{" "}
                            received from the date of apheresis to the date of
                            CAR-T infusion with [
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {displayCohortIndexNames()}
                            </span>
                            ] (i.e., from [
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {/* //Write seperate FUNCTION     */}
                              {displayApheresisDate()}
                            </span>
                            ] to{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {" "}
                              [{displayCohortIndexDates()}]){" "}
                            </span>
                            &nbsp;
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {""}
                            </span>
                          </span>
                        </div>

                        <div className="table-page">
                          <table border="1">
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Treatment <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Type of therapy <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Was therapy received? <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Date of therapy initiation <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Type of therapy received <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {carTCharRepeater &&
                              carTCharRepeater.length > 0 ? (
                                carTCharRepeater.map((data, idx) => (
                                  <>
                                    <tr key={idx}>
                                      <td>{data.cohortTreatmentName}</td>
                                      {data.carTCharacteristicsTypeList
                                        .slice(1, 2)
                                        .map((item, index) => (
                                          <>
                                            <td>
                                              <span key={index}>
                                                {item.carTtherapyName}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={1}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Yes
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={2}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={99}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Receive_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {item.q42_Therapy_Receive ===
                                                1 && (
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therpy_Initiation_Radio${idx}${index + 1}`}
                                                      value={1}
                                                      checked={
                                                        item.q42_Therpy_Initiation_Radio ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      {/* <DateControl
                                                      ctrlId={`q42_Therpy_Initiation_Date${idx}_${index}`}
                                                      HandleDateChange={
                                                        HandleRepeatDateChange
                                                      }
                                                      date={
                                                        item.q42_Therpy_Initiation_Date
                                                      }
                                                    /> */}
                                                      <DatePickerComponent
                                                        ctrlId={`q42_Therpy_Initiation_Date${idx}_${index + 1}`}
                                                        HandleDateChange={
                                                          HandleRepeatDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          item.q42_Therpy_Initiation_Date
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                        //marginLeft: "8px",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}_${index + 1}`}
                                                        name={`q42_Therpy_Initiation_Radio${idx}${index + 1}`}
                                                        value={99}
                                                        checked={
                                                          item.q42_Therpy_Initiation_Radio ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Date of initiation
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Radio_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_DateInvalid
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_NotValid
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Valid_Bridge
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Date_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Entered_Bridge
                                                }
                                              />
                                            </td>
                                          </>
                                        ))}

                                      <td
                                        style={{
                                          textAlign: "left",
                                          paddingInline: "8px",
                                        }}
                                      >
                                        {data.carTCharacteristicsTypeList[1]
                                          .q42_Therapy_Receive === 1 && (
                                          <>
                                            <div>
                                              {data.carTCharacteristicsReceivedList
                                                .filter(
                                                  (item) =>
                                                    item.carTtherapyId === 2,
                                                )
                                                .map((item, index) => (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                      marginBottom: "4px",
                                                    }}
                                                    key={index}
                                                  >
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                      name={`checkbox${idx}${item.carTTherapyReceivedId}`}
                                                      checked={item.isChecked}
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <div
                                                      style={{
                                                        marginLeft: "8px",
                                                      }}
                                                    >
                                                      <label
                                                        htmlFor={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                      >
                                                        {
                                                          item.carTtherapyReceivedName
                                                        }
                                                      </label>

                                                      {/* Conditionally render an input text field for a specific checkbox based on ID */}
                                                      {item.carTTherapyReceivedId ===
                                                        33 && (
                                                        <textarea
                                                          type="text"
                                                          // className="input-dashdash"
                                                          id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                          name={`Checkboxtext${idx}${item.carTTherapyReceivedId}`}
                                                          value={
                                                            item.carTOtherTxt ||
                                                            ""
                                                          }
                                                          maxLength={300}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          style={{
                                                            display: "flex",
                                                            marginTop: "4px",
                                                          }}
                                                        />
                                                      )}
                                                      <ErrorField
                                                        style={{
                                                          display: "flex",
                                                          marginLeft: "-25px",
                                                        }}
                                                        show={
                                                          item.carTOtherTxtEmpty
                                                        }
                                                        message="Please enter text for Other option. "
                                                      />
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>

                                            {/* Place the "Unknown" radio button after the checkboxes */}
                                            {/* {carTCharRepeater.carTCharacteristicsTypeList &&
                                          carTCharRepeater
                                            .carTCharacteristicsTypeList
                                            .length > 0 ? ( */}
                                            <div style={{ marginTop: "8px" }}>
                                              <label
                                              // style={{ marginLeft: "8px" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={`${idx}_1`}
                                                  name={`q42_CohortTreatment_Unk${idx}1`}
                                                  value={99}
                                                  checked={
                                                    data
                                                      .carTCharacteristicsTypeList[1]
                                                      .q42_CohortTreatment_Unk ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{ marginLeft: "8px" }}
                                                >
                                                  {" "}
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            {/* ) : (
                                            <div style={{ marginTop: "8px" }}>
                                              <label
                                              // style={{ marginLeft: "8px" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={`${idx}_0`}
                                                  style={{ marginRight: "8px" }}
                                                  name={`q42_CohortTreatment_Unk${idx}0`}
                                                  value={99}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                Unknown
                                              </label>
                                            </div>
                                          )} */}

                                            {/* Error message displayed below "Unknown" */}
                                            {data.carTCharacteristicsTypeList[1]
                                              .q42_Therapy_Receive === 1 && (
                                              <ErrorField
                                                show={
                                                  data
                                                    .carTCharacteristicsTypeList[1]
                                                    .therapyReceivedEmpty
                                                }
                                                message="Please choose at least one of the provided options or “Unknown” "
                                              />
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5">
                                    No treatment data available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      <div className="question-bot-sapce">
                        <div className="question question-weight">
                          <span style={{ fontWeight: "500" }}>Q42.</span>
                          <span
                            className="quest-text-pad"
                            style={{ fontWeight: "500" }}
                          >
                            Provide additional information on therapies received
                            from the date of apheresis to the date of CAR-T
                            infusion with [
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {displayCohortIndexNames()}
                            </span>
                            ] (i.e., from [
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {" "}
                              {/* //Write seperate FUNCTION     */}
                              {displayApheresisDate()}
                            </span>
                            ] to{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {" "}
                              [{displayCohortIndexDates()}]){" "}
                            </span>
                            &nbsp;
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                              }}
                            >
                              {""}
                            </span>
                          </span>
                        </div>

                        <div className="table-page">
                          <table border="1">
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Treatment <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Type of therapy <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Was therapy received? <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Date of therapy initiation <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Type of therapy received <br />
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  ></span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {carTCharRepeater &&
                              carTCharRepeater.length > 0 ? (
                                carTCharRepeater.map((data, idx) => (
                                  <>
                                    <tr key={idx}>
                                      <td rowSpan={2}>
                                        {data.cohortTreatmentName}
                                      </td>
                                      {data.carTCharacteristicsTypeList
                                        .slice(0, 1)
                                        .map((item, index) => (
                                          <>
                                            <td>
                                              <span key={index}>
                                                {item.carTtherapyName}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index}`}
                                                      name={`q42_Therapy_Receive${idx}${index}`}
                                                      value={1}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Yes
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index}`}
                                                      name={`q42_Therapy_Receive${idx}${index}`}
                                                      value={2}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      textAlign: "start",
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index}`}
                                                      name={`q42_Therapy_Receive${idx}${index}`}
                                                      value={99}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Receive_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {item.q42_Therapy_Receive ===
                                                1 && (
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index}`}
                                                      name={`q42_Therpy_Initiation_Radio${idx}${index}`}
                                                      value={1}
                                                      checked={
                                                        item.q42_Therpy_Initiation_Radio ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      {/* <DateControl
                                                      ctrlId={`q42_Therpy_Initiation_Date${idx}_${index}`}
                                                      HandleDateChange={
                                                        HandleRepeatDateChange
                                                      }
                                                      date={
                                                        item.q42_Therpy_Initiation_Date
                                                      }
                                                    /> */}
                                                      <DatePickerComponent
                                                        ctrlId={`q42_Therpy_Initiation_Date${idx}_${index}`}
                                                        HandleDateChange={
                                                          HandleRepeatDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          item.q42_Therpy_Initiation_Date
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                        //marginLeft: "8px",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}_${index}`}
                                                        name={`q42_Therpy_Initiation_Radio${idx}${index}`}
                                                        value={99}
                                                        checked={
                                                          item.q42_Therpy_Initiation_Radio ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Date of initiation
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Radio_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_DateInvalid
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_NotValid
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Valid_Bridge
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Date_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Entered_Bridge
                                                }
                                              />
                                            </td>
                                          </>
                                        ))}

                                      <td
                                        style={{
                                          textAlign: "left",
                                          paddingInline: "8px",
                                        }}
                                      >
                                        {data.carTCharacteristicsTypeList[0]
                                          .q42_Therapy_Receive === 1 && (
                                          <>
                                            <div>
                                              {data.carTCharacteristicsReceivedList
                                                .filter(
                                                  (item) =>
                                                    item.carTtherapyId === 1,
                                                )
                                                .map((item, index) => (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                      marginBottom: "4px",
                                                    }}
                                                    key={index}
                                                  >
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                      name={`checkbox${idx}${item.carTTherapyReceivedId}`}
                                                      checked={item.isChecked}
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <div
                                                      style={{
                                                        marginLeft: "8px",
                                                      }}
                                                    >
                                                      <label
                                                        htmlFor={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                      >
                                                        {
                                                          item.carTtherapyReceivedName
                                                        }
                                                      </label>

                                                      {/* Conditionally render an input text field for a specific checkbox based on ID */}
                                                      {item.carTTherapyReceivedId ===
                                                        27 && (
                                                        <textarea
                                                          type="text"
                                                          // className="input-dashdash"
                                                          id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                          name={`Checkboxtext${idx}${item.carTTherapyReceivedId}`}
                                                          value={
                                                            item.carTOtherTxt ||
                                                            ""
                                                          }
                                                          maxLength={300}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          style={{
                                                            display: "flex",
                                                            marginTop: "4px",
                                                          }}
                                                        />
                                                      )}
                                                      <ErrorField
                                                        style={{
                                                          display: "flex",
                                                          marginLeft: "-25px",
                                                        }}
                                                        show={
                                                          item.carTOtherTxtEmpty
                                                        }
                                                        message="Please enter text for Other option. "
                                                      />
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>

                                            {/* Place the "Unknown" radio button after the checkboxes */}
                                            {/* {carTCharRepeater.carTCharacteristicsTypeList &&
                                          carTCharRepeater
                                            .carTCharacteristicsTypeList
                                            .length > 0 ? ( */}
                                            <div style={{ marginTop: "8px" }}>
                                              <label
                                              // style={{ marginLeft: "8px" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={`${idx}_0`}
                                                  name={`q42_CohortTreatment_Unk${idx}0`}
                                                  value={99}
                                                  checked={
                                                    data
                                                      .carTCharacteristicsTypeList[0]
                                                      .q42_CohortTreatment_Unk ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{ marginLeft: "8px" }}
                                                >
                                                  {" "}
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            {/* ) : (
                                            <div style={{ marginTop: "8px" }}>
                                              <label
                                              // style={{ marginLeft: "8px" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={`${idx}_0`}
                                                  style={{ marginRight: "8px" }}
                                                  name={`q42_CohortTreatment_Unk${idx}0`}
                                                  value={99}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                Unknown
                                              </label>
                                            </div>
                                          )} */}

                                            {/* Error message displayed below "Unknown" */}
                                            {data.carTCharacteristicsTypeList[0]
                                              .q42_Therapy_Receive === 1 && (
                                              <ErrorField
                                                show={
                                                  data
                                                    .carTCharacteristicsTypeList[0]
                                                    .therapyReceivedEmpty
                                                }
                                                message="Please choose at least one of the provided options or “Unknown” "
                                              />
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </tr>

                                    <tr>
                                      {data.carTCharacteristicsTypeList
                                        .slice(1, 2)
                                        .map((item, index) => (
                                          <>
                                            <td>
                                              <span key={index + 1}>
                                                {item.carTtherapyName}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={1}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Yes
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={2}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={`${idx}_${index + 1}`}
                                                      name={`q42_Therapy_Receive${idx}${
                                                        index + 1
                                                      }`}
                                                      value={99}
                                                      checked={
                                                        item.q42_Therapy_Receive ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <ErrorField
                                                  show={
                                                    item.q42_Therapy_Receive_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {item.q42_Therapy_Receive ===
                                                1 && (
                                                <>
                                                  <div
                                                    style={{
                                                      marginTop: "5px",
                                                      marginBottom: "5px",
                                                    }}
                                                  >
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}_${index + 1}`}
                                                        name={`q42_Therpy_Initiation_Radio${idx}${
                                                          index + 1
                                                        }`}
                                                        value={1}
                                                        checked={
                                                          item.q42_Therpy_Initiation_Radio ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        {/* <DateControl
                                                        ctrlId={`q42_Therpy_Initiation_Date${idx}_${
                                                          index + 1
                                                        }`}
                                                        HandleDateChange={
                                                          HandleRepeatDateChange
                                                        }
                                                        date={
                                                          item.q42_Therpy_Initiation_Date
                                                        }
                                                      /> */}
                                                        <DatePickerComponent
                                                          ctrlId={`q42_Therpy_Initiation_Date${idx}_${
                                                            index + 1
                                                          }`}
                                                          HandleDateChange={
                                                            HandleRepeatDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en"
                                                          date={
                                                            item.q42_Therpy_Initiation_Date
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label
                                                        className="option-fbox"
                                                        style={{
                                                          textAlign: "left",
                                                          // marginLeft: "8px",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}_${
                                                            index + 1
                                                          }`}
                                                          name={`q42_Therpy_Initiation_Radio${idx}${
                                                            index + 1
                                                          }`}
                                                          value={99}
                                                          checked={
                                                            item.q42_Therpy_Initiation_Radio ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span className="radio-text-padding">
                                                          Date of initiation
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                              <ErrorField
                                                show={
                                                  item.q42_R2_Date_Not_Valid
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Valid_Lympo
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_DateInvalid
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therapy_Initiation_NotValid
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Valid_Lympo
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Radio_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q42_Therpy_Initiation_Date_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.q42_Date_Not_Entered_Lympo
                                                }
                                              />
                                            </td>
                                          </>
                                        ))}

                                      <td
                                        style={{
                                          textAlign: "left",
                                          paddingInline: "8px",
                                        }}
                                      >
                                        {data.carTCharacteristicsTypeList[1]
                                          .q42_Therapy_Receive === 1 && (
                                          <>
                                            <div>
                                              {data.carTCharacteristicsReceivedList
                                                .filter(
                                                  (item) =>
                                                    item.carTtherapyId === 2,
                                                )
                                                .map((item, index) => (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                      marginBottom: "4px",
                                                    }}
                                                    key={index}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      // id={`${idx}_${item.carTTherapyReceivedId}`}
                                                      id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                      name={`checkbox${idx}${item.carTTherapyReceivedId}`}
                                                      checked={item.isChecked}
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <div>
                                                      <label
                                                        htmlFor={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                        style={{
                                                          marginLeft: "8px",
                                                        }}
                                                      >
                                                        {
                                                          item.carTtherapyReceivedName
                                                        }
                                                      </label>

                                                      {/* Conditionally render an input text field for a specific checkbox based on ID */}
                                                      {item.carTTherapyReceivedId ===
                                                        33 && (
                                                        <textarea
                                                          type="text"
                                                          // className="input-dashdash"
                                                          id={`${idx}_${item.carTTherapyReceivedId}_${item.carTtherapyId}`}
                                                          name={`Checkboxtext${idx}${item.carTTherapyReceivedId}`}
                                                          value={
                                                            item.carTOtherTxt ||
                                                            ""
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          maxLength={300}
                                                          style={{
                                                            marginLeft: "8px",
                                                            marginTop: "4px",
                                                            display: "flex",
                                                          }}
                                                        />
                                                      )}
                                                      <ErrorField
                                                        style={{
                                                          display: "flex",
                                                          marginLeft: "-18px",
                                                        }}
                                                        show={
                                                          item.carTOtherTxtEmpty
                                                        }
                                                        message="Please enter text for Other option."
                                                      />
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>

                                            {/* Place the "Unknown" radio button after the checkboxes */}
                                            {/* Place the "Unknown" radio button after the checkboxes */}
                                            {/* {carTCharRepeater.carTCharacteristicsTypeList &&
                                          carTCharRepeater
                                            .carTCharacteristicsTypeList
                                            .length > 0 ? ( */}
                                            <div style={{ marginTop: "8px" }}>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={`${idx}_1`}
                                                  name={`q42_CohortTreatment_Unk${idx}1`}
                                                  value={99}
                                                  checked={
                                                    data
                                                      .carTCharacteristicsTypeList[1]
                                                      .q42_CohortTreatment_Unk ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{ marginLeft: "8px" }}
                                                >
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                            {/* // ) : (
                                          //   <div style={{ marginTop: "8px" }}>
                                          //     <label
                                          //     // style={{ marginLeft: "8px" }}
                                          //     >
                                          //       <input
                                          //         type="radio"
                                          //         style={{ marginRight: "8px" }}
                                          //         id={`${idx}_1`}
                                          //         name={`q42_CohortTreatment_Unk${idx}1`}
                                          //         value={99}
                                          //         onChange={
                                          //           HandleRepeaterFieldChange
                                          //         }
                                          //       />
                                          //       Unknown
                                          //     </label>
                                          //   </div>
                                          // )
                                              //  } */}

                                            {/* Error message displayed below "Unknown" */}
                                            {data.carTCharacteristicsTypeList[1]
                                              .q42_Therapy_Receive === 1 && (
                                              <ErrorField
                                                show={
                                                  data
                                                    .carTCharacteristicsTypeList[1]
                                                    .therapyReceivedEmpty
                                                }
                                                message="Please choose at least one of the provided options or “Unknown”  "
                                              />
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5">
                                    No treatment data available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* QUESTION 42.1.A */}

                    {isNewEcrfA && (
                      <div className="question-bot-sapce">
                        <div className="question question-weight">
                          <span style={{ fontWeight: "500" }}>Q42.1.A</span>
                          <span
                            className="quest-text-pad"
                            style={{ fontWeight: "500" }}
                          >
                            Provide information on{" "}
                            <u>
                              <i>all bridging therapy</i>
                            </u>{" "}
                            received prior to infusion with or lymphodepletion
                            therapy for{" "}
                            {filteredList[0]?.cohortTreatmentName && (
                              <>
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {filteredList[0]?.cohortTreatmentName}
                                </span>{" "}
                                (on or before{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  [
                                  {isNewEcrfA
                                    ? carTCharRepeater[0].carTCharacteristicsTypeList.filter(
                                        (item1) => item1.carTTherapyId == 2,
                                      )[0]?.q42_Therpy_Initiation_Date
                                    : carTCharRepeater[0].carTCharacteristicsTypeList
                                        .map(
                                          (i) => i.q42_Therpy_Initiation_Date,
                                        )
                                        .filter(Boolean)
                                        .sort(
                                          (a, b) => new Date(a) - new Date(b),
                                        )[0]}
                                  ]
                                </span>{" "}
                                or{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  [{filteredList[0]?.cohortIndexDate ?? ""}]
                                </span>{" "}
                                )
                              </>
                            )}
                            {filteredList[0]?.cohortTreatmentName &&
                              filteredList[1]?.cohortTreatmentName && (
                                <span> and </span>
                              )}
                            {filteredList[1]?.cohortTreatmentName && (
                              <>
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {filteredList[1]?.cohortTreatmentName}
                                </span>{" "}
                                (on or before{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  [
                                  {isNewEcrfA
                                    ? carTCharRepeater[1].carTCharacteristicsTypeList.filter(
                                        (item1) => item1.carTTherapyId == 2,
                                      )[0]?.q42_Therpy_Initiation_Date
                                    : carTCharRepeater[1].carTCharacteristicsTypeList
                                        .map(
                                          (i) => i.q42_Therpy_Initiation_Date,
                                        )
                                        .filter(Boolean)
                                        .sort(
                                          (a, b) => new Date(a) - new Date(b),
                                        )[0]}
                                  ]
                                </span>{" "}
                                or{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  [{filteredList[1]?.cohortIndexDate ?? ""}]
                                </span>
                                )
                              </>
                            )}
                            <br />
                            <b>
                              . Please enter one row per each regimen.
                              Separately input additional rows if there was any
                              switching in bridging therapy regimens.
                            </b>
                          </span>
                        </div>

                        {/* Ciltacabtagene autoleucel */}
                        {filteredBridgingCitacel &&
                        filteredBridgingCitacel.length > 0
                          ? filteredBridgingCitacel.map((item, idx) => (
                              <div className="loop-section-ul">
                                <div className="loop-head">
                                  <span
                                    className="question-weight"
                                    style={{ float: "inline-start" }}
                                  >
                                    {GetOrdinal(idx + 1)} CARVYKTI®
                                  </span>
                                  {idx != 0 && (
                                    <div
                                      className="delete-btn-div"
                                      style={{ float: "inline-end" }}
                                    >
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleDeleteQ421ARow(13, idx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="question-bot-sapce">
                                  <div className="sub-question">
                                    <div
                                      className=""
                                      style={{ overflowX: "auto" }}
                                    >
                                      <table
                                        border="1"
                                        style={{ overflowX: "auto" }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start date of bridging therapy{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End date of bridging therapy{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Therapy received <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Best response status on bridging
                                              therapy <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of best response assessment{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Method of assessment <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody key={idx}>
                                          <tr>
                                            <td
                                              className="customNoContent"
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    className="option-fbox"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_Start_Bridging_Therapy_13_${idx}`}
                                                      value={1}
                                                      checked={
                                                        item.q421A_Start_Bridging_Therapy ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span className="radio-text-padding">
                                                      No bridging therapy
                                                      received
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={`${idx}`}
                                                    name={`q421A_Start_Bridging_Therapy_13_${idx}`}
                                                    value={2}
                                                    checked={
                                                      item.q421A_Start_Bridging_Therapy ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    <DatePickerComponent
                                                      ctrlId={`q421A_Start_Bridging_Therapy_Date_13-${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                      date={
                                                        item.q421A_Start_Bridging_Therapy_Date
                                                      }
                                                    />
                                                  </span>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    className="option-fbox"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_Start_Bridging_Therapy_13_${idx}`}
                                                      value={99}
                                                      checked={
                                                        item.q421A_Start_Bridging_Therapy ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span className="radio-text-padding">
                                                      Bridging therapy start
                                                      date unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </>
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_Therapy_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_TherapyDate_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.q421A_StartDate_Empty
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_TherapyDate_Invalid
                                                }
                                                message={
                                                  CarTCharMsgs.q421A_StartDate_Not_Valid
                                                }
                                              />
                                            </td>

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_End_Bridging_Therapy_13_${idx}`}
                                                      value={1}
                                                      checked={
                                                        item.q421A_End_Bridging_Therapy ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`q421A_End_Bridging_Therapy_Date_13-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          item.q421A_End_Bridging_Therapy_Date
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_End_Bridging_Therapy_13_${idx}`}
                                                        value={99}
                                                        checked={
                                                          item.q421A_End_Bridging_Therapy ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Bridging therapy end
                                                        date unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>

                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_Therapy_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_TherapyDate_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_EndDate_Empty
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_TherapyDate_Invalid
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_EndDate_Not_Valid
                                                  }
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {receivedTreatments &&
                                                      receivedTreatments.length >
                                                        0 &&
                                                      receivedTreatments.map(
                                                        (category, index) => (
                                                          <div
                                                            key={index}
                                                            style={{
                                                              paddingBottom:
                                                                "10px",
                                                            }}
                                                          >
                                                            <h6>
                                                              {
                                                                category?.category
                                                              }
                                                            </h6>
                                                            {category?.treatments?.map(
                                                              (catItem) => (
                                                                <div
                                                                  key={
                                                                    catItem.prescribedTreatmentId
                                                                  }
                                                                >
                                                                  <label
                                                                    className={`long-text-option ${
                                                                      catItem.name ===
                                                                      "Other, please specify"
                                                                        ? undefined
                                                                        : "radio-text-padding"
                                                                    } `}
                                                                  >
                                                                    <input
                                                                      type="checkbox"
                                                                      id={
                                                                        idx +
                                                                        "_" +
                                                                        catItem.prescribedTreatmentId
                                                                      }
                                                                      name={
                                                                        "chk_q421A_received_tmt_13_" +
                                                                        idx +
                                                                        "_" +
                                                                        catItem.prescribedTreatmentId
                                                                      }
                                                                      checked={
                                                                        item.q421A_selectedReceivedTmtList &&
                                                                        item
                                                                          .q421A_selectedReceivedTmtList
                                                                          .length >
                                                                          0 &&
                                                                        item.q421A_selectedReceivedTmtList.some(
                                                                          (a) =>
                                                                            a.prescribedTreatmentId ===
                                                                            catItem.prescribedTreatmentId,
                                                                        )
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                    />
                                                                    {catItem.name ===
                                                                    "Other, please specify" ? (
                                                                      <span className="radio-text-padding">
                                                                        {
                                                                          catItem.name
                                                                        }
                                                                        :{" "}
                                                                        <textarea
                                                                          style={{
                                                                            width:
                                                                              "264px",
                                                                          }}
                                                                          id={
                                                                            idx +
                                                                            "_" +
                                                                            catItem.prescribedTreatmentId
                                                                          }
                                                                          name={
                                                                            "q421A_txt_received_tmt_oth_13_" +
                                                                            idx +
                                                                            "_" +
                                                                            catItem.prescribedTreatmentId
                                                                          }
                                                                          type="text"
                                                                          value={
                                                                            item.q421A_selectedReceivedTmtList?.find(
                                                                              (
                                                                                a,
                                                                              ) =>
                                                                                a.prescribedTreatmentId ===
                                                                                catItem.prescribedTreatmentId,
                                                                            )
                                                                              ?.prescribedTreatmentOthTxt ??
                                                                            ""
                                                                          }
                                                                          onChange={
                                                                            HandleRepeaterFieldChange
                                                                          }
                                                                          maxLength={
                                                                            300
                                                                          }
                                                                          className="option-fbox"
                                                                        />
                                                                      </span>
                                                                    ) : (
                                                                      <span className="radio-text-padding">
                                                                        {
                                                                          catItem.name
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </label>
                                                                </div>
                                                              ),
                                                            )}
                                                          </div>
                                                        ),
                                                      )}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={
                                                            idx +
                                                            "_" +
                                                            item.prescribedTreatmentId
                                                          }
                                                          name={
                                                            "q421A_rb_received_tmt_unk_13_" +
                                                            idx +
                                                            "_" +
                                                            item.prescribedTreatmentId
                                                          }
                                                          checked={
                                                            item.q421A_rb_received_tmt_unk
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={item.q421A_empty_err}
                                                    message={
                                                      CarTCharMsgs.q421A_C
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      item.q421A_txt_empty_err
                                                    }
                                                    message={
                                                      CarTCharMsgs.q421A_C_txt
                                                    }
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={5}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Minimal response (MR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={6}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          6
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stable disease (SD)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={7}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          7
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Progressive disease (PD)
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_13_" +
                                                          idx
                                                        }
                                                        value={8}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          8
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_Status_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                              1 &&
                                            item.q421A_BestResponse_Status !==
                                              8 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_BestResponse_Assessment_13_${idx}`}
                                                        value={1}
                                                        checked={
                                                          item.q421A_BestResponse_Assessment ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Best response assessed
                                                        on:
                                                        <br />
                                                        <DatePickerComponent
                                                          ctrlId={`q421A_BestResponse_Assessment_Date_13-${idx}`}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en"
                                                          date={
                                                            item.q421A_BestResponse_Assessment_Date
                                                          }
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_BestResponse_Assessment_13_${idx}`}
                                                        value={99}
                                                        checked={
                                                          item.q421A_BestResponse_Assessment ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Best response occurred
                                                        but date of assessment
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_Assessment_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_AssessmentDate_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_BRDate_Empty
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_AssessmentDate_Invalid
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_BRDate_Not_Valid
                                                  }
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                              1 &&
                                            item.q421A_BestResponse_Status !==
                                              8 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_13_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Standard IMWG Reporting
                                                        Criteria
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_13_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Other standard response
                                                        criteria
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_13_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        No standard criteria
                                                        mentioned in chart
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    item.q421A_Method_Assessment_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          : null}

                        {filteredBridgingCitacel &&
                          filteredBridgingCitacel.length > 0 && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div
                                className="answer-list-text"
                                onClick={() => {
                                  AddQ421ARow(13);
                                }}
                              >
                                <a>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add another assessment
                                </a>
                              </div>
                            </div>
                          )}

                        {/* Abecma */}
                        {filteredBridgingAbecma &&
                        filteredBridgingAbecma.length > 0
                          ? filteredBridgingAbecma.map((item, idx) => (
                              <div className="loop-section-ul">
                                <div className="loop-head">
                                  <span
                                    className="question-weight"
                                    style={{ float: "inline-start" }}
                                  >
                                    {GetOrdinal(idx + 1)} ABECMA®
                                  </span>
                                  {idx != 0 && (
                                    <div
                                      className="delete-btn-div"
                                      style={{ float: "inline-end" }}
                                    >
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleDeleteQ421ARow(14, idx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="question-bot-sapce">
                                  <div className="sub-question">
                                    <div
                                      className=""
                                      style={{ overflowX: "auto" }}
                                    >
                                      {/* Idecabtagene vicleucel */}
                                      <table border="1">
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start date of bridging therapy{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End date of bridging therapy{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Therapy received <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Best response status on bridging
                                              therapy <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of best response assessment{" "}
                                              <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Method of assessment <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody key={idx}>
                                          <tr>
                                            <td
                                              className="customNoContent"
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    className="option-fbox"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_Start_Bridging_Therapy_14_${idx}`}
                                                      value={1}
                                                      checked={
                                                        item.q421A_Start_Bridging_Therapy ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span className="radio-text-padding">
                                                      No bridging therapy
                                                      received
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={`${idx}`}
                                                    name={`q421A_Start_Bridging_Therapy_14_${idx}`}
                                                    value={2}
                                                    checked={
                                                      item.q421A_Start_Bridging_Therapy ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    <DatePickerComponent
                                                      ctrlId={`q421A_Start_Bridging_Therapy_Date_14-${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                      date={
                                                        item.q421A_Start_Bridging_Therapy_Date
                                                      }
                                                    />
                                                  </span>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label
                                                    className="option-fbox"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_Start_Bridging_Therapy_14_${idx}`}
                                                      value={99}
                                                      checked={
                                                        item.q421A_Start_Bridging_Therapy ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span className="radio-text-padding">
                                                      Bridging therapy start
                                                      date unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </>
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_Therapy_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_TherapyDate_Empty
                                                }
                                                message={
                                                  CarTCharMsgs.q421A_StartDate_Empty
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  item.q421A_Start_Bridging_TherapyDate_Invalid
                                                }
                                                message={
                                                  CarTCharMsgs.q421A_StartDate_Not_Valid
                                                }
                                              />
                                            </td>

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q421A_End_Bridging_Therapy_14_${idx}`}
                                                      value={1}
                                                      checked={
                                                        item.q421A_End_Bridging_Therapy ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`q421A_End_Bridging_Therapy_Date_14-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          item.q421A_End_Bridging_Therapy_Date
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_End_Bridging_Therapy_14_${idx}`}
                                                        value={99}
                                                        checked={
                                                          item.q421A_End_Bridging_Therapy ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Bridging therapy end
                                                        date unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>

                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_Therapy_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_TherapyDate_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_EndDate_Empty
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_End_Bridging_TherapyDate_Invalid
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_EndDate_Not_Valid
                                                  }
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {receivedTreatments &&
                                                      receivedTreatments.length >
                                                        0 &&
                                                      receivedTreatments.map(
                                                        (category, index) => (
                                                          <div
                                                            key={index}
                                                            style={{
                                                              paddingBottom:
                                                                "10px",
                                                            }}
                                                          >
                                                            <h6>
                                                              {
                                                                category?.category
                                                              }
                                                            </h6>
                                                            {category?.treatments?.map(
                                                              (catItem) => (
                                                                <div
                                                                  key={
                                                                    catItem.prescribedTreatmentId
                                                                  }
                                                                >
                                                                  <label
                                                                    className={`long-text-option ${
                                                                      catItem.name ===
                                                                      "Other, please specify"
                                                                        ? undefined
                                                                        : "radio-text-padding"
                                                                    } `}
                                                                  >
                                                                    <input
                                                                      type="checkbox"
                                                                      id={
                                                                        idx +
                                                                        "_" +
                                                                        catItem.prescribedTreatmentId
                                                                      }
                                                                      name={
                                                                        "chk_q421A_received_tmt_14_" +
                                                                        idx +
                                                                        "_" +
                                                                        catItem.prescribedTreatmentId
                                                                      }
                                                                      checked={
                                                                        item.q421A_selectedReceivedTmtList &&
                                                                        item
                                                                          .q421A_selectedReceivedTmtList
                                                                          .length >
                                                                          0 &&
                                                                        item.q421A_selectedReceivedTmtList.some(
                                                                          (a) =>
                                                                            a.prescribedTreatmentId ===
                                                                            catItem.prescribedTreatmentId,
                                                                        )
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                    />
                                                                    {catItem.name ===
                                                                    "Other, please specify" ? (
                                                                      <span className="radio-text-padding">
                                                                        {
                                                                          catItem.name
                                                                        }
                                                                        :{" "}
                                                                        <textarea
                                                                          style={{
                                                                            width:
                                                                              "264px",
                                                                          }}
                                                                          id={
                                                                            idx +
                                                                            "_" +
                                                                            catItem.prescribedTreatmentId
                                                                          }
                                                                          name={
                                                                            "q421A_txt_received_tmt_oth_14_" +
                                                                            idx +
                                                                            "_" +
                                                                            catItem.prescribedTreatmentId
                                                                          }
                                                                          type="text"
                                                                          value={
                                                                            item.q421A_selectedReceivedTmtList?.find(
                                                                              (
                                                                                a,
                                                                              ) =>
                                                                                a.prescribedTreatmentId ===
                                                                                catItem.prescribedTreatmentId,
                                                                            )
                                                                              ?.prescribedTreatmentOthTxt ??
                                                                            ""
                                                                          }
                                                                          onChange={
                                                                            HandleRepeaterFieldChange
                                                                          }
                                                                          maxLength={
                                                                            300
                                                                          }
                                                                          className="option-fbox"
                                                                        />
                                                                      </span>
                                                                    ) : (
                                                                      <span className="radio-text-padding">
                                                                        {
                                                                          catItem.name
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </label>
                                                                </div>
                                                              ),
                                                            )}
                                                          </div>
                                                        ),
                                                      )}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={
                                                            idx +
                                                            "_" +
                                                            item.prescribedTreatmentId
                                                          }
                                                          name={
                                                            "q421A_rb_received_tmt_unk_14_" +
                                                            idx +
                                                            "_" +
                                                            item.prescribedTreatmentId
                                                          }
                                                          checked={
                                                            item.q421A_rb_received_tmt_unk
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={item.q421A_empty_err}
                                                    message={
                                                      CarTCharMsgs.q421A_C
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      item.q421A_txt_empty_err
                                                    }
                                                    message={
                                                      CarTCharMsgs.q421A_C_txt
                                                    }
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                            1 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={5}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Minimal response (MR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={6}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          6
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stable disease (SD)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={7}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          7
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Progressive disease (PD)
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_BestResponse_Status_14_" +
                                                          idx
                                                        }
                                                        value={8}
                                                        checked={
                                                          item.q421A_BestResponse_Status ===
                                                          8
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_Status_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                              1 &&
                                            item.q421A_BestResponse_Status !==
                                              8 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_BestResponse_Assessment_14_${idx}`}
                                                        value={1}
                                                        checked={
                                                          item.q421A_BestResponse_Assessment ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Best response assessed
                                                        on:
                                                        <br />
                                                        <DatePickerComponent
                                                          ctrlId={`q421A_BestResponse_Assessment_Date_14-${idx}`}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en"
                                                          date={
                                                            item.q421A_BestResponse_Assessment_Date
                                                          }
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q421A_BestResponse_Assessment_14_${idx}`}
                                                        value={99}
                                                        checked={
                                                          item.q421A_BestResponse_Assessment ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Best response occurred
                                                        but date of assessment
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </>
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_Assessment_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_AssessmentDate_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_BRDate_Empty
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    item.q421A_BestResponse_AssessmentDate_Invalid
                                                  }
                                                  message={
                                                    CarTCharMsgs.q421A_BRDate_Not_Valid
                                                  }
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}

                                            {item.q421A_Start_Bridging_Therapy >
                                              1 &&
                                            item.q421A_BestResponse_Status !==
                                              8 ? (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_14_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Standard IMWG Reporting
                                                        Criteria
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_14_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Other standard response
                                                        criteria
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "q421A_Method_Assessment_14_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          item.q421A_Method_Assessment ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        No standard criteria
                                                        mentioned in chart
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    item.q421A_Method_Assessment_Empty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>
                                            ) : (
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <b>Not applicable</b>
                                              </td>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          : null}

                        {filteredBridgingAbecma &&
                          filteredBridgingAbecma.length > 0 && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div
                                className="answer-list-text"
                                onClick={() => {
                                  AddQ421ARow(14);
                                }}
                              >
                                <a>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add another assessment
                                </a>
                              </div>
                            </div>
                          )}
                      </div>
                    )}

                    <div className="question-bot-sapce">
                      {/* Question 43 */}
                      <div className="sub-question" style={{ padding: "0px" }}>
                        <div
                          className="table-page"
                          style={{ paddingTop: "15px" }}
                        >
                          <div className="question question-weight">
                            <span style={{ fontWeight: "500" }}>Q43.</span>
                            <span
                              className="quest-text-pad"
                              style={{ fontWeight: "500" }}
                            >
                              Provide information on any procedures received
                              while receiving treatment with{" "}
                              {filteredList[0]?.cohortTreatmentName && (
                                <>
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {filteredList[0]?.cohortTreatmentName}
                                  </span>{" "}
                                  (from{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    [{filteredList[0]?.cohortIndexDate ?? ""}]
                                  </span>{" "}
                                  to{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    [
                                    {displayNdmmEndOfDates(
                                      filteredList[0]?.cohortTreatmentID,
                                    )}
                                    ]
                                  </span>
                                  )
                                </>
                              )}
                              {filteredList[0]?.cohortTreatmentName &&
                                filteredList[1]?.cohortTreatmentName && (
                                  <span> and </span>
                                )}
                              {filteredList[1]?.cohortTreatmentName && (
                                <>
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {filteredList[1]?.cohortTreatmentName}
                                  </span>{" "}
                                  (from{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    [{filteredList[1]?.cohortIndexDate ?? ""}]
                                  </span>{" "}
                                  to{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    [
                                    {displayNdmmEndOfDates(
                                      filteredList[1]?.cohortTreatmentID,
                                    )}
                                    ]
                                  </span>
                                  )
                                </>
                              )}
                              . Add additional rows for each procedure.
                            </span>
                          </div>

                          {/* Ciltacabtagene autoleucel */}
                          {filteredCiltacabtageneCarTChar &&
                          filteredCiltacabtageneCarTChar.length > 0
                            ? filteredCiltacabtageneCarTChar.map(
                                (data, idx) => (
                                  <div className="loop-section-ul">
                                    <div className="loop-head">
                                      <span
                                        className="question-weight"
                                        style={{ float: "inline-start" }}
                                      >
                                        {GetOrdinal(idx + 1)} CARVYKTI®
                                      </span>
                                      {idx != 0 && (
                                        <div
                                          className="delete-btn-div"
                                          style={{ float: "inline-end" }}
                                        >
                                          <img
                                            width="16px"
                                            src="../Assets/images/Icon-material-delete.png"
                                            alt=""
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              handleDeleteQ43Row(13, idx)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="question-bot-sapce">
                                      <div className="sub-question">
                                        <table border="1">
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Treatment <br />
                                                <span
                                                  style={{
                                                    color:
                                                      PageDesignConstants.fontColor,
                                                  }}
                                                ></span>
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Date of procedure
                                                <span
                                                  style={{
                                                    color:
                                                      PageDesignConstants.fontColor,
                                                  }}
                                                ></span>
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Type of procedure <br />
                                                <span
                                                  style={{
                                                    color:
                                                      PageDesignConstants.fontColor,
                                                  }}
                                                ></span>
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody key={idx}>
                                            <tr>
                                              <td rowSpan={2}>
                                                {data.treatmentName}
                                              </td>
                                              <td
                                                className="customNoContent"
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label>
                                                      <input
                                                        type="radio"
                                                        id={`${idx}`}
                                                        name={`q43B_No_Procedure_Rcvd_13_${idx}`}
                                                        value={1}
                                                        checked={
                                                          data.q43B_No_Procedure_Rcvd !==
                                                            null &&
                                                          data.q43B_No_Procedure_Rcvd ===
                                                            1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No procedures were
                                                        received
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q43B_No_Procedure_Rcvd_13_${idx}`}
                                                      value={2}
                                                      checked={
                                                        data.q43B_No_Procedure_Rcvd !==
                                                          null &&
                                                        data.q43B_No_Procedure_Rcvd ===
                                                          2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      {/* <DateControl
                                                ctrlId={`q43B_Procedure_Date-${idx}`}
                                                HandleDateChange={
                                                  HandleRepeaterDateChange
                                                }
                                                date={data.q43B_Procedure_Date}
                                              /> */}
                                                      <DatePickerComponent
                                                        ctrlId={`q43B_Procedure_Date_13-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          data.q43B_Procedure_Date
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                </span>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q43B_No_Procedure_Rcvd_13_${idx}`}
                                                      value={99}
                                                      checked={
                                                        data.q43B_No_Procedure_Rcvd !==
                                                          null &&
                                                        data.q43B_No_Procedure_Rcvd ===
                                                          99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Date of procedure unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <ErrorField
                                                  show={
                                                    data.q43B_No_Procedure_RcvdEmpty
                                                  }
                                                  message={
                                                    CarTCharMsgs.carTEmpty_Msg
                                                  }
                                                />
                                                <ErrorField
                                                  show={
                                                    data.q43B_Procedure_DateEmpty
                                                  }
                                                  message={
                                                    CarTCharMsgs.q43_Date_Empty
                                                  }
                                                />

                                                <ErrorField
                                                  show={
                                                    data.q43_Procedure_InvalidDate
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                />

                                                <ErrorField
                                                  show={data.q43_Date_Valid}
                                                  message={
                                                    CarTCharMsgs.q43_Date_Not_Valid
                                                  }
                                                />
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                {[2, 99].includes(
                                                  data.q43B_No_Procedure_Rcvd,
                                                ) && (
                                                  <div className="customNoContent">
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Radiography
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Electroencephalogram
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={3}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              3
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Electrocardiogram
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={4}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              4
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Lumbar puncture
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={5}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              5
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Magnetic resonance
                                                            imaging (MRI)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={6}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              6
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Hemodialysis
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "11px",
                                                          }}
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_13_${idx}`}
                                                          value={7}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            7
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <div
                                                          style={{
                                                            marginLeft: "5px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              marginLeft:
                                                                "-5px",
                                                              paddingTop: "4px",
                                                            }}
                                                          >
                                                            Other, please
                                                            specify &nbsp;
                                                            <textarea
                                                              style={{
                                                                width: "264px",
                                                                marginTop:
                                                                  "4px",
                                                                display: "flex",
                                                              }}
                                                              // className="input-dashdash"
                                                              id={`${idx}`}
                                                              name={`q43C_ProcedureType_Txt_13_${idx}`}
                                                              type="text"
                                                              value={
                                                                data.q43C_ProcedureType_Txt ||
                                                                ""
                                                              }
                                                              maxLength={300}
                                                              max={100}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                      </label>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_13_${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.q43C_ProcedureType ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.q43C_ProcedureTypeEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_Radio_Empty
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43C_ProcedureType_TxtEmpty
                                                      }
                                                      message={
                                                        "Please enter text for Other option."
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            : null}

                          {filteredCiltacabtageneCarTChar &&
                            filteredCiltacabtageneCarTChar.length > 0 &&
                            showClickToAddMore_13 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => {
                                    AddQ43Row(13);
                                  }}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another assessment
                                  </a>
                                </div>
                              </div>
                            )}

                          {/* Abecma */}
                          {filteredIdecabtageneCarTChar &&
                          filteredIdecabtageneCarTChar.length > 0
                            ? filteredIdecabtageneCarTChar.map((data, idx) => (
                                <div className="loop-section-ul">
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} ABECMA®
                                    </span>
                                    {idx != 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleDeleteQ43Row(14, idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="question-bot-sapce">
                                    <div className="sub-question">
                                      {/* Idecabtagene vicleucel */}
                                      <table border="1">
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of procedure
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Type of procedure <br />
                                              <span
                                                style={{
                                                  color:
                                                    PageDesignConstants.fontColor,
                                                }}
                                              ></span>
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody key={idx}>
                                          <tr>
                                            <td rowSpan={2}>
                                              {data.treatmentName}
                                            </td>
                                            <td
                                              className="customNoContent"
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={`${idx}`}
                                                      name={`q43B_No_Procedure_Rcvd_14_${idx}`}
                                                      value={1}
                                                      checked={
                                                        data.q43B_No_Procedure_Rcvd !==
                                                          null &&
                                                        data.q43B_No_Procedure_Rcvd ===
                                                          1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No procedures were
                                                      received
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={`${idx}`}
                                                    name={`q43B_No_Procedure_Rcvd_14_${idx}`}
                                                    value={2}
                                                    checked={
                                                      data.q43B_No_Procedure_Rcvd !==
                                                        null &&
                                                      data.q43B_No_Procedure_Rcvd ===
                                                        2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    {/* <DateControl
                                                ctrlId={`q43B_Procedure_Date-${idx}`}
                                                HandleDateChange={
                                                  HandleRepeaterDateChange
                                                }
                                                date={data.q43B_Procedure_Date}
                                              /> */}
                                                    <DatePickerComponent
                                                      ctrlId={`q43B_Procedure_Date_14-${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                      date={
                                                        data.q43B_Procedure_Date
                                                      }
                                                    />
                                                  </span>
                                                </div>
                                              </span>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label>
                                                  <input
                                                    type="radio"
                                                    id={`${idx}`}
                                                    name={`q43B_No_Procedure_Rcvd_14_${idx}`}
                                                    value={99}
                                                    checked={
                                                      data.q43B_No_Procedure_Rcvd !==
                                                        null &&
                                                      data.q43B_No_Procedure_Rcvd ===
                                                        99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Date of procedure unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.q43B_No_Procedure_RcvdEmpty
                                                }
                                                message={
                                                  CarTCharMsgs.carTEmpty_Msg
                                                }
                                              />
                                              <ErrorField
                                                show={
                                                  data.q43B_Procedure_DateEmpty
                                                }
                                                message={
                                                  CarTCharMsgs.q43_Date_Empty
                                                }
                                              />

                                              <ErrorField
                                                show={
                                                  data.q43_Procedure_InvalidDate
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                              />

                                              <ErrorField
                                                show={data.q43_Date_Valid}
                                                message={
                                                  CarTCharMsgs.q43_Date_Not_Valid
                                                }
                                              />
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {[2, 99].includes(
                                                data.q43B_No_Procedure_Rcvd,
                                              ) && (
                                                <div className="customNoContent">
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Radiography
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={2}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Electroencephalogram
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={3}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Electrocardiogram
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={4}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Lumbar puncture
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={5}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Magnetic resonance
                                                          imaging (MRI)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={6}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            6
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Hemodialysis
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "11px",
                                                        }}
                                                        id={`${idx}`}
                                                        name={`q43C_ProcedureType_14_${idx}`}
                                                        value={7}
                                                        checked={
                                                          data.q43C_ProcedureType ===
                                                          7
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <label
                                                        style={{
                                                          marginLeft: "5px",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                            paddingTop: "4px",
                                                          }}
                                                        >
                                                          Other, please specify
                                                          &nbsp;
                                                          <textarea
                                                            style={{
                                                              width: "264px",
                                                              marginTop: "4px",
                                                              display: "flex",
                                                            }}
                                                            // className="input-dashdash"
                                                            id={`${idx}`}
                                                            name={`q43C_ProcedureType_Txt_14_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.q43C_ProcedureType_Txt ||
                                                              ""
                                                            }
                                                            maxLength={300}
                                                            max={100}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43C_ProcedureType_14_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.q43C_ProcedureType ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.q43C_ProcedureTypeEmpty
                                                    }
                                                    message={
                                                      CarTCharMsgs.q43_Radio_Empty
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.q43C_ProcedureType_TxtEmpty
                                                    }
                                                    message={
                                                      "Please enter text for Other option."
                                                    }
                                                  />
                                                </div>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : null}

                          {filteredIdecabtageneCarTChar &&
                            filteredIdecabtageneCarTChar.length > 0 &&
                            showClickToAddMore_14 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => {
                                    AddQ43Row(14);
                                  }}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another assessment
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>

                      {isNewEcrfA && (
                        <>
                          {/* Question 43.1.A */}
                          <div
                            className="sub-question"
                            style={{ padding: "0px" }}
                          >
                            <div
                              className="table-page"
                              style={{ paddingTop: "15px" }}
                            >
                              <div className="question question-weight">
                                <span style={{ fontWeight: "500" }}>
                                  Q43.1.A
                                </span>
                                <span
                                  className="quest-text-pad"
                                  style={{ fontWeight: "500" }}
                                >
                                  Provide information on each administration of
                                  tocilizumab received during the CAR-T line of
                                  therapy with{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[0]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {filteredList[0]?.cohortIndexDate ?? ""}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[0]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {filteredList[1]?.cohortIndexDate ?? ""}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[1]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  . Add additional rows for each administration.{" "}
                                  <i>Select all that apply.</i>
                                </span>
                              </div>

                              {/* Ciltacabtagene autoleucel */}
                              {filteredCiltacabtageneCarTTocilizumabChar &&
                              filteredCiltacabtageneCarTTocilizumabChar.length >
                                0
                                ? filteredCiltacabtageneCarTTocilizumabChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} CARVYKTI®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_1_Row(13, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of tocilizumab
                                                    administration
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Reason for receiving
                                                    medication <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      {idx === 0 && (
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_1B_No_Tocilizumab_Rcvd_13_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_1B_No_Tocilizumab_Rcvd !==
                                                                  null &&
                                                                data.q43_1B_No_Tocilizumab_Rcvd ===
                                                                  1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Tocilizumab not
                                                              received
                                                            </span>
                                                          </label>
                                                        </div>
                                                      )}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_1B_No_Tocilizumab_Rcvd_13_${idx}`}
                                                          value={2}
                                                          checked={
                                                            data.q43_1B_No_Tocilizumab_Rcvd !==
                                                              null &&
                                                            data.q43_1B_No_Tocilizumab_Rcvd ===
                                                              2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          {/* <DateControl
                                                ctrlId={`q43B_Procedure_Date-${idx}`}
                                                HandleDateChange={
                                                  HandleRepeaterDateChange
                                                }
                                                date={data.q43B_Procedure_Date}
                                              /> */}
                                                          <DatePickerComponent
                                                            ctrlId={`q43_1B_Tocilizumab_Date_13-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_1B_Tocilizumab_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_1B_No_Tocilizumab_Rcvd_13_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.q43_1B_No_Tocilizumab_Rcvd !==
                                                              null &&
                                                            data.q43_1B_No_Tocilizumab_Rcvd ===
                                                              99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Date of administration
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.q43_1B_No_Tocilizumab_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_1B_Tocilizumab_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_1_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_1_Tocilizumab_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_1_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_1_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_1B_No_Tocilizumab_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_cytokin_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_cytokin
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Primary
                                                                prophylactic for
                                                                cytokine release
                                                                syndrome (CRS)
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_secondary_prophylactic_crs_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_secondary_prophylactic_crs
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Secondary
                                                                prophylactic for
                                                                CRS
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_crs_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_crs
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Treatment or
                                                                supportive care
                                                                for CRS
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_primary_prophylactic_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_primary_prophylactic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Primary
                                                                prophylactic for
                                                                neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_secondary_prophylactic_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_secondary_prophylactic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Secondary
                                                                prophylactic for
                                                                neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_tmt_neurologic_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_tmt_neurologic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Treatment or
                                                                supportive care
                                                                for neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_reason_other_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_reason_other
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Other
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option">
                                                              <input
                                                                type="radio"
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                id={idx}
                                                                name={
                                                                  "q43_1C_reason_unknown_13_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_reason_unknown
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </label>
                                                          </div>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_1C_ReasonEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredCiltacabtageneCarTTocilizumabChar &&
                                filteredCiltacabtageneCarTTocilizumabChar.length >
                                  0 &&
                                showTocilizumabClickToAddMore_13 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_1_Row(13);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}

                              {filteredIdecabtageneCarTTocilizumabChar &&
                              filteredIdecabtageneCarTTocilizumabChar.length > 0
                                ? filteredIdecabtageneCarTTocilizumabChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} ABECMA®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_1_Row(14, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            {/* Idecabtagene vicleucel */}
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of tocilizumab
                                                    administration
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Reason for receiving
                                                    medication <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      {idx === 0 && (
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_1B_No_Tocilizumab_Rcvd_14_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_1B_No_Tocilizumab_Rcvd !==
                                                                  null &&
                                                                data.q43_1B_No_Tocilizumab_Rcvd ===
                                                                  1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Tocilizumab not
                                                              received
                                                            </span>
                                                          </label>
                                                        </div>
                                                      )}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_1B_No_Tocilizumab_Rcvd_14_${idx}`}
                                                          value={2}
                                                          checked={
                                                            data.q43_1B_No_Tocilizumab_Rcvd !==
                                                              null &&
                                                            data.q43_1B_No_Tocilizumab_Rcvd ===
                                                              2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          {/* <DateControl
                                                ctrlId={`q43B_Procedure_Date-${idx}`}
                                                HandleDateChange={
                                                  HandleRepeaterDateChange
                                                }
                                                date={data.q43B_Procedure_Date}
                                              /> */}
                                                          <DatePickerComponent
                                                            ctrlId={`q43_1B_Tocilizumab_Date_14-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_1B_Tocilizumab_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_1B_No_Tocilizumab_Rcvd_14_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.q43_1B_No_Tocilizumab_Rcvd !==
                                                              null &&
                                                            data.q43_1B_No_Tocilizumab_Rcvd ===
                                                              99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Date of administration
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.q43_1B_No_Tocilizumab_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_1B_Tocilizumab_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_1_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_1_Tocilizumab_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_1_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_1_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_1B_No_Tocilizumab_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "8px",
                                                                }}
                                                                name={
                                                                  "q43_1C_cytokin_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_cytokin
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Primary
                                                                prophylactic for
                                                                cytokine release
                                                                syndrome (CRS)
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_secondary_prophylactic_crs_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_secondary_prophylactic_crs
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Secondary
                                                                prophylactic for
                                                                CRS
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_crs_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_crs
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Treatment or
                                                                supportive care
                                                                for CRS
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_primary_prophylactic_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_primary_prophylactic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Primary
                                                                prophylactic for
                                                                neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_secondary_prophylactic_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_secondary_prophylactic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Secondary
                                                                prophylactic for
                                                                neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option align-items-start">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_tmt_neurologic_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_tmt_neurologic
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Treatment or
                                                                supportive care
                                                                for neurologic
                                                                events
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="">
                                                            <label className="checkbox-option">
                                                              <input
                                                                type="checkbox"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_reason_other_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_reason_other
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Other
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div className="">
                                                            <label className="checkbox-option">
                                                              <input
                                                                type="radio"
                                                                id={idx}
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                name={
                                                                  "q43_1C_reason_unknown_14_" +
                                                                  idx
                                                                }
                                                                checked={
                                                                  data.q43_1C_reason_unknown
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </label>
                                                          </div>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_1C_ReasonEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredIdecabtageneCarTTocilizumabChar &&
                                filteredIdecabtageneCarTTocilizumabChar.length >
                                  0 &&
                                showTocilizumabClickToAddMore_14 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_1_Row(14);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* Question 43.2.A */}
                          <div
                            className="sub-question"
                            style={{ padding: "0px" }}
                          >
                            <div
                              className="table-page"
                              style={{ paddingTop: "15px" }}
                            >
                              <div className="question question-weight">
                                <span style={{ fontWeight: "500" }}>
                                  Q43.2.A
                                </span>
                                <span
                                  className="quest-text-pad"
                                  style={{ fontWeight: "500" }}
                                >
                                  Provide information on{" "}
                                  <i>
                                    each intravenous (IV) corticosteroid
                                    administration received
                                  </i>{" "}
                                  from 1 month before through the end of the
                                  CAR-T line of therapy with{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[0]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {filteredList[0]?.cohortIndexDate ?? ""}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[0]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {filteredList[1]?.cohortIndexDate ?? ""}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[1]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  . Add additional rows for each administration.{" "}
                                  <br />
                                  <br />
                                  <b>Note:</b> please report only IV
                                  corticosteroid episodes where treatment was
                                  received as prophylactic or for the management
                                  and/or treatment of an AE.
                                </span>
                              </div>

                              {/* Ciltacabtagene autoleucel */}
                              {filteredCiltacabtageneCarTCorticosteroidChar &&
                              filteredCiltacabtageneCarTCorticosteroidChar.length >
                                0
                                ? filteredCiltacabtageneCarTCorticosteroidChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} CARVYKTI®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_2_Row(13, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of administration
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Type of corticosteroid{" "}
                                                    <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Dose strength <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Reason for corticosteroid
                                                    usage <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      {idx === 0 && (
                                                        <div className="option-without-input">
                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_2B_No_Corticosteroid_Rcvd_13_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_2B_No_Corticosteroid_Rcvd !==
                                                                  null &&
                                                                data.q43_2B_No_Corticosteroid_Rcvd ===
                                                                  1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              IV corticosteroids
                                                              not received
                                                            </span>
                                                          </label>
                                                        </div>
                                                      )}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_2B_No_Corticosteroid_Rcvd_13_${idx}`}
                                                          value={2}
                                                          checked={
                                                            data.q43_2B_No_Corticosteroid_Rcvd !==
                                                              null &&
                                                            data.q43_2B_No_Corticosteroid_Rcvd ===
                                                              2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={`q43_2B_Corticosteroid_Date_13-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_2B_Corticosteroid_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    <div className="option-without-input">
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_2B_No_Corticosteroid_Rcvd_13_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.q43_2B_No_Corticosteroid_Rcvd !==
                                                              null &&
                                                            data.q43_2B_No_Corticosteroid_Rcvd ===
                                                              99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Date of administration
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.q43_2B_No_Corticosteroid_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_2B_Corticosteroid_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_2_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_2_Corticosteroid_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_2_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_2_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Betamethasone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="option-without-input">
                                                            <label
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />

                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Dexamethasone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                IV
                                                                hydrocortisone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="option-without-input">
                                                            <label
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={4}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  4
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Methylprednisolone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={5}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  5
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Prednisone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={6}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  6
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Prednisolone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                                value={7}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  7
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Triamcinolone
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "11px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                              value={8}
                                                              checked={
                                                                data.q43_2C_CorticosteroidType ===
                                                                8
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "5px",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                  paddingTop:
                                                                    "4px",
                                                                }}
                                                              >
                                                                Other
                                                              </span>
                                                            </div>
                                                          </label>

                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "11px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2C_CorticosteroidType_13_${idx}`}
                                                              value={9}
                                                              checked={
                                                                data.q43_2C_CorticosteroidType ===
                                                                9
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "5px",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                  paddingTop:
                                                                    "4px",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2C_CorticosteroidType_Empty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_13_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_13_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />

                                                              <span className="radio-text-padding d-flex ">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_mg_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_mg
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} mg
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_13_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_13_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />

                                                              <span className="radio-text-padding d-flex ">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_kg_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_kg
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} mg/kg
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_13_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_13_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span className="radio-text-padding d-flex flex-wrap">
                                                                <div>
                                                                  Other, please
                                                                  specify:{" "}
                                                                  {""}{" "}
                                                                </div>
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_other_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_other
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <label className="d-flex align-items-start mt-2">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2D_DoseStrength_13_${idx}`}
                                                              value={99}
                                                              checked={
                                                                data.q43_2D_DoseStrength ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              htmlFor={`q43_2D_DoseStrength_13_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrength_Empty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrength_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_txt
                                                          }
                                                        />

                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrengthMGRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_RangeMGtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrengthKGRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_RangeKGtxt
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <>
                                                        <div className="">
                                                          {data.q43_2E_reasonCorticosteroid &&
                                                            data
                                                              .q43_2E_reasonCorticosteroid
                                                              .length > 0 &&
                                                            data.q43_2E_reasonCorticosteroid.map(
                                                              (item, index) => (
                                                                <div
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    key={
                                                                      item.cartcharacteristicscorticosteroidreasonid
                                                                    }
                                                                    style={{
                                                                      marginLeft:
                                                                        [
                                                                          1, 2,
                                                                          3, 21,
                                                                          22,
                                                                        ].includes(
                                                                          item.cartcharacteristicscorticosteroidreasonid,
                                                                        )
                                                                          ? "0px"
                                                                          : [
                                                                                7,
                                                                                8,
                                                                                9,
                                                                                10,
                                                                                11,
                                                                                12,
                                                                                13,
                                                                              ].includes(
                                                                                item.cartcharacteristicscorticosteroidreasonid,
                                                                              )
                                                                            ? "80px"
                                                                            : "30px",
                                                                    }}
                                                                  >
                                                                    <label
                                                                      className={
                                                                        "long-text-option radio-text-padding"
                                                                      }
                                                                      style={{
                                                                        textAlign:
                                                                          "left",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type={
                                                                          item.name ===
                                                                            "Unknown" ||
                                                                          item.name ===
                                                                            "Unknown type of AE"
                                                                            ? "radio"
                                                                            : "checkbox"
                                                                        }
                                                                        id={
                                                                          idx +
                                                                          "_" +
                                                                          item.cartcharacteristicscorticosteroidreasonid
                                                                        }
                                                                        name={
                                                                          "q43_2E_reasonCorticosteroid_13_" +
                                                                          idx +
                                                                          "_" +
                                                                          item.cartcharacteristicscorticosteroidreasonid
                                                                        }
                                                                        checked={
                                                                          data.q43_2E_selectedReasonCorticosteroid &&
                                                                          data
                                                                            .q43_2E_selectedReasonCorticosteroid
                                                                            .length >
                                                                            0 &&
                                                                          data.q43_2E_selectedReasonCorticosteroid?.some(
                                                                            (
                                                                              a,
                                                                            ) =>
                                                                              a.cartcharacteristicscorticosteroidreasonid ===
                                                                              item.cartcharacteristicscorticosteroidreasonid,
                                                                          )
                                                                        }
                                                                        onChange={
                                                                          HandleRepeaterFieldChange
                                                                        }
                                                                      />
                                                                      {item.name ===
                                                                      "Other neurologic event, please specify: " ? (
                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            item.name
                                                                          }{" "}
                                                                          <textarea
                                                                            style={{
                                                                              width:
                                                                                "264px",
                                                                            }}
                                                                            id={
                                                                              idx +
                                                                              "_" +
                                                                              item.cartcharacteristicscorticosteroidreasonid
                                                                            }
                                                                            name={
                                                                              "q43_2E_Reason_otherneurologic_Txt_13_" +
                                                                              idx +
                                                                              "_" +
                                                                              item.cartcharacteristicscorticosteroidreasonid
                                                                            }
                                                                            type="text"
                                                                            value={
                                                                              data.q43_2E_Reason_otherneurologic_Txt ??
                                                                              ""
                                                                            }
                                                                            onChange={
                                                                              HandleRepeaterFieldChange
                                                                            }
                                                                            maxLength={
                                                                              300
                                                                            }
                                                                            className="option-fbox"
                                                                          />
                                                                        </span>
                                                                      ) : (
                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            item.name
                                                                          }
                                                                        </span>
                                                                      )}
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                              ),
                                                            )}
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_ReasonEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_NeurologicTxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_AEEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_AE
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_NeurologicEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_Neurologic
                                                          }
                                                        />
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredCiltacabtageneCarTCorticosteroidChar &&
                                filteredCiltacabtageneCarTCorticosteroidChar.length >
                                  0 &&
                                showCorticosteroidClickToAddMore_13 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_2_Row(13);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}

                              {filteredIdecabtageneCarTCorticosteroidChar &&
                              filteredIdecabtageneCarTCorticosteroidChar.length >
                                0
                                ? filteredIdecabtageneCarTCorticosteroidChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} ABECMA®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_2_Row(14, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of administration
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Type of corticosteroid{" "}
                                                    <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Dose strength <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Reason for corticosteroid
                                                    usage <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      {idx === 0 && (
                                                        <div className="option-without-input">
                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_2B_No_Corticosteroid_Rcvd_14_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_2B_No_Corticosteroid_Rcvd !==
                                                                  null &&
                                                                data.q43_2B_No_Corticosteroid_Rcvd ===
                                                                  1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              IV corticosteroids
                                                              not received
                                                            </span>
                                                          </label>
                                                        </div>
                                                      )}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_2B_No_Corticosteroid_Rcvd_14_${idx}`}
                                                          value={2}
                                                          checked={
                                                            data.q43_2B_No_Corticosteroid_Rcvd !==
                                                              null &&
                                                            data.q43_2B_No_Corticosteroid_Rcvd ===
                                                              2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={`q43_2B_Corticosteroid_Date_14-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_2B_Corticosteroid_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    <div className="option-without-input">
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_2B_No_Corticosteroid_Rcvd_14_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.q43_2B_No_Corticosteroid_Rcvd !==
                                                              null &&
                                                            data.q43_2B_No_Corticosteroid_Rcvd ===
                                                              99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Date of administration
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.q43_2B_No_Corticosteroid_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_2B_Corticosteroid_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_2_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_2_Corticosteroid_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_2_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_2_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Betamethasone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="option-without-input">
                                                            <label
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />

                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Dexamethasone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                IV
                                                                hydrocortisone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div className="option-without-input">
                                                            <label
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={4}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  4
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Methylprednisolone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={5}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  5
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Prednisone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={6}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  6
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Prednisolone
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label>
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                                value={7}
                                                                checked={
                                                                  data.q43_2C_CorticosteroidType ===
                                                                  7
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "15px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Triamcinolone
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "11px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                              value={8}
                                                              checked={
                                                                data.q43_2C_CorticosteroidType ===
                                                                8
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "5px",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                  paddingTop:
                                                                    "4px",
                                                                }}
                                                              >
                                                                Other
                                                              </span>
                                                            </div>
                                                          </label>

                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "11px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2C_CorticosteroidType_14_${idx}`}
                                                              value={9}
                                                              checked={
                                                                data.q43_2C_CorticosteroidType ===
                                                                9
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "5px",
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                  paddingTop:
                                                                    "4px",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2C_CorticosteroidType_Empty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_14_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_14_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span className="radio-text-padding d-flex">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_mg_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_mg
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} mg
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_14_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_14_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span className="radio-text-padding d-flex">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_kg_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_kg
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} mg/kg
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_2D_DoseStrength_14_${idx}`}
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <input
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_2D_DoseStrength_14_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_2D_DoseStrength ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />

                                                              <span className="radio-text-padding d-flex flex-wrap">
                                                                <div>
                                                                  Other, please
                                                                  specify:{" "}
                                                                  {""}{" "}
                                                                </div>
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_2D_DoseStrength_other_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_2D_DoseStrength_other
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                              </span>
                                                            </label>

                                                            <br />
                                                          </div>
                                                          <label className="d-flex align-items-start mt-2">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_2D_DoseStrength_14_${idx}`}
                                                              value={99}
                                                              checked={
                                                                data.q43_2D_DoseStrength ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              htmlFor={`q43_2D_DoseStrength_14_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrength_Empty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrength_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_txt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrengthMGRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_RangeMGtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2D_DoseStrengthKGRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2D_RangeKGtxt
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    {[2, 99].includes(
                                                      data.q43_2B_No_Corticosteroid_Rcvd,
                                                    ) && (
                                                      <>
                                                        <div className="">
                                                          {data.q43_2E_reasonCorticosteroid &&
                                                            data
                                                              .q43_2E_reasonCorticosteroid
                                                              .length > 0 &&
                                                            data.q43_2E_reasonCorticosteroid.map(
                                                              (item, index) => (
                                                                <div
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    key={
                                                                      item.cartcharacteristicscorticosteroidreasonid
                                                                    }
                                                                    style={{
                                                                      marginLeft:
                                                                        [
                                                                          1, 2,
                                                                          3, 21,
                                                                          22,
                                                                        ].includes(
                                                                          item.cartcharacteristicscorticosteroidreasonid,
                                                                        )
                                                                          ? "0px"
                                                                          : [
                                                                                7,
                                                                                8,
                                                                                9,
                                                                                10,
                                                                                11,
                                                                                12,
                                                                                13,
                                                                              ].includes(
                                                                                item.cartcharacteristicscorticosteroidreasonid,
                                                                              )
                                                                            ? "80px"
                                                                            : "30px",
                                                                    }}
                                                                  >
                                                                    <label
                                                                      className={
                                                                        "long-text-option radio-text-padding"
                                                                      }
                                                                      style={{
                                                                        textAlign:
                                                                          "left",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type={
                                                                          item.name ===
                                                                            "Unknown" ||
                                                                          item.name ===
                                                                            "Unknown type of AE"
                                                                            ? "radio"
                                                                            : "checkbox"
                                                                        }
                                                                        id={
                                                                          idx +
                                                                          "_" +
                                                                          item.cartcharacteristicscorticosteroidreasonid
                                                                        }
                                                                        name={
                                                                          "q43_2E_reasonCorticosteroid_14_" +
                                                                          idx +
                                                                          "_" +
                                                                          item.cartcharacteristicscorticosteroidreasonid
                                                                        }
                                                                        checked={
                                                                          data.q43_2E_selectedReasonCorticosteroid &&
                                                                          data
                                                                            .q43_2E_selectedReasonCorticosteroid
                                                                            .length >
                                                                            0 &&
                                                                          data.q43_2E_selectedReasonCorticosteroid?.some(
                                                                            (
                                                                              a,
                                                                            ) =>
                                                                              a.cartcharacteristicscorticosteroidreasonid ===
                                                                              item.cartcharacteristicscorticosteroidreasonid,
                                                                          )
                                                                        }
                                                                        onChange={
                                                                          HandleRepeaterFieldChange
                                                                        }
                                                                      />
                                                                      {item.name ===
                                                                      "Other neurologic event, please specify: " ? (
                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            item.name
                                                                          }{" "}
                                                                          <textarea
                                                                            style={{
                                                                              width:
                                                                                "264px",
                                                                            }}
                                                                            id={
                                                                              idx +
                                                                              "_" +
                                                                              item.cartcharacteristicscorticosteroidreasonid
                                                                            }
                                                                            name={
                                                                              "q43_2E_Reason_otherneurologic_Txt_14_" +
                                                                              idx +
                                                                              "_" +
                                                                              item.cartcharacteristicscorticosteroidreasonid
                                                                            }
                                                                            type="text"
                                                                            value={
                                                                              data.q43_2E_Reason_otherneurologic_Txt ??
                                                                              ""
                                                                            }
                                                                            onChange={
                                                                              HandleRepeaterFieldChange
                                                                            }
                                                                            maxLength={
                                                                              300
                                                                            }
                                                                            className="option-fbox"
                                                                          />
                                                                        </span>
                                                                      ) : (
                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            item.name
                                                                          }
                                                                        </span>
                                                                      )}
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                              ),
                                                            )}
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_ReasonEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_NeurologicTxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_AEEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_AE
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_2E_Reason_NeurologicEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_2E_Reason_Neurologic
                                                          }
                                                        />
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredIdecabtageneCarTCorticosteroidChar &&
                                filteredIdecabtageneCarTCorticosteroidChar.length >
                                  0 &&
                                showCorticosteroidClickToAddMore_14 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_2_Row(14);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* Question 43.3.A */}
                          <div
                            className="sub-question"
                            style={{ padding: "0px" }}
                          >
                            <div
                              className="table-page"
                              style={{ paddingTop: "15px" }}
                            >
                              <div className="question question-weight">
                                <span style={{ fontWeight: "500" }}>
                                  Q43.3.A
                                </span>
                                <span
                                  className="quest-text-pad"
                                  style={{ fontWeight: "500" }}
                                >
                                  Provide information on{" "}
                                  <i>
                                    additional mitigation strategies for
                                    neurologic events (other than tocilizumab or
                                    corticosteroids collected above)
                                  </i>{" "}
                                  for the CAR-T line of therapy with{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[0]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from aphresis{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[0]?.cohortTreatmentID,
                                        )?.q41_Apheresis_Date ||
                                          "Date of Apheresis"}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[0]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>{" "}
                                      (i.e., from aphresis{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[1]?.cohortTreatmentID,
                                        )?.q41_Apheresis_Date ||
                                          "Date of Apheresis"}
                                        ]
                                      </span>{" "}
                                      until{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {display43_1_EndOfDates(
                                          filteredList[1]?.cohortTreatmentID,
                                        )}
                                        ]
                                      </span>
                                      )
                                    </>
                                  )}
                                  . <br />
                                  <b>Note</b> - please ensure each row
                                  corresponds to a unique AE and to clarify the
                                  medication name and intention of use when
                                  describing the mitigation strategy. Add
                                  additional rows, as needed
                                </span>
                              </div>

                              {/* Ciltacabtagene autoleucel */}
                              {filteredCiltacabtageneCarTMitigationChar &&
                              filteredCiltacabtageneCarTMitigationChar.length >
                                0
                                ? filteredCiltacabtageneCarTMitigationChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} CARVYKTI®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_3_Row(13, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Neurologic Event <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Mitigation Strategy
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div className="customNoContent">
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Peripheral
                                                              neuropathy
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div className="option-without-input">
                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={2}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Immune effector
                                                              cell-associated
                                                              neurotoxicity
                                                              syndrome (ICANS)
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={3}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Fever
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={4}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Delayed
                                                              neurotoxicity
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={5}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Guillain-Barre
                                                              Syndrome
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={6}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                6
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Parkinsonism
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_13_${idx}`}
                                                              value={7}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                7
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Cranial nerve
                                                              palsy
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <label
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "11px",
                                                            }}
                                                            id={`${idx}`}
                                                            name={`q43_3B_NeurologicType_13_${idx}`}
                                                            value={8}
                                                            checked={
                                                              data.q43_3B_NeurologicType ===
                                                              8
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <div
                                                            style={{
                                                              marginLeft: "5px",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                marginLeft:
                                                                  "-5px",
                                                                paddingTop:
                                                                  "4px",
                                                              }}
                                                            >
                                                              Other neurologic
                                                              event, specify
                                                              &nbsp;
                                                              <textarea
                                                                style={{
                                                                  width:
                                                                    "264px",
                                                                  marginTop:
                                                                    "4px",
                                                                  display:
                                                                    "flex",
                                                                }}
                                                                // className="input-dashdash"
                                                                id={`${idx}`}
                                                                name={`q43_3B_NeurologicType_Txt_13_${idx}`}
                                                                type="text"
                                                                value={
                                                                  data.q43_3B_NeurologicType_Txt ||
                                                                  ""
                                                                }
                                                                maxLength={300}
                                                                max={100}
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </span>
                                                          </div>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q43_3B_NeurologicTypeEmpty
                                                        }
                                                        message={
                                                          CarTCharMsgs.q43_Radio_Empty
                                                        }
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.q43_3B_NeurologicType_TxtEmpty
                                                        }
                                                        message={
                                                          "Please enter text for Other option."
                                                        }
                                                      />
                                                    </div>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div className="customNoContent">
                                                      <div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                          }}
                                                        >
                                                          <textarea
                                                            style={{
                                                              width: "300px",
                                                              marginTop: "4px",
                                                              display: "flex",
                                                              maxWidth: "100%",
                                                              height: "104px",
                                                            }}
                                                            // className="input-dashdash"
                                                            id={`${idx}`}
                                                            name={`q43_3C_Mitigation_Txt_13_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.q43_3C_Mitigation_Txt ||
                                                              ""
                                                            }
                                                            maxLength={300}
                                                            max={100}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q43_3C_Mitigation_TxtEmpty
                                                        }
                                                        message={
                                                          "Please enter text for Mitigation Strategy."
                                                        }
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredCiltacabtageneCarTMitigationChar &&
                                filteredCiltacabtageneCarTMitigationChar.length >
                                  0 &&
                                showMitigationClickToAddMore_13 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_3_Row(13);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}

                              {filteredIdecabtageneCarTMitigationChar &&
                              filteredIdecabtageneCarTMitigationChar.length > 0
                                ? filteredIdecabtageneCarTMitigationChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} ABECMA®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_3_Row(14, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            {/* Idecabtagene vicleucel */}
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Neurologic event
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "33%",
                                                    }}
                                                  >
                                                    Mitigation strategy <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div className="customNoContent">
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Peripheral
                                                              neuropathy
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div className="option-without-input">
                                                          <label
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={2}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Immune effector
                                                              cell-associated
                                                              neurotoxicity
                                                              syndrome (ICANS)
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={3}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Fever
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={4}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Delayed
                                                              neurotoxicity
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={5}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Guillain-Barre
                                                              Syndrome
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={6}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                6
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Parkinsonism
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label>
                                                            <input
                                                              type="radio"
                                                              id={`${idx}`}
                                                              name={`q43_3B_NeurologicType_14_${idx}`}
                                                              value={7}
                                                              checked={
                                                                data.q43_3B_NeurologicType ===
                                                                7
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "15px",
                                                                marginLeft:
                                                                  "-5px",
                                                              }}
                                                            >
                                                              Cranial nerve
                                                              palsy
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "11px",
                                                            }}
                                                            id={`${idx}`}
                                                            name={`q43_3B_NeurologicType_14_${idx}`}
                                                            value={8}
                                                            checked={
                                                              data.q43_3B_NeurologicType ===
                                                              8
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <label
                                                            style={{
                                                              marginLeft: "5px",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                marginLeft:
                                                                  "-5px",
                                                                paddingTop:
                                                                  "4px",
                                                              }}
                                                            >
                                                              Other neurologic
                                                              event, specify
                                                              &nbsp;
                                                              <textarea
                                                                style={{
                                                                  width:
                                                                    "264px",
                                                                  marginTop:
                                                                    "4px",
                                                                  display:
                                                                    "flex",
                                                                }}
                                                                // className="input-dashdash"
                                                                id={`${idx}`}
                                                                name={`q43_3B_NeurologicType_Txt_14_${idx}`}
                                                                type="text"
                                                                value={
                                                                  data.q43_3B_NeurologicType_Txt ||
                                                                  ""
                                                                }
                                                                maxLength={300}
                                                                max={100}
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q43_3B_NeurologicTypeEmpty
                                                        }
                                                        message={
                                                          CarTCharMsgs.q43_Radio_Empty
                                                        }
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.q43_3B_NeurologicType_TxtEmpty
                                                        }
                                                        message={
                                                          "Please enter text for Other option."
                                                        }
                                                      />
                                                    </div>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div className="customNoContent">
                                                      <div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                          }}
                                                        >
                                                          <textarea
                                                            style={{
                                                              width: "300px",
                                                              marginTop: "4px",
                                                              display: "flex",
                                                              maxWidth: "100%",
                                                              height: "104px",
                                                            }}
                                                            // className="input-dashdash"
                                                            id={`${idx}`}
                                                            name={`q43_3C_Mitigation_Txt_14_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.q43_3C_Mitigation_Txt ||
                                                              ""
                                                            }
                                                            maxLength={300}
                                                            max={100}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q43_3C_Mitigation_TxtEmpty
                                                        }
                                                        message={
                                                          "Please enter text for Mitigation Strategy."
                                                        }
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredIdecabtageneCarTMitigationChar &&
                                filteredIdecabtageneCarTMitigationChar.length >
                                  0 &&
                                showMitigationClickToAddMore_14 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_3_Row(14);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* Question 43.4.A */}
                          <div
                            className="sub-question"
                            style={{ padding: "0px" }}
                          >
                            <div
                              className="table-page"
                              style={{ paddingTop: "15px" }}
                            >
                              <div className="question question-weight">
                                <span style={{ fontWeight: "500" }}>
                                  Q43.4.A
                                </span>
                                <span
                                  className="quest-text-pad"
                                  style={{ fontWeight: "500" }}
                                >
                                  Please provide{" "}
                                  <i>absolute lymphocyte count</i> laboratory
                                  assessment results for the following time
                                  periods before and after the CAR-T line of
                                  therapy with{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[0]?.cohortTreatmentName}
                                      </span>{" "}
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and/or </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>{" "}
                                    </>
                                  )}
                                  <br />– The record closest to the index date
                                  on or after apheresis (i.e., closest to{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[0]?.cohortTreatmentID,
                                        )?.cohortIndexDate ||
                                          "Bispecifics/CAR-T index date for Cilta-Cel"}
                                        ]
                                      </span>{" "}
                                      but on or after{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[0]?.cohortTreatmentID,
                                        )?.q41_Apheresis_Date ||
                                          "Date of Apheresis"}
                                        ]
                                      </span>{" "}
                                      for{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {
                                          filteredList[0]?.cohortTreatmentName
                                        }{" "}
                                      </span>
                                      )
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and/or (i.e., closest to </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[1]?.cohortTreatmentID,
                                        )?.cohortIndexDate ||
                                          "Bispecifics/CAR-T index date for Ide-Cel"}
                                        ]
                                      </span>{" "}
                                      but on or after{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[1]?.cohortTreatmentID,
                                        )?.q41_Apheresis_Date ||
                                          "Date of Apheresis"}
                                        ]
                                      </span>{" "}
                                      for
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>
                                      )
                                    </>
                                  )}
                                  <br />– All assessment results within the
                                  first month of CAR-T treatment (i.e., from{" "}
                                  {filteredList[0]?.cohortTreatmentName && (
                                    <>
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[0]?.cohortTreatmentID,
                                        )?.cohortIndexDate ||
                                          "Bispecifics/CAR-T index date for Cilta-Cel"}
                                        ]
                                      </span>{" "}
                                      to{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {(() => {
                                          const dateValue =
                                            carTCharRepeater.find(
                                              (item) =>
                                                item.cohortTreatmentId ===
                                                filteredList[0]
                                                  ?.cohortTreatmentID,
                                            )?.indexAddThirtyDate;

                                          if (!dateValue) return " ";

                                          const d = new Date(dateValue);
                                          d.setDate(d.getDate() - 1);

                                          return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`;
                                        })()}
                                        ]
                                      </span>{" "}
                                      for{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[0]?.cohortTreatmentName}
                                      </span>
                                      )
                                    </>
                                  )}
                                  {filteredList[0]?.cohortTreatmentName &&
                                    filteredList[1]?.cohortTreatmentName && (
                                      <span> and/or </span>
                                    )}
                                  {filteredList[1]?.cohortTreatmentName && (
                                    <>
                                      {" "}
                                      (i.e., from{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {carTCharRepeater.find(
                                          (item) =>
                                            item.cohortTreatmentId ===
                                            filteredList[1]?.cohortTreatmentID,
                                        )?.cohortIndexDate ||
                                          "Bispecifics/CAR-T index date for Ide-Cel"}
                                        ]
                                      </span>{" "}
                                      to{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        [
                                        {(() => {
                                          const dateValue =
                                            carTCharRepeater.find(
                                              (item) =>
                                                item.cohortTreatmentId ===
                                                filteredList[1]
                                                  ?.cohortTreatmentID,
                                            )?.indexAddThirtyDate;

                                          if (!dateValue) return " ";

                                          const d = new Date(dateValue);
                                          d.setDate(d.getDate() - 1);

                                          return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`;
                                        })()}
                                        ]
                                      </span>{" "}
                                      for{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {filteredList[1]?.cohortTreatmentName}
                                      </span>
                                      )
                                    </>
                                  )}
                                </span>
                              </div>

                              {/* Ciltacabtagene autoleucel */}
                              {filteredCiltacabtageneCarTLymphocyteChar &&
                              filteredCiltacabtageneCarTLymphocyteChar.length >
                                0
                                ? filteredCiltacabtageneCarTLymphocyteChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} CARVYKTI®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_4_Row(13, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of Assessment
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Measurement <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_4B_No_Assessment_Rcvd_13_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.q43_4B_No_Assessment_Rcvd !==
                                                              null &&
                                                            data.q43_4B_No_Assessment_Rcvd ===
                                                              1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={`q43_4B_Assessment_Date_13-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_4B_Assessment_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {idx === 0 && (
                                                      <div className="option-without-input">
                                                        <label
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43_4B_No_Assessment_Rcvd_13_${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.q43_4B_No_Assessment_Rcvd !==
                                                                null &&
                                                              data.q43_4B_No_Assessment_Rcvd ===
                                                                2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Not assessed or
                                                            recorded during
                                                            these time periods
                                                          </span>
                                                        </label>
                                                      </div>
                                                    )}
                                                    <ErrorField
                                                      show={
                                                        data.q43_4B_No_Assessment_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_4B_Assessment_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_4_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_4_Assessment_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_4_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_4_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {[1].includes(
                                                      data.q43_4B_No_Assessment_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_13_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_13_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_ul_13_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_ul_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_ul
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells/µL
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_13_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_13_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_mm_13_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_mm_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_mm
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells/mm
                                                                <sup>3</sup>
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_13_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_13_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_xl_13_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_xl_13_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_xl
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells x 10
                                                                <sup>9</sup>/L
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <label className="d-flex align-items-start mt-2">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_4C_MeasurementValue_13_${idx}`}
                                                              value={99}
                                                              checked={
                                                                data.q43_4C_MeasurementValue ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              htmlFor={`q43_4C_MeasurementValue_13_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_MeasurementEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_txt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_xlRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeXLtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_mmRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeMMtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_ulRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeULtxt
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredCiltacabtageneCarTLymphocyteChar &&
                                filteredCiltacabtageneCarTLymphocyteChar.length >
                                  0 &&
                                showLymphocyteClickToAddMore_13 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_4_Row(13);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}

                              {filteredIdecabtageneCarTLymphocyteChar &&
                              filteredIdecabtageneCarTLymphocyteChar.length > 0
                                ? filteredIdecabtageneCarTLymphocyteChar.map(
                                    (data, idx) => (
                                      <div className="loop-section-ul">
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} ABECMA®
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDeleteQ43_4_Row(14, idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <div className="question-bot-sapce">
                                          <div className="sub-question">
                                            {/* Idecabtagene vicleucel */}
                                            <table border="1">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of Assessment
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Measurement <br />
                                                    <span
                                                      style={{
                                                        color:
                                                          PageDesignConstants.fontColor,
                                                      }}
                                                    ></span>
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody key={idx}>
                                                <tr>
                                                  <td rowSpan={2}>
                                                    {data.treatmentName}
                                                  </td>
                                                  <td
                                                    className="customNoContent"
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`${idx}`}
                                                          name={`q43_4B_No_Assessment_Rcvd_14_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.q43_4B_No_Assessment_Rcvd !==
                                                              null &&
                                                            data.q43_4B_No_Assessment_Rcvd ===
                                                              1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={`q43_4B_Assessment_Date_14-${idx}`}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                            date={
                                                              data.q43_4B_Assessment_Date
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {idx === 0 && (
                                                      <div className="option-without-input">
                                                        <label
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`${idx}`}
                                                            name={`q43_4B_No_Assessment_Rcvd_14_${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.q43_4B_No_Assessment_Rcvd !==
                                                                null &&
                                                              data.q43_4B_No_Assessment_Rcvd ===
                                                                2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Not assessed or
                                                            recorded during
                                                            these time periods
                                                          </span>
                                                        </label>
                                                      </div>
                                                    )}
                                                    <ErrorField
                                                      show={
                                                        data.q43_4B_No_Assessment_RcvdEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.carTEmpty_Msg
                                                      }
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q43_4B_Assessment_DateEmpty
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_4_Date_Empty
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_4_Assessment_InvalidDate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q43_4_Date_Valid
                                                      }
                                                      message={
                                                        CarTCharMsgs.q43_4_Date_Not_Valid
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {[1].includes(
                                                      data.q43_4B_No_Assessment_Rcvd,
                                                    ) && (
                                                      <div className="customNoContent">
                                                        <div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_14_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_14_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_ul_14_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_ul_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_ul
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells/µL
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_14_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_14_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_mm_14_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_mm_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_mm
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells/mm
                                                                <sup>3 </sup>
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <div className="">
                                                            <label
                                                              htmlFor={`q43_4C_MeasurementValue_14_${idx}`}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`${idx}`}
                                                                name={`q43_4C_MeasurementValue_14_${idx}`}
                                                                value={3}
                                                                checked={
                                                                  data.q43_4C_MeasurementValue ===
                                                                  3
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                            </label>
                                                            <label
                                                              htmlFor={`q43_4C_Measurement_xl_14_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                <input
                                                                  ref={inputRef}
                                                                  className="input-dash-custom input-dash"
                                                                  id={`${idx}`}
                                                                  name={`q43_4C_Measurement_xl_14_${idx}`}
                                                                  type="text"
                                                                  pattern="\d*"
                                                                  value={
                                                                    data.q43_4C_Measurement_xl
                                                                  }
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      [
                                                                        "Backspace",
                                                                        "ArrowLeft",
                                                                        "ArrowRight",
                                                                        "Delete",
                                                                        "Tab",
                                                                      ].includes(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/[0-9.]/.test(
                                                                        e.key,
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    const selectionStart =
                                                                      e.target
                                                                        .selectionStart;
                                                                    const newValue =
                                                                      value.slice(
                                                                        0,
                                                                        selectionStart,
                                                                      ) +
                                                                      e.key +
                                                                      value.slice(
                                                                        e.target
                                                                          .selectionEnd,
                                                                      );
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value.includes(
                                                                        ".",
                                                                      )
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      e.key ===
                                                                        "." &&
                                                                      value ===
                                                                        ""
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                    if (
                                                                      newValue.includes(
                                                                        ".",
                                                                      ) &&
                                                                      newValue.split(
                                                                        ".",
                                                                      )[1]
                                                                        .length >
                                                                        2
                                                                    ) {
                                                                      e.preventDefault();
                                                                      return;
                                                                    }
                                                                  }}
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                {""} cells x 10
                                                                <sup>9</sup>/L
                                                              </span>
                                                            </label>
                                                            <br />
                                                          </div>
                                                          <label className="d-flex align-items-start mt-2">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={`${idx}`}
                                                              name={`q43_4C_MeasurementValue_14_${idx}`}
                                                              value={99}
                                                              checked={
                                                                data.q43_4C_MeasurementValue ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <div
                                                              htmlFor={`q43_4C_MeasurementValue_14_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Unknown
                                                              </span>
                                                            </div>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_MeasurementEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_Radio_Empty
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_TxtEmpty
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_txt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_xlRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeXLtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_mmRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeMMtxt
                                                          }
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.q43_4C_Measurement_ulRange
                                                          }
                                                          message={
                                                            CarTCharMsgs.q43_4C_RangeULtxt
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                : null}

                              {filteredIdecabtageneCarTLymphocyteChar &&
                                filteredIdecabtageneCarTLymphocyteChar.length >
                                  0 &&
                                showLymphocyteClickToAddMore_14 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={() => {
                                        AddQ43_4_Row(14);
                                      }}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another assessment
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CarTCharacteristics;
